/* jshint maxerr: 10000 */

/* jslint unused: true */

/* jshint shadow: true */

/* jshint -W075 */
var emojione = {};
emojione.emojioneList = {
  ':homes:': {
    'tn': 'Häuser',
    'uc': '1f3d8',
    'c': 'travel',
    'o': 2514,
    'sn': ':homes:'
  },
  ':white_sun_small_cloud:': {
    'tn': 'Sonne_dreiviertel',
    'uc': '1f324',
    'c': 'nature',
    'o': 978,
    'sn': ':white_sun_small_cloud:'
  },
  ':libra:': {
    'tn': 'Waage_Zeichen',
    'uc': '264e',
    'c': 'symbols',
    'o': 36,
    'sn': ':libra:'
  },
  ':poultry_leg:': {
    'tn': 'Hühnchenschenkel',
    'uc': '1f357',
    'c': 'food',
    'o': 1036,
    'sn': ':poultry_leg:'
  },
  ':lips:': {
    'tn': 'Lippen',
    'uc': '1f444',
    'c': 'people',
    'o': 1410,
    'sn': ':lips:'
  },
  ':poop:': {
    'tn': 'Scheißhaufen',
    'uc': '1f4a9',
    'c': 'people',
    'o': 1197,
    'sn': ':poop:'
  },
  ':revolving_hearts:': {
    'tn': 'Herz_drehend',
    'uc': '1f49e',
    'c': 'symbols',
    'o': 11,
    'sn': ':revolving_hearts:'
  },
  ':beach_umbrella:': {
    'tn': 'Sonnenschirm',
    'uc': '26f1',
    'c': 'travel',
    'o': 2502,
    'sn': ':beach_umbrella:'
  },
  ':mailbox:': {
    'tn': 'Briefkasten2',
    'uc': '1f4eb',
    'c': 'objects',
    'o': 764,
    'sn': ':mailbox:'
  },
  ':cancer:': {
    'tn': 'Krebs_Zeichen',
    'uc': '264b',
    'c': 'symbols',
    'o': 33,
    'sn': ':cancer:'
  },
  ':man_walking:': {
    'tn': 'Mann_geht',
    'uc': '1f6b6-2642',
    'c': 'people',
    'o': 2306,
    'sn': ':man_walking:'
  },
  ':two_women_holding_hands:': {
    'tn': 'Frauen Händchenhalten',
    'uc': '1f46d',
    'c': 'people',
    'o': 2331,
    'sn': ':two_women_holding_hands:'
  },
  ':heart_exclamation:': {
    'tn': 'Herz_Ausrufezeichen',
    'uc': '2763',
    'c': 'symbols',
    'o': 9,
    'sn': ':heart_exclamation:'
  },
  ':label:': {
    'tn': 'Label',
    'uc': '1f3f7',
    'c': 'objects',
    'o': 762,
    'sn': ':label:'
  },
  ':flag_st:': {
    'tn': 'Fl_SaoTome',
    'uc': '1f1f8-1f1f9',
    'c': 'flags',
    'o': 2748,
    'sn': ':flag_st:'
  },
  ':dizzy:': {
    'tn': 'schwindelig',
    'uc': '1f4ab',
    'c': 'nature',
    'o': 967,
    'sn': ':dizzy:'
  },
  ':sweat:': {
    'tn': 'schwitzen',
    'uc': '1f613',
    'c': 'people',
    'o': 1162,
    'sn': ':sweat:'
  },
  ':flag_rs:': {
    'tn': 'Fl_Slowenien',
    'uc': '1f1f7-1f1f8',
    'c': 'flags',
    'o': 2751,
    'sn': ':flag_rs:'
  },
  ':tired_face:': {
    'tn': 'müde',
    'uc': '1f62b',
    'c': 'people',
    'o': 1145,
    'sn': ':tired_face:'
  },
  ':traffic_light:': {
    'tn': 'Ampel horizontal',
    'uc': '1f6a5',
    'c': 'travel',
    'o': 2489,
    'sn': ':traffic_light:'
  },
  ':pregnant_woman:': {
    'tn': 'Frau_schwanger',
    'uc': '1f930',
    'c': 'people',
    'o': 2033,
    'sn': ':pregnant_woman:'
  },
  ':man_playing_water_polo:': {
    'tn': 'Mann_Wasserpolo',
    'uc': '1f93d-2642',
    'c': 'activity',
    'o': 492,
    'sn': ':man_playing_water_polo:'
  },
  ':relieved:': {
    'tn': 'erleichtert',
    'uc': '1f60c',
    'c': 'people',
    'o': 1117,
    'sn': ':relieved:'
  },
  ':kangaroo:': {
    'tn': 'Känguru',
    'uc': '1f998',
    'c': 'nature',
    'o': 830,
    'sn': ':kangaroo:'
  },
  ':giraffe:': {
    'tn': 'Giraffe',
    'uc': '1f992',
    'c': 'nature',
    'o': 901,
    'sn': ':giraffe:'
  },
  ':rhino:': {
    'tn': 'Nashorn',
    'uc': '1f98f',
    'c': 'nature',
    'o': 897,
    'sn': ':rhino:'
  },
  ':two_hearts:': {
    'tn': 'Herz_zwei',
    'uc': '1f495',
    'c': 'symbols',
    'o': 10,
    'sn': ':two_hearts:'
  },
  ':merman:': {
    'tn': 'Meermann',
    'uc': '1f9dc-2642',
    'c': 'people',
    'o': 2003,
    'sn': ':merman:'
  },
  ':flag_no:': {
    'tn': 'Fl_Norwegen',
    'uc': '1f1f3-1f1f4',
    'c': 'flags',
    'o': 2727,
    'sn': ':flag_no:'
  },
  ':scotland:': {
    'tn': 'Fl_Schottland',
    'uc': '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f',
    'c': 'flags',
    'o': 2798,
    'sn': ':scotland:'
  },
  ':flag_mn:': {
    'tn': 'Fl_Mongolei',
    'uc': '1f1f2-1f1f3',
    'c': 'flags',
    'o': 2708,
    'sn': ':flag_mn:'
  },
  ':black_square_button:': {
    'tn': 'Quader_Knopf2',
    'uc': '1f532',
    'c': 'symbols',
    'o': 223,
    'sn': ':black_square_button:'
  },
  ':clock130:': {
    'tn': '01:30 Uhr',
    'uc': '1f55c',
    'c': 'symbols',
    'o': 264,
    'sn': ':clock130:'
  },
  ':fork_and_knife:': {
    'tn': 'Messer_Gabel',
    'uc': '1f374',
    'c': 'food',
    'o': 1098,
    'sn': ':fork_and_knife:'
  },
  ':hotel:': {
    'tn': 'Hotel',
    'uc': '1f3e8',
    'c': 'travel',
    'o': 2524,
    'sn': ':hotel:'
  },
  ':man_bouncing_ball:': {
    'tn': 'Mann_dribbelt',
    'uc': '26f9-2642',
    'c': 'activity',
    'o': 377,
    'sn': ':man_bouncing_ball:'
  },
  ':digit_one:': {
    'tn': 'Ziffer eins',
    'uc': '0031',
    'c': 'symbols',
    'o': 277,
    'sn': ':digit_one:'
  },
  ':arrow_down_small:': {
    'tn': 'Pfeil_unten',
    'uc': '1f53d',
    'c': 'symbols',
    'o': 170,
    'sn': ':arrow_down_small:'
  },
  ':joy:': {
    'tn': 'Freude',
    'uc': '1f602',
    'c': 'people',
    'o': 1109,
    'sn': ':joy:'
  },
  ':flag_gh:': {
    'tn': 'Fl_Ghana',
    'uc': '1f1ec-1f1ed',
    'c': 'flags',
    'o': 2646,
    'sn': ':flag_gh:'
  },
  ':bikini:': {
    'tn': 'Bikini',
    'uc': '1f459',
    'c': 'people',
    'o': 2373,
    'sn': ':bikini:'
  },
  ':flag_de:': {
    'tn': 'Fl_Deutschland',
    'uc': '1f1e9-1f1ea',
    'c': 'flags',
    'o': 2645,
    'sn': ':flag_de:'
  },
  ':cricket_game:': {
    'tn': 'Cricket',
    'uc': '1f3cf',
    'c': 'activity',
    'o': 305,
    'sn': ':cricket_game:'
  },
  ':flag_cd:': {
    'tn': 'Fl_Kinshasa',
    'uc': '1f1e8-1f1e9',
    'c': 'flags',
    'o': 2613,
    'sn': ':flag_cd:'
  },
  ':new_moon:': {
    'tn': 'Mond_neu',
    'uc': '1f311',
    'c': 'nature',
    'o': 959,
    'sn': ':new_moon:'
  },
  ':dromedary_camel:': {
    'tn': 'Dromedar',
    'uc': '1f42a',
    'c': 'nature',
    'o': 899,
    'sn': ':dromedary_camel:'
  },
  ':couple:': {
    'tn': 'Pärchen',
    'uc': '1f46b',
    'c': 'people',
    'o': 2330,
    'sn': ':couple:'
  },
  ':woman_astronaut:': {
    'tn': 'Astronautin',
    'uc': '1f469-1f680',
    'c': 'people',
    'o': 1835,
    'sn': ':woman_astronaut:'
  },
  ':family_woman_girl:': {
    'tn': 'Single_Frau_F',
    'uc': '1f469-1f467',
    'c': 'people',
    'o': 2358,
    'sn': ':family_woman_girl:'
  },
  ':bug:': {
    'tn': 'Raupe',
    'uc': '1f41b',
    'c': 'nature',
    'o': 862,
    'sn': ':bug:'
  },
  ':hole:': {
    'tn': 'Loch',
    'uc': '1f573',
    'c': 'objects',
    'o': 706,
    'sn': ':hole:'
  },
  ':woman_farmer:': {
    'tn': 'Bäuerin',
    'uc': '1f469-1f33e',
    'c': 'people',
    'o': 1679,
    'sn': ':woman_farmer:'
  },
  ':wedding:': {
    'tn': 'Hochzeit_Kirche',
    'uc': '1f492',
    'c': 'travel',
    'o': 2528,
    'sn': ':wedding:'
  },
  ':station:': {
    'tn': 'Station',
    'uc': '1f689',
    'c': 'travel',
    'o': 2467,
    'sn': ':station:'
  },
  ':last_quarter_moon_with_face:': {
    'tn': 'Mond_viertel_Gesicht2',
    'uc': '1f31c',
    'c': 'nature',
    'o': 953,
    'sn': ':last_quarter_moon_with_face:'
  },
  ':middle_finger:': {
    'tn': 'Mittelfinger',
    'uc': '1f595',
    'c': 'people',
    'o': 1389,
    'sn': ':middle_finger:'
  },
  ':family_man_girl_girl:': {
    'tn': 'Single_Mann_FF',
    'uc': '1f468-1f467-1f467',
    'c': 'people',
    'o': 2366,
    'sn': ':family_man_girl_girl:'
  },
  ':man_wearing_turban:': {
    'tn': 'Mann_Turban',
    'uc': '1f473-2642',
    'c': 'people',
    'o': 1583,
    'sn': ':man_wearing_turban:'
  },
  ':earth_asia:': {
    'tn': 'Erde_Asien',
    'uc': '1f30f',
    'c': 'nature',
    'o': 966,
    'sn': ':earth_asia:'
  },
  ':thumbsdown:': {
    'tn': 'Daumen_runter',
    'uc': '1f44e',
    'c': 'people',
    'o': 1245,
    'sn': ':thumbsdown:'
  },
  ':lemon:': {
    'tn': 'Zitrone',
    'uc': '1f34b',
    'c': 'food',
    'o': 1002,
    'sn': ':lemon:'
  },
  ':e-mail:': {
    'tn': 'Email',
    'uc': '1f4e7',
    'c': 'objects',
    'o': 757,
    'sn': ':e-mail:'
  },
  ':mag:': {
    'tn': 'Lupe1',
    'uc': '1f50d',
    'c': 'objects',
    'o': 817,
    'sn': ':mag:'
  },
  ':six_pointed_star:': {
    'tn': 'Hexagramm',
    'uc': '1f52f',
    'c': 'symbols',
    'o': 24,
    'sn': ':six_pointed_star:'
  },
  ':flag_tt:': {
    'tn': 'Fl_TrinidadTobago',
    'uc': '1f1f9-1f1f9',
    'c': 'flags',
    'o': 2786,
    'sn': ':flag_tt:'
  },
  ':dart:': {
    'tn': 'Dart',
    'uc': '1f3af',
    'c': 'activity',
    'o': 612,
    'sn': ':dart:'
  },
  ':melon:': {
    'tn': 'Honigmelone',
    'uc': '1f348',
    'c': 'food',
    'o': 1007,
    'sn': ':melon:'
  },
  ':small_red_triangle_down:': {
    'tn': 'Dreieck_rot2',
    'uc': '1f53b',
    'c': 'symbols',
    'o': 217,
    'sn': ':small_red_triangle_down:'
  },
  ':flag_ss:': {
    'tn': 'Fl_SüdSudan',
    'uc': '1f1f8-1f1f8',
    'c': 'flags',
    'o': 2763,
    'sn': ':flag_ss:'
  },
  ':man_scientist:': {
    'tn': 'Wisschenschaftler',
    'uc': '1f468-1f52c',
    'c': 'people',
    'o': 1793,
    'sn': ':man_scientist:'
  },
  ':takeout_box:': {
    'tn': 'Mitnahmebox',
    'uc': '1f961',
    'c': 'food',
    'o': 1101,
    'sn': ':takeout_box:'
  },
  ':black_joker:': {
    'tn': 'Joker',
    'uc': '1f0cf',
    'c': 'symbols',
    'o': 249,
    'sn': ':black_joker:'
  },
  ':running_shirt_with_sash:': {
    'tn': 'Shirt_Bändchen',
    'uc': '1f3bd',
    'c': 'activity',
    'o': 313,
    'sn': ':running_shirt_with_sash:'
  },
  ':flag_mm:': {
    'tn': 'Fl_Myanmar',
    'uc': '1f1f2-1f1f2',
    'c': 'flags',
    'o': 2713,
    'sn': ':flag_mm:'
  },
  ':arrow_double_up:': {
    'tn': 'Pfeil_doppelt_oben',
    'uc': '23eb',
    'c': 'symbols',
    'o': 166,
    'sn': ':arrow_double_up:'
  },
  ':fork_knife_plate:': {
    'tn': 'Messer_Gabel_Teller',
    'uc': '1f37d',
    'c': 'food',
    'o': 1099,
    'sn': ':fork_knife_plate:'
  },
  ':recycle:': {
    'tn': 'Recycle',
    'uc': '267b',
    'c': 'symbols',
    'o': 101,
    'sn': ':recycle:'
  },
  ':love_letter:': {
    'tn': 'Liebesbrief',
    'uc': '1f48c',
    'c': 'objects',
    'o': 758,
    'sn': ':love_letter:'
  },
  ':flag_gg:': {
    'tn': 'Fl_Guernsey',
    'uc': '1f1ec-1f1ec',
    'c': 'flags',
    'o': 2654,
    'sn': ':flag_gg:'
  },
  ':coat:': {
    'tn': 'Mantel',
    'uc': '1f9e5',
    'c': 'people',
    'o': 2367,
    'sn': ':coat:'
  },
  ':flag_ee:': {
    'tn': 'Fl_Estland',
    'uc': '1f1ea-1f1ea',
    'c': 'flags',
    'o': 2631,
    'sn': ':flag_ee:'
  },
  ':man_pilot:': {
    'tn': 'Pilot',
    'uc': '1f468-2708',
    'c': 'people',
    'o': 1829,
    'sn': ':man_pilot:'
  },
  ':flag_cc:': {
    'tn': 'Fl_Kokosinseln',
    'uc': '1f1e8-1f1e8',
    'c': 'flags',
    'o': 2609,
    'sn': ':flag_cc:'
  },
  ':flag_bb:': {
    'tn': 'Fl_Barbados',
    'uc': '1f1e7-1f1e7',
    'c': 'flags',
    'o': 2580,
    'sn': ':flag_bb:'
  },
  ':stuffed_flatbread:': {
    'tn': 'Fladenbrot_gefüllt',
    'uc': '1f959',
    'c': 'food',
    'o': 1043,
    'sn': ':stuffed_flatbread:'
  },
  ':dancer:': {
    'tn': 'Tänzerin',
    'uc': '1f483',
    'c': 'people',
    'o': 2273,
    'sn': ':dancer:'
  },
  ':man_gesturing_no:': {
    'tn': 'Mann_nein',
    'uc': '1f645-2642',
    'c': 'people',
    'o': 2093,
    'sn': ':man_gesturing_no:'
  },
  ':diamonds:': {
    'tn': 'Karo',
    'uc': '2666',
    'c': 'symbols',
    'o': 248,
    'sn': ':diamonds:'
  },
  ':toolbox:': {
    'tn': 'Werkzeugkasten',
    'uc': '1f9f0',
    'c': 'objects',
    'o': 677,
    'sn': ':toolbox:'
  },
  ':u7533:': {
    'tn': 'Anfrage',
    'uc': '1f238',
    'c': 'symbols',
    'o': 52,
    'sn': ':u7533:'
  },
  ':on:': {
    'tn': 'An',
    'uc': '1f51b',
    'c': 'symbols',
    'o': 206,
    'sn': ':on:'
  },
  ':tropical_fish:': {
    'tn': 'Wimpelfisch',
    'uc': '1f420',
    'c': 'nature',
    'o': 885,
    'sn': ':tropical_fish:'
  },
  ':woman_mountain_biking:': {
    'tn': 'Frau_Mountainbiking',
    'uc': '1f6b5-2640',
    'c': 'activity',
    'o': 540,
    'sn': ':woman_mountain_biking:'
  },
  ':confounded:': {
    'tn': 'elend',
    'uc': '1f616',
    'c': 'people',
    'o': 1144,
    'sn': ':confounded:'
  },
  ':butterfly:': {
    'tn': 'Schmetterling',
    'uc': '1f98b',
    'c': 'nature',
    'o': 863,
    'sn': ':butterfly:'
  },
  ':cloud_rain:': {
    'tn': 'Wolke_Regen',
    'uc': '1f327',
    'c': 'nature',
    'o': 983,
    'sn': ':cloud_rain:'
  },
  ':sushi:': {
    'tn': 'Sushi',
    'uc': '1f363',
    'c': 'food',
    'o': 1053,
    'sn': ':sushi:'
  },
  ':oncoming_police_car:': {
    'tn': 'Polizeiwagen von vorne',
    'uc': '1f694',
    'c': 'travel',
    'o': 2449,
    'sn': ':oncoming_police_car:'
  },
  ':flag_vu:': {
    'tn': 'Fl_Vanuatu',
    'uc': '1f1fb-1f1fa',
    'c': 'flags',
    'o': 2803,
    'sn': ':flag_vu:'
  },
  ':carousel_horse:': {
    'tn': 'Karussellpferd',
    'uc': '1f3a0',
    'c': 'travel',
    'o': 2500,
    'sn': ':carousel_horse:'
  },
  ':flag_sr:': {
    'tn': 'Fl_Suriname',
    'uc': '1f1f8-1f1f7',
    'c': 'flags',
    'o': 2773,
    'sn': ':flag_sr:'
  },
  ':railway_car:': {
    'tn': 'Eisenbahnwagen 1',
    'uc': '1f683',
    'c': 'travel',
    'o': 2456,
    'sn': ':railway_car:'
  },
  ':smiling_imp:': {
    'tn': 'Kobold_lachen',
    'uc': '1f608',
    'c': 'people',
    'o': 1192,
    'sn': ':smiling_imp:'
  },
  ':flag_ml:': {
    'tn': 'Fl_Mali',
    'uc': '1f1f2-1f1f1',
    'c': 'flags',
    'o': 2697,
    'sn': ':flag_ml:'
  },
  ':slight_frown:': {
    'tn': 'leicht_traurig',
    'uc': '1f641',
    'c': 'people',
    'o': 1141,
    'sn': ':slight_frown:'
  },
  ':flag_lk:': {
    'tn': 'Fl_SriLanka',
    'uc': '1f1f1-1f1f0',
    'c': 'flags',
    'o': 2765,
    'sn': ':flag_lk:'
  },
  ':koala:': {
    'tn': 'Koala',
    'uc': '1f428',
    'c': 'nature',
    'o': 832,
    'sn': ':koala:'
  },
  ':bar_chart:': {
    'tn': 'Säulendiagramm',
    'uc': '1f4ca',
    'c': 'objects',
    'o': 774,
    'sn': ':bar_chart:'
  },
  ':sleeping_accommodation:': {
    'tn': 'Bett_besetzt',
    'uc': '1f6cc',
    'c': 'objects',
    'o': 734,
    'sn': ':sleeping_accommodation:'
  },
  ':calendar:': {
    'tn': 'Kalender',
    'uc': '1f4c6',
    'c': 'objects',
    'o': 779,
    'sn': ':calendar:'
  },
  ':taxi:': {
    'tn': 'Taxi',
    'uc': '1f695',
    'c': 'travel',
    'o': 2432,
    'sn': ':taxi:'
  },
  ':left_luggage:': {
    'tn': 'Gepäckort',
    'uc': '1f6c5',
    'c': 'symbols',
    'o': 122,
    'sn': ':left_luggage:'
  },
  ':squid:': {
    'tn': 'Tintenfisch',
    'uc': '1f991',
    'c': 'nature',
    'o': 880,
    'sn': ':squid:'
  },
  ':pirate_flag:': {
    'tn': 'Piratenflagge',
    'uc': '1f3f4-2620',
    'c': 'flags',
    'o': 2560,
    'sn': ':pirate_flag:'
  },
  ':sunglasses:': {
    'tn': 'Sonnenbrille',
    'uc': '1f60e',
    'c': 'people',
    'o': 1132,
    'sn': ':sunglasses:'
  },
  ':flag_gf:': {
    'tn': 'Fl_FGuinea',
    'uc': '1f1ec-1f1eb',
    'c': 'flags',
    'o': 2639,
    'sn': ':flag_gf:'
  },
  ':pancakes:': {
    'tn': 'Pfannkuchen',
    'uc': '1f95e',
    'c': 'food',
    'o': 1033,
    'sn': ':pancakes:'
  },
  ':red_envelope:': {
    'tn': 'roter Umschlag',
    'uc': '1f9e7',
    'c': 'objects',
    'o': 753,
    'sn': ':red_envelope:'
  },
  ':man_judge:': {
    'tn': 'Richter',
    'uc': '1f468-2696',
    'c': 'people',
    'o': 1853,
    'sn': ':man_judge:'
  },
  ':woman_juggling:': {
    'tn': 'Jongliererin',
    'uc': '1f939-2640',
    'c': 'activity',
    'o': 587,
    'sn': ':woman_juggling:'
  },
  ':busts_in_silhouette:': {
    'tn': 'Schattenrisse',
    'uc': '1f465',
    'c': 'people',
    'o': 1432,
    'sn': ':busts_in_silhouette:'
  },
  ':trident:': {
    'tn': 'Dreizack',
    'uc': '1f531',
    'c': 'symbols',
    'o': 98,
    'sn': ':trident:'
  },
  ':boar:': {
    'tn': 'Wildschwein',
    'uc': '1f417',
    'c': 'nature',
    'o': 858,
    'sn': ':boar:'
  },
  ':tulip:': {
    'tn': 'Tulpe',
    'uc': '1f337',
    'c': 'nature',
    'o': 943,
    'sn': ':tulip:'
  },
  ':stuck_out_tongue_winking_eye:': {
    'tn': 'Zunge_ein_Zwinker',
    'uc': '1f61c',
    'c': 'people',
    'o': 1127,
    'sn': ':stuck_out_tongue_winking_eye:'
  },
  ':flag_ba:': {
    'tn': 'Fl_Bosnien',
    'uc': '1f1e7-1f1e6',
    'c': 'flags',
    'o': 2588,
    'sn': ':flag_ba:'
  },
  ':oden:': {
    'tn': 'Oden',
    'uc': '1f362',
    'c': 'food',
    'o': 1061,
    'sn': ':oden:'
  },
  ':volcano:': {
    'tn': 'Vulkan',
    'uc': '1f30b',
    'c': 'travel',
    'o': 2506,
    'sn': ':volcano:'
  },
  ':man_rowing_boat:': {
    'tn': 'Ruderer',
    'uc': '1f6a3-2642',
    'c': 'activity',
    'o': 510,
    'sn': ':man_rowing_boat:'
  },
  ':snowflake:': {
    'tn': 'Schneeflocke',
    'uc': '2744',
    'c': 'nature',
    'o': 987,
    'sn': ':snowflake:'
  },
  ':woman_tipping_hand:': {
    'tn': 'Assistentin',
    'uc': '1f481-2640',
    'c': 'people',
    'o': 2069,
    'sn': ':woman_tipping_hand:'
  },
  ':peanuts:': {
    'tn': 'Erdnuss',
    'uc': '1f95c',
    'c': 'food',
    'o': 1081,
    'sn': ':peanuts:'
  },
  ':red_circle:': {
    'tn': 'Kreis_rot',
    'uc': '1f534',
    'c': 'symbols',
    'o': 214,
    'sn': ':red_circle:'
  },
  ':goggles:': {
    'tn': 'Brille',
    'uc': '1f97d',
    'c': 'people',
    'o': 2399,
    'sn': ':goggles:'
  },
  ':couplekiss:': {
    'tn': 'Pärchen_Kuss',
    'uc': '1f48f',
    'c': 'people',
    'o': 2337,
    'sn': ':couplekiss:'
  },
  ':compass:': {
    'tn': 'Kompass',
    'uc': '1f9ed',
    'c': 'objects',
    'o': 656,
    'sn': ':compass:'
  },
  ':dvd:': {
    'tn': 'DVD',
    'uc': '1f4c0',
    'c': 'objects',
    'o': 632,
    'sn': ':dvd:'
  },
  ':mahjong:': {
    'tn': 'Mahjong',
    'uc': '1f004',
    'c': 'symbols',
    'o': 251,
    'sn': ':mahjong:'
  },
  ':calendar_spiral:': {
    'tn': 'Kalender_spiral',
    'uc': '1f5d3',
    'c': 'objects',
    'o': 778,
    'sn': ':calendar_spiral:'
  },
  ':no_bicycles:': {
    'tn': 'keine_Fahrräder',
    'uc': '1f6b3',
    'c': 'symbols',
    'o': 82,
    'sn': ':no_bicycles:'
  },
  ':ok_hand:': {
    'tn': 'ok_Hand',
    'uc': '1f44c',
    'c': 'people',
    'o': 1299,
    'sn': ':ok_hand:'
  },
  ':fishing_pole_and_fish:': {
    'tn': 'Angel_Fisch',
    'uc': '1f3a3',
    'c': 'activity',
    'o': 310,
    'sn': ':fishing_pole_and_fish:'
  },
  ':kiss:': {
    'tn': 'Kussmund',
    'uc': '1f48b',
    'c': 'people',
    'o': 1409,
    'sn': ':kiss:'
  },
  ':fuelpump:': {
    'tn': 'Tankpumpe',
    'uc': '26fd',
    'c': 'travel',
    'o': 2486,
    'sn': ':fuelpump:'
  },
  ':oil:': {
    'tn': 'Öl_Fass',
    'uc': '1f6e2',
    'c': 'objects',
    'o': 665,
    'sn': ':oil:'
  },
  ':spoon:': {
    'tn': 'Löffel',
    'uc': '1f944',
    'c': 'food',
    'o': 1097,
    'sn': ':spoon:'
  },
  ':test_tube:': {
    'tn': 'Reagenzglas',
    'uc': '1f9ea',
    'c': 'objects',
    'o': 700,
    'sn': ':test_tube:'
  },
  ':urn:': {
    'tn': 'Urne',
    'uc': '26b1',
    'c': 'objects',
    'o': 694,
    'sn': ':urn:'
  },
  ':flag_us:': {
    'tn': 'Fl_USA',
    'uc': '1f1fa-1f1f8',
    'c': 'flags',
    'o': 2800,
    'sn': ':flag_us:'
  },
  ':persevere:': {
    'tn': 'durchhalten',
    'uc': '1f623',
    'c': 'people',
    'o': 1143,
    'sn': ':persevere:'
  },
  ':flag_tr:': {
    'tn': 'Fl_Türkei',
    'uc': '1f1f9-1f1f7',
    'c': 'flags',
    'o': 2788,
    'sn': ':flag_tr:'
  },
  ':ski:': {
    'tn': 'Ski',
    'uc': '1f3bf',
    'c': 'activity',
    'o': 318,
    'sn': ':ski:'
  },
  ':cricket:': {
    'tn': 'Grille',
    'uc': '1f997',
    'c': 'nature',
    'o': 868,
    'sn': ':cricket:'
  },
  ':peach:': {
    'tn': 'Pfirsich',
    'uc': '1f351',
    'c': 'food',
    'o': 1009,
    'sn': ':peach:'
  },
  ':yum:': {
    'tn': 'lecker',
    'uc': '1f60b',
    'c': 'people',
    'o': 1124,
    'sn': ':yum:'
  },
  ':woman_vampire:': {
    'tn': 'Vampir_w',
    'uc': '1f9db-2640',
    'c': 'people',
    'o': 1973,
    'sn': ':woman_vampire:'
  },
  ':necktie:': {
    'tn': 'Krawatte',
    'uc': '1f454',
    'c': 'people',
    'o': 2371,
    'sn': ':necktie:'
  },
  ':tanabata_tree:': {
    'tn': 'Tanabata_Baum',
    'uc': '1f38b',
    'c': 'nature',
    'o': 936,
    'sn': ':tanabata_tree:'
  },
  ':arrow_left:': {
    'tn': 'Pfeil_links',
    'uc': '2b05',
    'c': 'symbols',
    'o': 172,
    'sn': ':arrow_left:'
  },
  ':flag_pn:': {
    'tn': 'Fl_PitcairnIS',
    'uc': '1f1f5-1f1f3',
    'c': 'flags',
    'o': 2737,
    'sn': ':flag_pn:'
  },
  ':mans_shoe:': {
    'tn': 'Herrenschuh',
    'uc': '1f45e',
    'c': 'people',
    'o': 2379,
    'sn': ':mans_shoe:'
  },
  ':raised_hands:': {
    'tn': 'erhobene_Hände',
    'uc': '1f64c',
    'c': 'people',
    'o': 1226,
    'sn': ':raised_hands:'
  },
  ':flag_om:': {
    'tn': 'Fl_Oman',
    'uc': '1f1f4-1f1f2',
    'c': 'flags',
    'o': 2728,
    'sn': ':flag_om:'
  },
  ':satellite_orbital:': {
    'tn': 'Satellit',
    'uc': '1f6f0',
    'c': 'travel',
    'o': 2474,
    'sn': ':satellite_orbital:'
  },
  ':flag_nl:': {
    'tn': 'Fl_Niederlande',
    'uc': '1f1f3-1f1f1',
    'c': 'flags',
    'o': 2717,
    'sn': ':flag_nl:'
  },
  ':flag_mk:': {
    'tn': 'Fl_Mazedonien',
    'uc': '1f1f2-1f1f0',
    'c': 'flags',
    'o': 2692,
    'sn': ':flag_mk:'
  },
  ':capricorn:': {
    'tn': 'Steinbock_Zeichen',
    'uc': '2651',
    'c': 'symbols',
    'o': 39,
    'sn': ':capricorn:'
  },
  ':currency_exchange:': {
    'tn': 'Währungstausch',
    'uc': '1f4b1',
    'c': 'symbols',
    'o': 197,
    'sn': ':currency_exchange:'
  },
  ':flag_ki:': {
    'tn': 'Fl_Kiribati',
    'uc': '1f1f0-1f1ee',
    'c': 'flags',
    'o': 2678,
    'sn': ':flag_ki:'
  },
  ':arrows_clockwise:': {
    'tn': 'im Uhrzeigersinn',
    'uc': '1f503',
    'c': 'symbols',
    'o': 189,
    'sn': ':arrows_clockwise:'
  },
  ':interrobang:': {
    'tn': 'Fragerufzeichen',
    'uc': '2049',
    'c': 'symbols',
    'o': 92,
    'sn': ':interrobang:'
  },
  ':cherry_blossom:': {
    'tn': 'Kirschblüte',
    'uc': '1f338',
    'c': 'nature',
    'o': 947,
    'sn': ':cherry_blossom:'
  },
  ':white_medium_square:': {
    'tn': 'Quader_mittel_weiß2',
    'uc': '25fb',
    'c': 'symbols',
    'o': 229,
    'sn': ':white_medium_square:'
  },
  ':flag_ge:': {
    'tn': 'Fl_Georgien',
    'uc': '1f1ec-1f1ea',
    'c': 'flags',
    'o': 2644,
    'sn': ':flag_ge:'
  },
  ':eject:': {
    'tn': 'auswerfen_Knopf',
    'uc': '23cf',
    'c': 'symbols',
    'o': 156,
    'sn': ':eject:'
  },
  ':flag_ec:': {
    'tn': 'Fl_Ecuador',
    'uc': '1f1ea-1f1e8',
    'c': 'flags',
    'o': 2626,
    'sn': ':flag_ec:'
  },
  ':birthday:': {
    'tn': 'Geburtstag',
    'uc': '1f382',
    'c': 'food',
    'o': 1068,
    'sn': ':birthday:'
  },
  ':mens:': {
    'tn': 'Männer',
    'uc': '1f6b9',
    'c': 'symbols',
    'o': 123,
    'sn': ':mens:'
  },
  ':flag_ca:': {
    'tn': 'Fl_Kanada',
    'uc': '1f1e8-1f1e6',
    'c': 'flags',
    'o': 2599,
    'sn': ':flag_ca:'
  },
  ':point_up_2:': {
    'tn': 'zeigen_oben2',
    'uc': '1f446',
    'c': 'people',
    'o': 1317,
    'sn': ':point_up_2:'
  },
  ':scooter:': {
    'tn': 'Roller',
    'uc': '1f6f4',
    'c': 'travel',
    'o': 2444,
    'sn': ':scooter:'
  },
  ':vs:': {
    'tn': 'gegen',
    'uc': '1f19a',
    'c': 'symbols',
    'o': 56,
    'sn': ':vs:'
  },
  ':eye_in_speech_bubble:': {
    'tn': 'Sprechblase_Auge',
    'uc': '1f441-1f5e8',
    'c': 'symbols',
    'o': 241,
    'sn': ':eye_in_speech_bubble:'
  },
  ':burrito:': {
    'tn': 'Burrito',
    'uc': '1f32f',
    'c': 'food',
    'o': 1045,
    'sn': ':burrito:'
  },
  ':firecracker:': {
    'tn': 'Feuerwerkskörper',
    'uc': '1f9e8',
    'c': 'travel',
    'o': 2545,
    'sn': ':firecracker:'
  },
  ':honey_pot:': {
    'tn': 'Honigtopf',
    'uc': '1f36f',
    'c': 'food',
    'o': 1082,
    'sn': ':honey_pot:'
  },
  ':sparkles:': {
    'tn': 'Glanz',
    'uc': '2728',
    'c': 'nature',
    'o': 970,
    'sn': ':sparkles:'
  },
  ':man_supervillain:': {
    'tn': 'Mann_Supervillain',
    'uc': '1f9b9-2642',
    'c': 'people',
    'o': 1925,
    'sn': ':man_supervillain:'
  },
  ':man_bowing:': {
    'tn': 'Mann_bücken',
    'uc': '1f647-2642',
    'c': 'people',
    'o': 2057,
    'sn': ':man_bowing:'
  },
  ':file_folder:': {
    'tn': 'Ordner',
    'uc': '1f4c1',
    'c': 'objects',
    'o': 786,
    'sn': ':file_folder:'
  },
  ':lipstick:': {
    'tn': 'Lippenstift',
    'uc': '1f484',
    'c': 'people',
    'o': 1408,
    'sn': ':lipstick:'
  },
  ':eye:': {
    'tn': 'Auge',
    'uc': '1f441',
    'c': 'people',
    'o': 1425,
    'sn': ':eye:'
  },
  ':full_moon:': {
    'tn': 'Vollmond',
    'uc': '1f315',
    'c': 'nature',
    'o': 955,
    'sn': ':full_moon:'
  },
  ':grimacing:': {
    'tn': 'grimassieren',
    'uc': '1f62c',
    'c': 'people',
    'o': 1171,
    'sn': ':grimacing:'
  },
  ':camera_with_flash:': {
    'tn': 'Kamera_Blitz',
    'uc': '1f4f8',
    'c': 'objects',
    'o': 635,
    'sn': ':camera_with_flash:'
  },
  ':100:': {
    'tn': '100',
    'uc': '1f4af',
    'c': 'symbols',
    'o': 77,
    'sn': ':100:'
  },
  ':tropical_drink:': {
    'tn': 'Cocktail2',
    'uc': '1f379',
    'c': 'food',
    'o': 1095,
    'sn': ':tropical_drink:'
  },
  ':second_place:': {
    'tn': 'Medallie_2',
    'uc': '1f948',
    'c': 'activity',
    'o': 572,
    'sn': ':second_place:'
  },
  ':snowboarder:': {
    'tn': 'Snowboardfahrer',
    'uc': '1f3c2',
    'c': 'activity',
    'o': 320,
    'sn': ':snowboarder:'
  },
  ':flag_ro:': {
    'tn': 'Fl_Rumänien',
    'uc': '1f1f7-1f1f4',
    'c': 'flags',
    'o': 2743,
    'sn': ':flag_ro:'
  },
  ':card_box:': {
    'tn': 'Karteikasten',
    'uc': '1f5c3',
    'c': 'objects',
    'o': 782,
    'sn': ':card_box:'
  },
  ':female_sign:': {
    'tn': 'weiblich',
    'uc': '2640',
    'c': 'symbols',
    'o': 288,
    'sn': ':female_sign:'
  },
  ':heavy_check_mark:': {
    'tn': 'schwarzes Häkchen',
    'uc': '2714',
    'c': 'symbols',
    'o': 209,
    'sn': ':heavy_check_mark:'
  },
  ':open_file_folder:': {
    'tn': 'Ordner_offen',
    'uc': '1f4c2',
    'c': 'objects',
    'o': 787,
    'sn': ':open_file_folder:'
  },
  ':cat2:': {
    'tn': 'Katze2',
    'uc': '1f408',
    'c': 'nature',
    'o': 914,
    'sn': ':cat2:'
  },
  ':foggy:': {
    'tn': 'Brücke_Nebel',
    'uc': '1f301',
    'c': 'travel',
    'o': 2554,
    'sn': ':foggy:'
  },
  ':shell:': {
    'tn': 'Muschel',
    'uc': '1f41a',
    'c': 'nature',
    'o': 865,
    'sn': ':shell:'
  },
  ':flag_pm:': {
    'tn': 'Fl_StPierre',
    'uc': '1f1f5-1f1f2',
    'c': 'flags',
    'o': 2770,
    'sn': ':flag_pm:'
  },
  ':astonished:': {
    'tn': 'beeindruckt',
    'uc': '1f632',
    'c': 'people',
    'o': 1177,
    'sn': ':astonished:'
  },
  ':bullettrain_front:': {
    'tn': 'Magnetschwebebahn 2',
    'uc': '1f685',
    'c': 'travel',
    'o': 2461,
    'sn': ':bullettrain_front:'
  },
  ':turtle:': {
    'tn': 'Schildkröte',
    'uc': '1f422',
    'c': 'nature',
    'o': 874,
    'sn': ':turtle:'
  },
  ':mortar_board:': {
    'tn': 'Doktorhut',
    'uc': '1f393',
    'c': 'people',
    'o': 2389,
    'sn': ':mortar_board:'
  },
  ':comet:': {
    'tn': 'Komet',
    'uc': '2604',
    'c': 'nature',
    'o': 972,
    'sn': ':comet:'
  },
  ':girl:': {
    'tn': 'Mädchen',
    'uc': '1f467',
    'c': 'people',
    'o': 1439,
    'sn': ':girl:'
  },
  ':flag_li:': {
    'tn': 'Fl_Liechtenstein',
    'uc': '1f1f1-1f1ee',
    'c': 'flags',
    'o': 2688,
    'sn': ':flag_li:'
  },
  ':tea:': {
    'tn': 'Tee',
    'uc': '1f375',
    'c': 'food',
    'o': 1086,
    'sn': ':tea:'
  },
  ':flag_kh:': {
    'tn': 'Fl_Kambodscha',
    'uc': '1f1f0-1f1ed',
    'c': 'flags',
    'o': 2597,
    'sn': ':flag_kh:'
  },
  ':chocolate_bar:': {
    'tn': 'Schokolade_Tafel',
    'uc': '1f36b',
    'c': 'food',
    'o': 1074,
    'sn': ':chocolate_bar:'
  },
  ':ship:': {
    'tn': 'Schiff',
    'uc': '1f6a2',
    'c': 'travel',
    'o': 2484,
    'sn': ':ship:'
  },
  ':tokyo_tower:': {
    'tn': 'Tokyo-Tower',
    'uc': '1f5fc',
    'c': 'travel',
    'o': 2494,
    'sn': ':tokyo_tower:'
  },
  ':dollar:': {
    'tn': 'Dollar',
    'uc': '1f4b5',
    'c': 'objects',
    'o': 667,
    'sn': ':dollar:'
  },
  ':electric_plug:': {
    'tn': 'Stecker',
    'uc': '1f50c',
    'c': 'objects',
    'o': 658,
    'sn': ':electric_plug:'
  },
  ':bank:': {
    'tn': 'Bank',
    'uc': '1f3e6',
    'c': 'travel',
    'o': 2523,
    'sn': ':bank:'
  },
  ':paintbrush:': {
    'tn': 'Pinsel',
    'uc': '1f58c',
    'c': 'objects',
    'o': 813,
    'sn': ':paintbrush:'
  },
  ':leaves:': {
    'tn': 'Blätter',
    'uc': '1f343',
    'c': 'nature',
    'o': 937,
    'sn': ':leaves:'
  },
  ':pretzel:': {
    'tn': 'Brezn',
    'uc': '1f968',
    'c': 'food',
    'o': 1028,
    'sn': ':pretzel:'
  },
  ':man_in_steamy_room:': {
    'tn': 'Mann_Sauna',
    'uc': '1f9d6-2642',
    'c': 'people',
    'o': 2255,
    'sn': ':man_in_steamy_room:'
  },
  ':mag_right:': {
    'tn': 'Lupe2',
    'uc': '1f50e',
    'c': 'objects',
    'o': 818,
    'sn': ':mag_right:'
  },
  ':flag_gd:': {
    'tn': 'Fl_Grenada',
    'uc': '1f1ec-1f1e9',
    'c': 'flags',
    'o': 2650,
    'sn': ':flag_gd:'
  },
  ':oncoming_automobile:': {
    'tn': 'Auto von vorne',
    'uc': '1f698',
    'c': 'travel',
    'o': 2451,
    'sn': ':oncoming_automobile:'
  },
  ':low_brightness:': {
    'tn': 'geringe_Helligkeit',
    'uc': '1f505',
    'c': 'symbols',
    'o': 93,
    'sn': ':low_brightness:'
  },
  ':man_detective:': {
    'tn': 'Detektiv_Mann',
    'uc': '1f575-2642',
    'c': 'people',
    'o': 1661,
    'sn': ':man_detective:'
  },
  ':broken_heart:': {
    'tn': 'Herz_gebrochen',
    'uc': '1f494',
    'c': 'symbols',
    'o': 8,
    'sn': ':broken_heart:'
  },
  ':barber:': {
    'tn': 'Friseur',
    'uc': '1f488',
    'c': 'objects',
    'o': 698,
    'sn': ':barber:'
  },
  ':sparkler:': {
    'tn': 'Wunderkerze',
    'uc': '1f387',
    'c': 'travel',
    'o': 2543,
    'sn': ':sparkler:'
  },
  ':love_you_gesture:': {
    'tn': 'ild_Geste',
    'uc': '1f91f',
    'c': 'people',
    'o': 1287,
    'sn': ':love_you_gesture:'
  },
  ':man_bald:': {
    'tn': 'Mann kahl',
    'uc': '1f468-1f9b2',
    'c': 'people',
    'o': 1535,
    'sn': ':man_bald:'
  },
  ':man_white_haired:': {
    'tn': 'Mann_weißhaarig',
    'uc': '1f468-1f9b3',
    'c': 'people',
    'o': 1523,
    'sn': ':man_white_haired:'
  },
  ':digit_six:': {
    'tn': 'Ziffer sechs',
    'uc': '0036',
    'c': 'symbols',
    'o': 282,
    'sn': ':digit_six:'
  },
  ':woman_playing_handball:': {
    'tn': 'Handballspielerin',
    'uc': '1f93e-2640',
    'c': 'activity',
    'o': 390,
    'sn': ':woman_playing_handball:'
  },
  ':watermelon:': {
    'tn': 'Wassermelone',
    'uc': '1f349',
    'c': 'food',
    'o': 1004,
    'sn': ':watermelon:'
  },
  ':man_fairy:': {
    'tn': 'Fee_m',
    'uc': '1f9da-2642',
    'c': 'people',
    'o': 2021,
    'sn': ':man_fairy:'
  },
  ':arrow_up_down:': {
    'tn': 'hoch_runter_Pfeil',
    'uc': '2195',
    'c': 'symbols',
    'o': 179,
    'sn': ':arrow_up_down:'
  },
  ':ok:': {
    'tn': 'OK',
    'uc': '1f197',
    'c': 'symbols',
    'o': 137,
    'sn': ':ok:'
  },
  ':arrow_right_hook:': {
    'tn': 'Pfeil_Haken_rechts',
    'uc': '21aa',
    'c': 'symbols',
    'o': 181,
    'sn': ':arrow_right_hook:'
  },
  ':flag_zw:': {
    'tn': 'Fl_Zimbabwe',
    'uc': '1f1ff-1f1fc',
    'c': 'flags',
    'o': 2811,
    'sn': ':flag_zw:'
  },
  ':joystick:': {
    'tn': 'Joystick',
    'uc': '1f579',
    'c': 'objects',
    'o': 625,
    'sn': ':joystick:'
  },
  ':office:': {
    'tn': 'Büro',
    'uc': '1f3e2',
    'c': 'travel',
    'o': 2518,
    'sn': ':office:'
  },
  ':u7981:': {
    'tn': 'Verbot',
    'uc': '1f232',
    'c': 'symbols',
    'o': 64,
    'sn': ':u7981:'
  },
  ':rolling_eyes:': {
    'tn': 'augen_rollend',
    'uc': '1f644',
    'c': 'people',
    'o': 1172,
    'sn': ':rolling_eyes:'
  },
  ':man_superhero:': {
    'tn': 'Superheld',
    'uc': '1f9b8-2642',
    'c': 'people',
    'o': 1907,
    'sn': ':man_superhero:'
  },
  ':level_slider:': {
    'tn': 'Schieber',
    'uc': '1f39a',
    'c': 'objects',
    'o': 647,
    'sn': ':level_slider:'
  },
  ':worried:': {
    'tn': 'besorgt',
    'uc': '1f61f',
    'c': 'people',
    'o': 1139,
    'sn': ':worried:'
  },
  ':kiss_woman_man:': {
    'tn': 'Kuss Frau und Mann',
    'uc': '1f469-2764-1f48b-1f468',
    'c': 'people',
    'o': 2338,
    'sn': ':kiss_woman_man:'
  },
  ':wales:': {
    'tn': 'Fl_Wales',
    'uc': '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f',
    'c': 'flags',
    'o': 2799,
    'sn': ':wales:'
  },
  ':pause_button:': {
    'tn': 'pausieren',
    'uc': '23f8',
    'c': 'symbols',
    'o': 158,
    'sn': ':pause_button:'
  },
  ':id:': {
    'tn': 'ID',
    'uc': '1f194',
    'c': 'symbols',
    'o': 42,
    'sn': ':id:'
  },
  ':bagel:': {
    'tn': 'Bagel',
    'uc': '1f96f',
    'c': 'food',
    'o': 1029,
    'sn': ':bagel:'
  },
  ':balloon:': {
    'tn': 'Ballon',
    'uc': '1f388',
    'c': 'objects',
    'o': 745,
    'sn': ':balloon:'
  },
  ':arrow_forward:': {
    'tn': 'abspielen',
    'uc': '25b6',
    'c': 'symbols',
    'o': 157,
    'sn': ':arrow_forward:'
  },
  ':ghost:': {
    'tn': 'Gespenst',
    'uc': '1f47b',
    'c': 'people',
    'o': 1198,
    'sn': ':ghost:'
  },
  ':flag_so:': {
    'tn': 'Fl_Somalia',
    'uc': '1f1f8-1f1f4',
    'c': 'flags',
    'o': 2760,
    'sn': ':flag_so:'
  },
  ':woman_surfing:': {
    'tn': 'Surferin',
    'uc': '1f3c4-2640',
    'c': 'activity',
    'o': 450,
    'sn': ':woman_surfing:'
  },
  ':older_adult:': {
    'tn': 'Senior',
    'uc': '1f9d3',
    'c': 'people',
    'o': 1553,
    'sn': ':older_adult:'
  },
  ':repeat:': {
    'tn': 'Wiederholen',
    'uc': '1f501',
    'c': 'symbols',
    'o': 186,
    'sn': ':repeat:'
  },
  ':fox:': {
    'tn': 'Fuchs',
    'uc': '1f98a',
    'c': 'nature',
    'o': 826,
    'sn': ':fox:'
  },
  ':goat:': {
    'tn': 'Ziege',
    'uc': '1f410',
    'c': 'nature',
    'o': 910,
    'sn': ':goat:'
  },
  ':flag_pl:': {
    'tn': 'Fl_Polen',
    'uc': '1f1f5-1f1f1',
    'c': 'flags',
    'o': 2738,
    'sn': ':flag_pl:'
  },
  ':hedgehog:': {
    'tn': 'Igel',
    'uc': '1f994',
    'c': 'nature',
    'o': 922,
    'sn': ':hedgehog:'
  },
  ':yellow_heart:': {
    'tn': 'Herz_gelb',
    'uc': '1f49b',
    'c': 'symbols',
    'o': 3,
    'sn': ':yellow_heart:'
  },
  ':upside_down:': {
    'tn': 'falsch_herum',
    'uc': '1f643',
    'c': 'people',
    'o': 1115,
    'sn': ':upside_down:'
  },
  ':male_sign:': {
    'tn': 'männlich',
    'uc': '2642',
    'c': 'symbols',
    'o': 289,
    'sn': ':male_sign:'
  },
  ':relaxed:': {
    'tn': 'entspannt',
    'uc': '263a',
    'c': 'people',
    'o': 1111,
    'sn': ':relaxed:'
  },
  ':small_orange_diamond:': {
    'tn': 'Viereck_klein_orange',
    'uc': '1f538',
    'c': 'symbols',
    'o': 218,
    'sn': ':small_orange_diamond:'
  },
  ':tennis:': {
    'tn': 'Ball_Tennis',
    'uc': '1f3be',
    'c': 'activity',
    'o': 296,
    'sn': ':tennis:'
  },
  ':stop_button:': {
    'tn': 'stop_Knopf',
    'uc': '23f9',
    'c': 'symbols',
    'o': 160,
    'sn': ':stop_button:'
  },
  ':flag_kg:': {
    'tn': 'Fl_Kirgistan',
    'uc': '1f1f0-1f1ec',
    'c': 'flags',
    'o': 2681,
    'sn': ':flag_kg:'
  },
  ':suspension_railway:': {
    'tn': 'Schwebebahn',
    'uc': '1f69f',
    'c': 'travel',
    'o': 2455,
    'sn': ':suspension_railway:'
  },
  ':rewind:': {
    'tn': 'Spulen_zurück',
    'uc': '23ea',
    'c': 'symbols',
    'o': 165,
    'sn': ':rewind:'
  },
  ':computer:': {
    'tn': 'Laptop',
    'uc': '1f4bb',
    'c': 'objects',
    'o': 619,
    'sn': ':computer:'
  },
  ':flag_ie:': {
    'tn': 'Fl_Irland',
    'uc': '1f1ee-1f1ea',
    'c': 'flags',
    'o': 2667,
    'sn': ':flag_ie:'
  },
  ':socks:': {
    'tn': 'Socken',
    'uc': '1f9e6',
    'c': 'people',
    'o': 2383,
    'sn': ':socks:'
  },
  ':clock12:': {
    'tn': '12 Uhr',
    'uc': '1f55b',
    'c': 'symbols',
    'o': 263,
    'sn': ':clock12:'
  },
  ':sound:': {
    'tn': 'Ton',
    'uc': '1f509',
    'c': 'symbols',
    'o': 234,
    'sn': ':sound:'
  },
  ':christmas_tree:': {
    'tn': 'Weihnachtsbaum',
    'uc': '1f384',
    'c': 'nature',
    'o': 927,
    'sn': ':christmas_tree:'
  },
  ':woman_genie:': {
    'tn': 'Weiblicher Geist',
    'uc': '1f9de-2640',
    'c': 'people',
    'o': 1989,
    'sn': ':woman_genie:'
  },
  ':woman_biking:': {
    'tn': 'Fahrradfahrerin',
    'uc': '1f6b4-2640',
    'c': 'activity',
    'o': 558,
    'sn': ':woman_biking:'
  },
  ':light_rail:': {
    'tn': 'Straßenbahn',
    'uc': '1f688',
    'c': 'travel',
    'o': 2462,
    'sn': ':light_rail:'
  },
  ':baby_bottle:': {
    'tn': 'Babyflasche',
    'uc': '1f37c',
    'c': 'food',
    'o': 1084,
    'sn': ':baby_bottle:'
  },
  ':gem:': {
    'tn': 'Juwel',
    'uc': '1f48e',
    'c': 'objects',
    'o': 673,
    'sn': ':gem:'
  },
  ':watch:': {
    'tn': 'Uhr',
    'uc': '231a',
    'c': 'objects',
    'o': 616,
    'sn': ':watch:'
  },
  ':flag_ea:': {
    'tn': 'Fl_Ceuta',
    'uc': '1f1ea-1f1e6',
    'c': 'flags',
    'o': 2815,
    'sn': ':flag_ea:'
  },
  ':shushing_face:': {
    'tn': 'Shhh',
    'uc': '1f92b',
    'c': 'people',
    'o': 1166,
    'sn': ':shushing_face:'
  },
  ':arrow_lower_left:': {
    'tn': 'Pfeil_unten_links',
    'uc': '2199',
    'c': 'symbols',
    'o': 177,
    'sn': ':arrow_lower_left:'
  },
  ':trolleybus:': {
    'tn': 'Elektrobus',
    'uc': '1f68e',
    'c': 'travel',
    'o': 2435,
    'sn': ':trolleybus:'
  },
  ':older_man:': {
    'tn': 'Älterer_Mann',
    'uc': '1f474',
    'c': 'people',
    'o': 1559,
    'sn': ':older_man:'
  },
  ':eight:': {
    'tn': '8',
    'uc': '0038-20e3',
    'c': 'symbols',
    'o': 150,
    'sn': ':eight:'
  },
  ':soon:': {
    'tn': 'Bald',
    'uc': '1f51c',
    'c': 'symbols',
    'o': 208,
    'sn': ':soon:'
  },
  ':heart_eyes:': {
    'tn': 'Herz_Augen',
    'uc': '1f60d',
    'c': 'people',
    'o': 1118,
    'sn': ':heart_eyes:'
  },
  ':up:': {
    'tn': 'Hoch!',
    'uc': '1f199',
    'c': 'symbols',
    'o': 138,
    'sn': ':up:'
  },
  ':snowman2:': {
    'tn': 'Schneemann2',
    'uc': '2603',
    'c': 'nature',
    'o': 988,
    'sn': ':snowman2:'
  },
  ':fleur-de-lis:': {
    'tn': 'Lilie',
    'uc': '269c',
    'c': 'symbols',
    'o': 99,
    'sn': ':fleur-de-lis:'
  },
  ':house_with_garden:': {
    'tn': 'Haus_Garten',
    'uc': '1f3e1',
    'c': 'travel',
    'o': 2513,
    'sn': ':house_with_garden:'
  },
  ':notebook:': {
    'tn': 'Notizbuch',
    'uc': '1f4d3',
    'c': 'objects',
    'o': 791,
    'sn': ':notebook:'
  },
  ':syringe:': {
    'tn': 'Spritze',
    'uc': '1f489',
    'c': 'objects',
    'o': 708,
    'sn': ':syringe:'
  },
  ':speaking_head:': {
    'tn': 'sprechen',
    'uc': '1f5e3',
    'c': 'people',
    'o': 1430,
    'sn': ':speaking_head:'
  },
  ':third_place:': {
    'tn': 'Medallie_3',
    'uc': '1f949',
    'c': 'activity',
    'o': 573,
    'sn': ':third_place:'
  },
  ':sandwich:': {
    'tn': 'Sandwich',
    'uc': '1f96a',
    'c': 'food',
    'o': 1042,
    'sn': ':sandwich:'
  },
  ':o:': {
    'tn': 'Kreis2',
    'uc': '2b55',
    'c': 'symbols',
    'o': 72,
    'sn': ':o:'
  },
  ':woman_construction_worker:': {
    'tn': 'Bauarbeiterin',
    'uc': '1f477-2640',
    'c': 'people',
    'o': 1619,
    'sn': ':woman_construction_worker:'
  },
  ':milk:': {
    'tn': 'Milch',
    'uc': '1f95b',
    'c': 'food',
    'o': 1083,
    'sn': ':milk:'
  },
  ':flag_ws:': {
    'tn': 'Fl_Samoa',
    'uc': '1f1fc-1f1f8',
    'c': 'flags',
    'o': 2746,
    'sn': ':flag_ws:'
  },
  ':chart_with_downwards_trend:': {
    'tn': 'Graph_neg',
    'uc': '1f4c9',
    'c': 'objects',
    'o': 776,
    'sn': ':chart_with_downwards_trend:'
  },
  ':spider_web:': {
    'tn': 'Spinnennetz',
    'uc': '1f578',
    'c': 'nature',
    'o': 870,
    'sn': ':spider_web:'
  },
  ':flag_to:': {
    'tn': 'Fl_Tonga',
    'uc': '1f1f9-1f1f4',
    'c': 'flags',
    'o': 2785,
    'sn': ':flag_to:'
  },
  ':dividers:': {
    'tn': 'Teiler',
    'uc': '1f5c2',
    'c': 'objects',
    'o': 788,
    'sn': ':dividers:'
  },
  ':vampire:': {
    'tn': 'Vampir',
    'uc': '1f9db',
    'c': 'people',
    'o': 1967,
    'sn': ':vampire:'
  },
  ':flag_sn:': {
    'tn': 'Fl_Senegal',
    'uc': '1f1f8-1f1f3',
    'c': 'flags',
    'o': 2750,
    'sn': ':flag_sn:'
  },
  ':peace:': {
    'tn': 'Peace',
    'uc': '262e',
    'c': 'symbols',
    'o': 18,
    'sn': ':peace:'
  },
  ':man_police_officer:': {
    'tn': 'Polizei_Mann',
    'uc': '1f46e-2642',
    'c': 'people',
    'o': 1607,
    'sn': ':man_police_officer:'
  },
  ':man_lifting_weights:': {
    'tn': 'Gewichtheber',
    'uc': '1f3cb-2642',
    'c': 'activity',
    'o': 338,
    'sn': ':man_lifting_weights:'
  },
  ':digit_zero:': {
    'tn': 'Ziffer null',
    'uc': '0030',
    'c': 'symbols',
    'o': 276,
    'sn': ':digit_zero:'
  },
  ':flag_pk:': {
    'tn': 'Fl_Pakistan',
    'uc': '1f1f5-1f1f0',
    'c': 'flags',
    'o': 2729,
    'sn': ':flag_pk:'
  },
  ':pen_fountain:': {
    'tn': 'Füller',
    'uc': '1f58b',
    'c': 'objects',
    'o': 811,
    'sn': ':pen_fountain:'
  },
  ':womans_clothes:': {
    'tn': 'Frauenkleidung',
    'uc': '1f45a',
    'c': 'people',
    'o': 2368,
    'sn': ':womans_clothes:'
  },
  ':flag_ni:': {
    'tn': 'Fl_Nicaragua',
    'uc': '1f1f3-1f1ee',
    'c': 'flags',
    'o': 2720,
    'sn': ':flag_ni:'
  },
  ':flag_mh:': {
    'tn': 'Fl_MarshallIS',
    'uc': '1f1f2-1f1ed',
    'c': 'flags',
    'o': 2699,
    'sn': ':flag_mh:'
  },
  ':no_pedestrians:': {
    'tn': 'keine_Fußgänger',
    'uc': '1f6b7',
    'c': 'symbols',
    'o': 80,
    'sn': ':no_pedestrians:'
  },
  ':waning_crescent_moon:': {
    'tn': 'Mond_abnehmend_halb',
    'uc': '1f318',
    'c': 'nature',
    'o': 958,
    'sn': ':waning_crescent_moon:'
  },
  ':white_check_mark:': {
    'tn': 'grünes Häkchen',
    'uc': '2705',
    'c': 'symbols',
    'o': 102,
    'sn': ':white_check_mark:'
  },
  ':woman_swimming:': {
    'tn': 'Schwimmerin',
    'uc': '1f3ca-2640',
    'c': 'activity',
    'o': 468,
    'sn': ':woman_swimming:'
  },
  ':flag_je:': {
    'tn': 'Fl_Jersey',
    'uc': '1f1ef-1f1ea',
    'c': 'flags',
    'o': 2674,
    'sn': ':flag_je:'
  },
  ':flag_id:': {
    'tn': 'Fl_Indonesien',
    'uc': '1f1ee-1f1e9',
    'c': 'flags',
    'o': 2664,
    'sn': ':flag_id:'
  },
  ':clock11:': {
    'tn': '11 Uhr',
    'uc': '1f55a',
    'c': 'symbols',
    'o': 262,
    'sn': ':clock11:'
  },
  ':punch:': {
    'tn': 'Schlag',
    'uc': '1f44a',
    'c': 'people',
    'o': 1251,
    'sn': ':punch:'
  },
  ':flag_gb:': {
    'tn': 'Fl_Großbritannien',
    'uc': '1f1ec-1f1e7',
    'c': 'flags',
    'o': 2796,
    'sn': ':flag_gb:'
  },
  ':pray:': {
    'tn': 'Beten',
    'uc': '1f64f',
    'c': 'people',
    'o': 1401,
    'sn': ':pray:'
  },
  ':rabbit:': {
    'tn': 'Kaninchen',
    'uc': '1f430',
    'c': 'nature',
    'o': 825,
    'sn': ':rabbit:'
  },
  ':blue_book:': {
    'tn': 'Buch_blau',
    'uc': '1f4d8',
    'c': 'objects',
    'o': 796,
    'sn': ':blue_book:'
  },
  ':bathtub:': {
    'tn': 'Badewanne1',
    'uc': '1f6c1',
    'c': 'objects',
    'o': 713,
    'sn': ':bathtub:'
  },
  ':u7121:': {
    'tn': 'Mangel',
    'uc': '1f21a',
    'c': 'symbols',
    'o': 51,
    'sn': ':u7121:'
  },
  ':motorway:': {
    'tn': 'Autobahn',
    'uc': '1f6e3',
    'c': 'travel',
    'o': 2536,
    'sn': ':motorway:'
  },
  ':airplane_small:': {
    'tn': 'Flugzeug_klein',
    'uc': '1f6e9',
    'c': 'travel',
    'o': 2471,
    'sn': ':airplane_small:'
  },
  ':man_in_lotus_position:': {
    'tn': 'Mann_Lotusposition',
    'uc': '1f9d8-2642',
    'c': 'activity',
    'o': 438,
    'sn': ':man_in_lotus_position:'
  },
  ':hospital:': {
    'tn': 'Krankenhaus',
    'uc': '1f3e5',
    'c': 'travel',
    'o': 2522,
    'sn': ':hospital:'
  },
  ':umbrella2:': {
    'tn': 'Regenschirm2',
    'uc': '2602',
    'c': 'nature',
    'o': 995,
    'sn': ':umbrella2:'
  },
  ':first_quarter_moon_with_face:': {
    'tn': 'Mond_viertel_Gesicht1',
    'uc': '1f31b',
    'c': 'nature',
    'o': 952,
    'sn': ':first_quarter_moon_with_face:'
  },
  ':lacrosse:': {
    'tn': 'Lacrosse',
    'uc': '1f94d',
    'c': 'activity',
    'o': 306,
    'sn': ':lacrosse:'
  },
  ':clock:': {
    'tn': 'Uhr',
    'uc': '1f570',
    'c': 'objects',
    'o': 652,
    'sn': ':clock:'
  },
  ':milky_way:': {
    'tn': 'Milchstraße',
    'uc': '1f30c',
    'c': 'travel',
    'o': 2550,
    'sn': ':milky_way:'
  },
  ':man_gesturing_ok:': {
    'tn': 'Mann_ok',
    'uc': '1f646-2642',
    'c': 'people',
    'o': 2111,
    'sn': ':man_gesturing_ok:'
  },
  ':gloves:': {
    'tn': 'Handschuhe',
    'uc': '1f9e4',
    'c': 'people',
    'o': 2384,
    'sn': ':gloves:'
  },
  ':man_in_tuxedo:': {
    'tn': 'Mann_Smoking',
    'uc': '1f935',
    'c': 'people',
    'o': 1865,
    'sn': ':man_in_tuxedo:'
  },
  ':couch:': {
    'tn': 'Sofa',
    'uc': '1f6cb',
    'c': 'objects',
    'o': 732,
    'sn': ':couch:'
  },
  ':arrow_upper_left:': {
    'tn': 'Pfeil_oben_links',
    'uc': '2196',
    'c': 'symbols',
    'o': 178,
    'sn': ':arrow_upper_left:'
  },
  ':woman_technologist:': {
    'tn': 'Frau_Laptop',
    'uc': '1f469-1f4bb',
    'c': 'people',
    'o': 1751,
    'sn': ':woman_technologist:'
  },
  ':dove:': {
    'tn': 'Friedenstaube',
    'uc': '1f54a',
    'c': 'nature',
    'o': 917,
    'sn': ':dove:'
  },
  ':high_brightness:': {
    'tn': 'hohe_Helligkeit',
    'uc': '1f506',
    'c': 'symbols',
    'o': 94,
    'sn': ':high_brightness:'
  },
  ':man_facepalming:': {
    'tn': 'Mann_Hand_Gesicht',
    'uc': '1f926-2642',
    'c': 'people',
    'o': 2147,
    'sn': ':man_facepalming:'
  },
  ':performing_arts:': {
    'tn': 'Masken',
    'uc': '1f3ad',
    'c': 'activity',
    'o': 599,
    'sn': ':performing_arts:'
  },
  ':sponge:': {
    'tn': 'Schwamm',
    'uc': '1f9fd',
    'c': 'objects',
    'o': 724,
    'sn': ':sponge:'
  },
  ':negative_squared_cross_mark:': {
    'tn': 'x_grün',
    'uc': '274e',
    'c': 'symbols',
    'o': 107,
    'sn': ':negative_squared_cross_mark:'
  },
  ':leg:': {
    'tn': 'Bein',
    'uc': '1f9b5',
    'c': 'people',
    'o': 1377,
    'sn': ':leg:'
  },
  ':flag_yt:': {
    'tn': 'Fl_Mayotte',
    'uc': '1f1fe-1f1f9',
    'c': 'flags',
    'o': 2703,
    'sn': ':flag_yt:'
  },
  ':earth_americas:': {
    'tn': 'Erde_Amerika',
    'uc': '1f30e',
    'c': 'nature',
    'o': 964,
    'sn': ':earth_americas:'
  },
  ':link:': {
    'tn': 'Verknüpfung',
    'uc': '1f517',
    'c': 'objects',
    'o': 801,
    'sn': ':link:'
  },
  ':pig:': {
    'tn': 'Schwein',
    'uc': '1f437',
    'c': 'nature',
    'o': 836,
    'sn': ':pig:'
  },
  ':ice_cream:': {
    'tn': 'Eis2',
    'uc': '1f368',
    'c': 'food',
    'o': 1064,
    'sn': ':ice_cream:'
  },
  ':face_with_raised_eyebrow:': {
    'tn': 'skeptisch',
    'uc': '1f928',
    'c': 'people',
    'o': 1129,
    'sn': ':face_with_raised_eyebrow:'
  },
  ':flag_sm:': {
    'tn': 'Fl_SanMarino',
    'uc': '1f1f8-1f1f2',
    'c': 'flags',
    'o': 2747,
    'sn': ':flag_sm:'
  },
  ':santa:': {
    'tn': 'Nikolaus',
    'uc': '1f385',
    'c': 'people',
    'o': 1889,
    'sn': ':santa:'
  },
  ':point_right:': {
    'tn': 'zeigen_rechts',
    'uc': '1f449',
    'c': 'people',
    'o': 1311,
    'sn': ':point_right:'
  },
  ':wave:': {
    'tn': 'winken',
    'uc': '1f44b',
    'c': 'people',
    'o': 1359,
    'sn': ':wave:'
  },
  ':arrow_backward:': {
    'tn': 'Pfeil_zurück',
    'uc': '25c0',
    'c': 'symbols',
    'o': 168,
    'sn': ':arrow_backward:'
  },
  ':capital_abcd:': {
    'tn': 'ABCD',
    'uc': '1f520',
    'c': 'symbols',
    'o': 135,
    'sn': ':capital_abcd:'
  },
  ':exclamation:': {
    'tn': 'Ausrufezeichen_rot',
    'uc': '2757',
    'c': 'symbols',
    'o': 87,
    'sn': ':exclamation:'
  },
  ':flag_mg:': {
    'tn': 'Fl_Madagaskar',
    'uc': '1f1f2-1f1ec',
    'c': 'flags',
    'o': 2693,
    'sn': ':flag_mg:'
  },
  ':eyeglasses:': {
    'tn': 'Brille',
    'uc': '1f453',
    'c': 'people',
    'o': 2397,
    'sn': ':eyeglasses:'
  },
  ':flag_ke:': {
    'tn': 'Fl_Kenia',
    'uc': '1f1f0-1f1ea',
    'c': 'flags',
    'o': 2677,
    'sn': ':flag_ke:'
  },
  ':mute:': {
    'tn': 'stumm',
    'uc': '1f507',
    'c': 'symbols',
    'o': 233,
    'sn': ':mute:'
  },
  ':flag_ic:': {
    'tn': 'Fl_Kanaren',
    'uc': '1f1ee-1f1e8',
    'c': 'flags',
    'o': 2600,
    'sn': ':flag_ic:'
  },
  ':shinto_shrine:': {
    'tn': 'Shinto-Schrein',
    'uc': '26e9',
    'c': 'travel',
    'o': 2534,
    'sn': ':shinto_shrine:'
  },
  ':clock10:': {
    'tn': '10 Uhr',
    'uc': '1f559',
    'c': 'symbols',
    'o': 261,
    'sn': ':clock10:'
  },
  ':lobster:': {
    'tn': 'Hummer',
    'uc': '1f99e',
    'c': 'nature',
    'o': 883,
    'sn': ':lobster:'
  },
  ':cold_sweat:': {
    'tn': 'kalter_Schweiß',
    'uc': '1f630',
    'c': 'people',
    'o': 1157,
    'sn': ':cold_sweat:'
  },
  ':flag_ga:': {
    'tn': 'Fl_Gabun',
    'uc': '1f1ec-1f1e6',
    'c': 'flags',
    'o': 2642,
    'sn': ':flag_ga:'
  },
  ':fearful:': {
    'tn': 'ängstlich',
    'uc': '1f628',
    'c': 'people',
    'o': 1156,
    'sn': ':fearful:'
  },
  ':battery:': {
    'tn': 'Batterie',
    'uc': '1f50b',
    'c': 'objects',
    'o': 657,
    'sn': ':battery:'
  },
  ':arrow_up_small:': {
    'tn': 'Pfeil_oben',
    'uc': '1f53c',
    'c': 'symbols',
    'o': 169,
    'sn': ':arrow_up_small:'
  },
  ':newspaper2:': {
    'tn': 'Zeitung',
    'uc': '1f5de',
    'c': 'objects',
    'o': 789,
    'sn': ':newspaper2:'
  },
  ':pill:': {
    'tn': 'Pille',
    'uc': '1f48a',
    'c': 'objects',
    'o': 707,
    'sn': ':pill:'
  },
  ':family_man_boy_boy:': {
    'tn': 'Single_Mann_MM',
    'uc': '1f468-1f466-1f466',
    'c': 'people',
    'o': 2365,
    'sn': ':family_man_boy_boy:'
  },
  ':crying_cat_face:': {
    'tn': 'Träne_Katze',
    'uc': '1f63f',
    'c': 'people',
    'o': 1212,
    'sn': ':crying_cat_face:'
  },
  ':tm:': {
    'uc': '2122',
    'c': 'symbols',
    'o': 198,
    'sn': ':tm:'
  },
  ':u5272:': {
    'tn': '10%_Rabatt',
    'uc': '1f239',
    'c': 'symbols',
    'o': 63,
    'sn': ':u5272:'
  },
  ':woman_singer:': {
    'tn': 'Sängerin',
    'uc': '1f469-1f3a4',
    'c': 'people',
    'o': 1715,
    'sn': ':woman_singer:'
  },
  ':seven:': {
    'tn': '7',
    'uc': '0037-20e3',
    'c': 'symbols',
    'o': 149,
    'sn': ':seven:'
  },
  ':wheel_of_dharma:': {
    'tn': 'Dharmachakra',
    'uc': '2638',
    'c': 'symbols',
    'o': 22,
    'sn': ':wheel_of_dharma:'
  },
  ':rice:': {
    'tn': 'Reis',
    'uc': '1f35a',
    'c': 'food',
    'o': 1057,
    'sn': ':rice:'
  },
  ':bird:': {
    'tn': 'Vogel',
    'uc': '1f426',
    'c': 'nature',
    'o': 846,
    'sn': ':bird:'
  },
  ':tangerine:': {
    'tn': 'Mandarine',
    'uc': '1f34a',
    'c': 'food',
    'o': 1001,
    'sn': ':tangerine:'
  },
  ':loudspeaker:': {
    'tn': 'Megafon',
    'uc': '1f4e2',
    'c': 'symbols',
    'o': 239,
    'sn': ':loudspeaker:'
  },
  ':duck:': {
    'tn': 'Ente',
    'uc': '1f986',
    'c': 'nature',
    'o': 850,
    'sn': ':duck:'
  },
  ':ng:': {
    'tn': 'NG',
    'uc': '1f196',
    'c': 'symbols',
    'o': 136,
    'sn': ':ng:'
  },
  ':nazar_amulet:': {
    'tn': 'Nazar-Amulett',
    'uc': '1f9ff',
    'c': 'objects',
    'o': 674,
    'sn': ':nazar_amulet:'
  },
  ':m:': {
    'tn': 'Metro_Zeichen',
    'uc': '24c2',
    'c': 'symbols',
    'o': 110,
    'sn': ':m:'
  },
  ':thunder_cloud_rain:': {
    'tn': 'Wolke_Blitz_Regen',
    'uc': '26c8',
    'c': 'nature',
    'o': 984,
    'sn': ':thunder_cloud_rain:'
  },
  ':disappointed_relieved:': {
    'tn': 'Enttäuschung',
    'uc': '1f625',
    'c': 'people',
    'o': 1161,
    'sn': ':disappointed_relieved:'
  },
  ':stopwatch:': {
    'tn': 'Stoppuhr',
    'uc': '23f1',
    'c': 'objects',
    'o': 649,
    'sn': ':stopwatch:'
  },
  ':hotsprings:': {
    'tn': 'Wärme',
    'uc': '2668',
    'c': 'symbols',
    'o': 79,
    'sn': ':hotsprings:'
  },
  ':taco:': {
    'tn': 'Taco',
    'uc': '1f32e',
    'c': 'food',
    'o': 1044,
    'sn': ':taco:'
  },
  ':woman_shrugging:': {
    'tn': 'Frau_keine_Ahnung',
    'uc': '1f937-2640',
    'c': 'people',
    'o': 2159,
    'sn': ':woman_shrugging:'
  },
  ':billed_cap:': {
    'tn': 'Baseballcap',
    'uc': '1f9e2',
    'c': 'people',
    'o': 2387,
    'sn': ':billed_cap:'
  },
  ':flag_tn:': {
    'tn': 'Fl_Tunesien',
    'uc': '1f1f9-1f1f3',
    'c': 'flags',
    'o': 2787,
    'sn': ':flag_tn:'
  },
  ':white_sun_cloud:': {
    'tn': 'Sonne_viertel',
    'uc': '1f325',
    'c': 'nature',
    'o': 980,
    'sn': ':white_sun_cloud:'
  },
  ':supervillain:': {
    'tn': 'Supervillain',
    'uc': '1f9b9',
    'c': 'people',
    'o': 1913,
    'sn': ':supervillain:'
  },
  ':clock1230:': {
    'tn': '12:30 Uhr',
    'uc': '1f567',
    'c': 'symbols',
    'o': 275,
    'sn': ':clock1230:'
  },
  ':partly_sunny:': {
    'tn': 'Sonne_halb',
    'uc': '26c5',
    'c': 'nature',
    'o': 979,
    'sn': ':partly_sunny:'
  },
  ':flag_ng:': {
    'tn': 'Fl_Nigeria',
    'uc': '1f1f3-1f1ec',
    'c': 'flags',
    'o': 2722,
    'sn': ':flag_ng:'
  },
  ':flag_mf:': {
    'tn': 'Fl_StMartin',
    'uc': '1f1f2-1f1eb',
    'c': 'flags',
    'o': 2818,
    'sn': ':flag_mf:'
  },
  ':man_astronaut:': {
    'tn': 'Astronaut',
    'uc': '1f468-1f680',
    'c': 'people',
    'o': 1841,
    'sn': ':man_astronaut:'
  },
  ':penguin:': {
    'tn': 'Pinguin',
    'uc': '1f427',
    'c': 'nature',
    'o': 845,
    'sn': ':penguin:'
  },
  ':evergreen_tree:': {
    'tn': 'Nadelbaum',
    'uc': '1f332',
    'c': 'nature',
    'o': 928,
    'sn': ':evergreen_tree:'
  },
  ':clap:': {
    'tn': 'Klatschen',
    'uc': '1f44f',
    'c': 'people',
    'o': 1232,
    'sn': ':clap:'
  },
  ':fish:': {
    'tn': 'Fisch',
    'uc': '1f41f',
    'c': 'nature',
    'o': 886,
    'sn': ':fish:'
  },
  ':cake:': {
    'tn': 'Kuchen',
    'uc': '1f370',
    'c': 'food',
    'o': 1067,
    'sn': ':cake:'
  },
  ':bow_and_arrow:': {
    'tn': 'Pfeil_Bogen',
    'uc': '1f3f9',
    'c': 'activity',
    'o': 309,
    'sn': ':bow_and_arrow:'
  },
  ':imp:': {
    'tn': 'Kobold',
    'uc': '1f47f',
    'c': 'people',
    'o': 1193,
    'sn': ':imp:'
  },
  ':smoking:': {
    'tn': 'Zigarette',
    'uc': '1f6ac',
    'c': 'objects',
    'o': 692,
    'sn': ':smoking:'
  },
  ':woman_playing_water_polo:': {
    'tn': 'Frau_Wasserpolo',
    'uc': '1f93d-2640',
    'c': 'activity',
    'o': 486,
    'sn': ':woman_playing_water_polo:'
  },
  ':digit_four:': {
    'tn': 'Ziffer fünf',
    'uc': '0034',
    'c': 'symbols',
    'o': 280,
    'sn': ':digit_four:'
  },
  ':racehorse:': {
    'tn': 'Rennpferd',
    'uc': '1f40e',
    'c': 'nature',
    'o': 906,
    'sn': ':racehorse:'
  },
  ':flag_az:': {
    'tn': 'Fl_Aserbaidschan',
    'uc': '1f1e6-1f1ff',
    'c': 'flags',
    'o': 2576,
    'sn': ':flag_az:'
  },
  ':couple_with_heart:': {
    'tn': 'Pärchen_Herz',
    'uc': '1f491',
    'c': 'people',
    'o': 2333,
    'sn': ':couple_with_heart:'
  },
  ':genie:': {
    'tn': 'Geist',
    'uc': '1f9de',
    'c': 'people',
    'o': 1988,
    'sn': ':genie:'
  },
  ':construction_worker:': {
    'tn': 'Bauarbeiter',
    'uc': '1f477',
    'c': 'people',
    'o': 1613,
    'sn': ':construction_worker:'
  },
  ':fireworks:': {
    'tn': 'Feuerwerk',
    'uc': '1f386',
    'c': 'travel',
    'o': 2544,
    'sn': ':fireworks:'
  },
  ':sled:': {
    'tn': 'Schlitten',
    'uc': '1f6f7',
    'c': 'activity',
    'o': 317,
    'sn': ':sled:'
  },
  ':stuck_out_tongue:': {
    'tn': 'Zunge_draußen',
    'uc': '1f61b',
    'c': 'people',
    'o': 1125,
    'sn': ':stuck_out_tongue:'
  },
  ':two:': {
    'tn': '2',
    'uc': '0032-20e3',
    'c': 'symbols',
    'o': 144,
    'sn': ':two:'
  },
  ':man_curly_haired:': {
    'tn': 'Mann_lockig',
    'uc': '1f468-1f9b1',
    'c': 'people',
    'o': 1511,
    'sn': ':man_curly_haired:'
  },
  ':two_men_holding_hands:': {
    'tn': 'Männer Händchenhalten',
    'uc': '1f46c',
    'c': 'people',
    'o': 2332,
    'sn': ':two_men_holding_hands:'
  },
  ':digit_three:': {
    'tn': 'Ziffer drei',
    'uc': '0033',
    'c': 'symbols',
    'o': 279,
    'sn': ':digit_three:'
  },
  ':man_factory_worker:': {
    'tn': 'Fabrikarbeiter',
    'uc': '1f468-1f3ed',
    'c': 'people',
    'o': 1745,
    'sn': ':man_factory_worker:'
  },
  ':boy:': {
    'tn': 'Junge',
    'uc': '1f466',
    'c': 'people',
    'o': 1451,
    'sn': ':boy:'
  },
  ':droplet:': {
    'tn': 'Tropfen',
    'uc': '1f4a7',
    'c': 'nature',
    'o': 992,
    'sn': ':droplet:'
  },
  ':pie:': {
    'tn': 'Kuchen',
    'uc': '1f967',
    'c': 'food',
    'o': 1066,
    'sn': ':pie:'
  },
  ':thumbsup:': {
    'tn': 'Daumen_hoch',
    'uc': '1f44d',
    'c': 'people',
    'o': 1239,
    'sn': ':thumbsup:'
  },
  ':arrow_down:': {
    'tn': 'Pfeil_runter',
    'uc': '2b07',
    'c': 'symbols',
    'o': 174,
    'sn': ':arrow_down:'
  },
  ':hatched_chick:': {
    'tn': 'Küken aus Ei',
    'uc': '1f425',
    'c': 'nature',
    'o': 849,
    'sn': ':hatched_chick:'
  },
  ':flag_tm:': {
    'tn': 'Fl_Türkmenistan',
    'uc': '1f1f9-1f1f2',
    'c': 'flags',
    'o': 2789,
    'sn': ':flag_tm:'
  },
  ':floppy_disk:': {
    'tn': 'Diskette',
    'uc': '1f4be',
    'c': 'objects',
    'o': 630,
    'sn': ':floppy_disk:'
  },
  ':mushroom:': {
    'tn': 'Pilz',
    'uc': '1f344',
    'c': 'nature',
    'o': 940,
    'sn': ':mushroom:'
  },
  ':pound:': {
    'tn': 'Pfund',
    'uc': '1f4b7',
    'c': 'objects',
    'o': 670,
    'sn': ':pound:'
  },
  ':flag_sl:': {
    'tn': 'Fl_SierraLeone',
    'uc': '1f1f8-1f1f1',
    'c': 'flags',
    'o': 2753,
    'sn': ':flag_sl:'
  },
  ':scissors:': {
    'tn': 'Schere',
    'uc': '2702',
    'c': 'objects',
    'o': 809,
    'sn': ':scissors:'
  },
  ':cherries:': {
    'tn': 'Kirsche',
    'uc': '1f352',
    'c': 'food',
    'o': 1008,
    'sn': ':cherries:'
  },
  ':flag_ph:': {
    'tn': 'Fl_Philippinen',
    'uc': '1f1f5-1f1ed',
    'c': 'flags',
    'o': 2736,
    'sn': ':flag_ph:'
  },
  ':white_haired:': {
    'tn': 'weißhaarig',
    'uc': '1f9b3',
    'c': 'people',
    'o': 2403,
    'sn': ':white_haired:'
  },
  ':mailbox_closed:': {
    'tn': 'Briefkasten1',
    'uc': '1f4ea',
    'c': 'objects',
    'o': 763,
    'sn': ':mailbox_closed:'
  },
  ':flag_nf:': {
    'tn': 'Fl_NorfolkIS',
    'uc': '1f1f3-1f1eb',
    'c': 'flags',
    'o': 2724,
    'sn': ':flag_nf:'
  },
  ':flag_me:': {
    'tn': 'Fl_Montenegro',
    'uc': '1f1f2-1f1ea',
    'c': 'flags',
    'o': 2709,
    'sn': ':flag_me:'
  },
  ':woman_wearing_turban:': {
    'tn': 'Frau_Turban',
    'uc': '1f473-2640',
    'c': 'people',
    'o': 1577,
    'sn': ':woman_wearing_turban:'
  },
  ':cheese:': {
    'tn': 'Käse',
    'uc': '1f9c0',
    'c': 'food',
    'o': 1030,
    'sn': ':cheese:'
  },
  ':palm_tree:': {
    'tn': 'Palme',
    'uc': '1f334',
    'c': 'nature',
    'o': 930,
    'sn': ':palm_tree:'
  },
  ':cloud_tornado:': {
    'tn': 'Tornado',
    'uc': '1f32a',
    'c': 'nature',
    'o': 975,
    'sn': ':cloud_tornado:'
  },
  ':pen_ballpoint:': {
    'tn': 'Kugelschreiber',
    'uc': '1f58a',
    'c': 'objects',
    'o': 810,
    'sn': ':pen_ballpoint:'
  },
  ':man_dancing:': {
    'tn': 'Tänzer',
    'uc': '1f57a',
    'c': 'people',
    'o': 2279,
    'sn': ':man_dancing:'
  },
  ':pisces:': {
    'tn': 'Fische_Zeichen',
    'uc': '2653',
    'c': 'symbols',
    'o': 41,
    'sn': ':pisces:'
  },
  ':bald:': {
    'tn': 'kahl',
    'uc': '1f9b2',
    'c': 'people',
    'o': 2404,
    'sn': ':bald:'
  },
  ':kissing_heart:': {
    'tn': 'Kuss_Herz',
    'uc': '1f618',
    'c': 'people',
    'o': 1119,
    'sn': ':kissing_heart:'
  },
  ':paperclips:': {
    'tn': 'Büroklammern',
    'uc': '1f587',
    'c': 'objects',
    'o': 803,
    'sn': ':paperclips:'
  },
  ':new_moon_with_face:': {
    'tn': 'Mond_neu_Gesicht',
    'uc': '1f31a',
    'c': 'nature',
    'o': 954,
    'sn': ':new_moon_with_face:'
  },
  ':white_large_square:': {
    'tn': 'Quader_groß_weiß',
    'uc': '2b1c',
    'c': 'symbols',
    'o': 231,
    'sn': ':white_large_square:'
  },
  ':flag_bz:': {
    'tn': 'Fl_Belize',
    'uc': '1f1e7-1f1ff',
    'c': 'flags',
    'o': 2583,
    'sn': ':flag_bz:'
  },
  ':checkered_flag:': {
    'tn': 'Fl_schwarzweiß',
    'uc': '1f3c1',
    'c': 'flags',
    'o': 2557,
    'sn': ':checkered_flag:'
  },
  ':gift_heart:': {
    'tn': 'Herz_Schleife',
    'uc': '1f49d',
    'c': 'symbols',
    'o': 16,
    'sn': ':gift_heart:'
  },
  ':woman_gesturing_no:': {
    'tn': 'Frau_nein',
    'uc': '1f645-2640',
    'c': 'people',
    'o': 2087,
    'sn': ':woman_gesturing_no:'
  },
  ':face_with_symbols_over_mouth:': {
    'tn': 'beleidigen',
    'uc': '1f92c',
    'c': 'people',
    'o': 1152,
    'sn': ':face_with_symbols_over_mouth:'
  },
  ':fire_engine:': {
    'tn': 'Feuerwehrwagen',
    'uc': '1f692',
    'c': 'travel',
    'o': 2439,
    'sn': ':fire_engine:'
  },
  ':arrows_counterclockwise:': {
    'tn': 'gegen Uhrzeigersinn',
    'uc': '1f504',
    'c': 'symbols',
    'o': 188,
    'sn': ':arrows_counterclockwise:'
  },
  ':postbox:': {
    'tn': 'Postkasten',
    'uc': '1f4ee',
    'c': 'objects',
    'o': 767,
    'sn': ':postbox:'
  },
  ':helicopter:': {
    'tn': 'Hubschrauber',
    'uc': '1f681',
    'c': 'travel',
    'o': 2477,
    'sn': ':helicopter:'
  },
  ':joy_cat:': {
    'tn': 'glück_Katze',
    'uc': '1f639',
    'c': 'people',
    'o': 1207,
    'sn': ':joy_cat:'
  },
  ':man_mage:': {
    'tn': 'Magier2',
    'uc': '1f9d9-2642',
    'c': 'people',
    'o': 1943,
    'sn': ':man_mage:'
  },
  ':kissing_smiling_eyes:': {
    'tn': 'Kuss_Augen_zu',
    'uc': '1f619',
    'c': 'people',
    'o': 1122,
    'sn': ':kissing_smiling_eyes:'
  },
  ':tent:': {
    'tn': 'Zelt',
    'uc': '26fa',
    'c': 'travel',
    'o': 2511,
    'sn': ':tent:'
  },
  ':heavy_multiplication_x:': {
    'tn': 'schwarzes X',
    'uc': '2716',
    'c': 'symbols',
    'o': 195,
    'sn': ':heavy_multiplication_x:'
  },
  ':cow:': {
    'tn': 'Kuh',
    'uc': '1f42e',
    'c': 'nature',
    'o': 835,
    'sn': ':cow:'
  },
  ':icecream:': {
    'tn': 'Eis',
    'uc': '1f366',
    'c': 'food',
    'o': 1065,
    'sn': ':icecream:'
  },
  ':flag_vn:': {
    'tn': 'Fl_Vietnam',
    'uc': '1f1fb-1f1f3',
    'c': 'flags',
    'o': 2806,
    'sn': ':flag_vn:'
  },
  ':man_mountain_biking:': {
    'tn': 'Mann_Mountainbiking',
    'uc': '1f6b5-2642',
    'c': 'activity',
    'o': 546,
    'sn': ':man_mountain_biking:'
  },
  ':flag_um:': {
    'tn': 'Fl_OutlyingIS',
    'uc': '1f1fa-1f1f2',
    'c': 'flags',
    'o': 2821,
    'sn': ':flag_um:'
  },
  ':jeans:': {
    'tn': 'Jeans',
    'uc': '1f456',
    'c': 'people',
    'o': 2370,
    'sn': ':jeans:'
  },
  ':flag_tl:': {
    'tn': 'Fl_TimorLeste',
    'uc': '1f1f9-1f1f1',
    'c': 'flags',
    'o': 2782,
    'sn': ':flag_tl:'
  },
  ':clock1130:': {
    'tn': '11:30 Uhr',
    'uc': '1f566',
    'c': 'symbols',
    'o': 274,
    'sn': ':clock1130:'
  },
  ':fries:': {
    'tn': 'Pommes',
    'uc': '1f35f',
    'c': 'food',
    'o': 1040,
    'sn': ':fries:'
  },
  ':flag_sk:': {
    'tn': 'Fl_Slowakei',
    'uc': '1f1f8-1f1f0',
    'c': 'flags',
    'o': 2756,
    'sn': ':flag_sk:'
  },
  ':blond-haired_woman:': {
    'tn': 'blonde_Frau',
    'uc': '1f471-2640',
    'c': 'people',
    'o': 1481,
    'sn': ':blond-haired_woman:'
  },
  ':classical_building:': {
    'tn': 'Gebäude_Säulen',
    'uc': '1f3db',
    'c': 'travel',
    'o': 2529,
    'sn': ':classical_building:'
  },
  ':flag_pg:': {
    'tn': 'Fl_PapuaNG',
    'uc': '1f1f5-1f1ec',
    'c': 'flags',
    'o': 2733,
    'sn': ':flag_pg:'
  },
  ':crocodile:': {
    'tn': 'Krokodil',
    'uc': '1f40a',
    'c': 'nature',
    'o': 891,
    'sn': ':crocodile:'
  },
  ':telescope:': {
    'tn': 'Teleskop',
    'uc': '1f52d',
    'c': 'objects',
    'o': 704,
    'sn': ':telescope:'
  },
  ':flag_ne:': {
    'tn': 'Fl_Niger',
    'uc': '1f1f3-1f1ea',
    'c': 'flags',
    'o': 2721,
    'sn': ':flag_ne:'
  },
  ':flag_md:': {
    'tn': 'Fl_Moldawien ',
    'uc': '1f1f2-1f1e9',
    'c': 'flags',
    'o': 2706,
    'sn': ':flag_md:'
  },
  ':dog2:': {
    'tn': 'Hund2',
    'uc': '1f415',
    'c': 'nature',
    'o': 912,
    'sn': ':dog2:'
  },
  ':flag_lc:': {
    'tn': 'Fl_StLucia',
    'uc': '1f1f1-1f1e8',
    'c': 'flags',
    'o': 2769,
    'sn': ':flag_lc:'
  },
  ':ribbon:': {
    'tn': 'Schleife',
    'uc': '1f380',
    'c': 'objects',
    'o': 747,
    'sn': ':ribbon:'
  },
  ':sweet_potato:': {
    'tn': 'Süßkartoffel',
    'uc': '1f360',
    'c': 'food',
    'o': 1024,
    'sn': ':sweet_potato:'
  },
  ':fire:': {
    'tn': 'Feuer',
    'uc': '1f525',
    'c': 'nature',
    'o': 974,
    'sn': ':fire:'
  },
  ':thermometer_face:': {
    'tn': 'krank',
    'uc': '1f912',
    'c': 'people',
    'o': 1188,
    'sn': ':thermometer_face:'
  },
  ':flag_white:': {
    'tn': 'Fl_weiß',
    'uc': '1f3f3',
    'c': 'flags',
    'o': 2555,
    'sn': ':flag_white:'
  },
  ':radio_button:': {
    'tn': 'Radio_Knopf',
    'uc': '1f518',
    'c': 'symbols',
    'o': 211,
    'sn': ':radio_button:'
  },
  ':point_left:': {
    'tn': 'zeigen_links',
    'uc': '1f448',
    'c': 'people',
    'o': 1305,
    'sn': ':point_left:'
  },
  ':pineapple:': {
    'tn': 'Ananas',
    'uc': '1f34d',
    'c': 'food',
    'o': 1011,
    'sn': ':pineapple:'
  },
  ':video_game:': {
    'tn': 'Controller',
    'uc': '1f3ae',
    'c': 'activity',
    'o': 614,
    'sn': ':video_game:'
  },
  ':orthodox_cross:': {
    'tn': 'orthodoxes_Kreuz',
    'uc': '2626',
    'c': 'symbols',
    'o': 27,
    'sn': ':orthodox_cross:'
  },
  ':flag_cz:': {
    'tn': 'Fl_Tschechien',
    'uc': '1f1e8-1f1ff',
    'c': 'flags',
    'o': 2621,
    'sn': ':flag_cz:'
  },
  ':nauseated_face:': {
    'tn': 'angewiedert',
    'uc': '1f922',
    'c': 'people',
    'o': 1184,
    'sn': ':nauseated_face:'
  },
  ':round_pushpin:': {
    'tn': 'Reißzwecke2',
    'uc': '1f4cd',
    'c': 'objects',
    'o': 808,
    'sn': ':round_pushpin:'
  },
  ':flag_by:': {
    'tn': 'Fl_Belarus',
    'uc': '1f1e7-1f1fe',
    'c': 'flags',
    'o': 2581,
    'sn': ':flag_by:'
  },
  ':flag_ax:': {
    'tn': 'Fl_AlandIS',
    'uc': '1f1e6-1f1fd',
    'c': 'flags',
    'o': 2562,
    'sn': ':flag_ax:'
  },
  ':zany_face:': {
    'tn': 'verrücktes Gesicht',
    'uc': '1f92a',
    'c': 'people',
    'o': 1128,
    'sn': ':zany_face:'
  },
  ':fingers_crossed:': {
    'tn': 'gekreuzte_Finger',
    'uc': '1f91e',
    'c': 'people',
    'o': 1275,
    'sn': ':fingers_crossed:'
  },
  ':heavy_plus_sign:': {
    'tn': 'Plus',
    'uc': '2795',
    'c': 'symbols',
    'o': 192,
    'sn': ':heavy_plus_sign:'
  },
  ':crossed_swords:': {
    'tn': 'gekreuzte_Schwerter',
    'uc': '2694',
    'c': 'objects',
    'o': 690,
    'sn': ':crossed_swords:'
  },
  ':hibiscus:': {
    'tn': 'Hibiskus',
    'uc': '1f33a',
    'c': 'nature',
    'o': 946,
    'sn': ':hibiscus:'
  },
  ':jack_o_lantern:': {
    'tn': 'Kürbislaterne',
    'uc': '1f383',
    'c': 'people',
    'o': 1204,
    'sn': ':jack_o_lantern:'
  },
  ':baby:': {
    'tn': 'Baby',
    'uc': '1f476',
    'c': 'people',
    'o': 1433,
    'sn': ':baby:'
  },
  ':frowning2:': {
    'tn': 'düster',
    'uc': '2639',
    'c': 'people',
    'o': 1142,
    'sn': ':frowning2:'
  },
  ':statue_of_liberty:': {
    'tn': 'Freiheitsstatue',
    'uc': '1f5fd',
    'c': 'travel',
    'o': 2493,
    'sn': ':statue_of_liberty:'
  },
  ':briefcase:': {
    'tn': 'Brieftasche',
    'uc': '1f4bc',
    'c': 'people',
    'o': 2395,
    'sn': ':briefcase:'
  },
  ':factory:': {
    'tn': 'Fabrik',
    'uc': '1f3ed',
    'c': 'travel',
    'o': 2517,
    'sn': ':factory:'
  },
  ':curly_loop:': {
    'tn': 'Schleife1',
    'uc': '27b0',
    'c': 'symbols',
    'o': 202,
    'sn': ':curly_loop:'
  },
  ':woman_firefighter:': {
    'tn': 'Feuerwehrfrau',
    'uc': '1f469-1f692',
    'c': 'people',
    'o': 1811,
    'sn': ':woman_firefighter:'
  },
  ':couple_with_heart_woman_man:': {
    'tn': 'Pärchen mit Herz',
    'uc': '1f469-2764-1f468',
    'c': 'people',
    'o': 2334,
    'sn': ':couple_with_heart_woman_man:'
  },
  ':salt:': {
    'tn': 'Salz',
    'uc': '1f9c2',
    'c': 'food',
    'o': 1076,
    'sn': ':salt:'
  },
  ':green_heart:': {
    'tn': 'Herz_grün',
    'uc': '1f49a',
    'c': 'symbols',
    'o': 4,
    'sn': ':green_heart:'
  },
  ':cry:': {
    'tn': 'Träne',
    'uc': '1f622',
    'c': 'people',
    'o': 1147,
    'sn': ':cry:'
  },
  ':hourglass_flowing_sand:': {
    'tn': 'Sanduhr_voll',
    'uc': '23f3',
    'c': 'objects',
    'o': 654,
    'sn': ':hourglass_flowing_sand:'
  },
  ':bookmark:': {
    'tn': 'Lesezeichen',
    'uc': '1f516',
    'c': 'objects',
    'o': 800,
    'sn': ':bookmark:'
  },
  ':city_sunset:': {
    'tn': 'Stadt Sonnenuntergang',
    'uc': '1f307',
    'c': 'travel',
    'o': 2546,
    'sn': ':city_sunset:'
  },
  ':lizard:': {
    'tn': 'Eidechse',
    'uc': '1f98e',
    'c': 'nature',
    'o': 876,
    'sn': ':lizard:'
  },
  ':do_not_litter:': {
    'tn': 'keinen_Abfall',
    'uc': '1f6af',
    'c': 'symbols',
    'o': 81,
    'sn': ':do_not_litter:'
  },
  ':kaaba:': {
    'tn': 'Kaaba',
    'uc': '1f54b',
    'c': 'travel',
    'o': 2533,
    'sn': ':kaaba:'
  },
  ':clock1030:': {
    'tn': '10:30 Uhr',
    'uc': '1f565',
    'c': 'symbols',
    'o': 273,
    'sn': ':clock1030:'
  },
  ':athletic_shoe:': {
    'tn': 'Sportschuh',
    'uc': '1f45f',
    'c': 'people',
    'o': 2380,
    'sn': ':athletic_shoe:'
  },
  ':trackball:': {
    'tn': 'Trackball',
    'uc': '1f5b2',
    'c': 'objects',
    'o': 624,
    'sn': ':trackball:'
  },
  ':books:': {
    'tn': 'Bücher',
    'uc': '1f4da',
    'c': 'objects',
    'o': 798,
    'sn': ':books:'
  },
  ':flag_tk:': {
    'tn': 'Fl_Tokelau',
    'uc': '1f1f9-1f1f0',
    'c': 'flags',
    'o': 2784,
    'sn': ':flag_tk:'
  },
  ':flag_sj:': {
    'tn': 'Fl_Svalbard',
    'uc': '1f1f8-1f1ef',
    'c': 'flags',
    'o': 2819,
    'sn': ':flag_sj:'
  },
  ':hand_splayed:': {
    'tn': 'Finger_gespreizt',
    'uc': '1f590',
    'c': 'people',
    'o': 1347,
    'sn': ':hand_splayed:'
  },
  ':musical_keyboard:': {
    'tn': 'Keyboard',
    'uc': '1f3b9',
    'c': 'activity',
    'o': 605,
    'sn': ':musical_keyboard:'
  },
  ':robot:': {
    'tn': 'Roboter',
    'uc': '1f916',
    'c': 'people',
    'o': 1203,
    'sn': ':robot:'
  },
  ':parrot:': {
    'tn': 'Papagei',
    'uc': '1f99c',
    'c': 'nature',
    'o': 854,
    'sn': ':parrot:'
  },
  ':police_officer:': {
    'tn': 'Polizist',
    'uc': '1f46e',
    'c': 'people',
    'o': 1595,
    'sn': ':police_officer:'
  },
  ':flag_mc:': {
    'tn': 'Fl_Monaco',
    'uc': '1f1f2-1f1e8',
    'c': 'flags',
    'o': 2707,
    'sn': ':flag_mc:'
  },
  ':man_vampire:': {
    'tn': 'Vampir_m',
    'uc': '1f9db-2642',
    'c': 'people',
    'o': 1979,
    'sn': ':man_vampire:'
  },
  ':violin:': {
    'tn': 'Violine',
    'uc': '1f3bb',
    'c': 'activity',
    'o': 610,
    'sn': ':violin:'
  },
  ':flag_lb:': {
    'tn': 'Fl_Libanon',
    'uc': '1f1f1-1f1e7',
    'c': 'flags',
    'o': 2684,
    'sn': ':flag_lb:'
  },
  ':u7a7a:': {
    'tn': 'frei',
    'uc': '1f233',
    'c': 'symbols',
    'o': 117,
    'sn': ':u7a7a:'
  },
  ':rainbow_flag:': {
    'tn': 'Fl_Regenbogen',
    'uc': '1f3f3-1f308',
    'c': 'flags',
    'o': 2559,
    'sn': ':rainbow_flag:'
  },
  ':family_man_girl_boy:': {
    'tn': 'Single_Mann_FM',
    'uc': '1f468-1f467-1f466',
    'c': 'people',
    'o': 2364,
    'sn': ':family_man_girl_boy:'
  },
  ':black_small_square:': {
    'tn': 'Quader_klein_schwarz',
    'uc': '25aa',
    'c': 'symbols',
    'o': 224,
    'sn': ':black_small_square:'
  },
  ':minibus:': {
    'tn': 'Minibus',
    'uc': '1f690',
    'c': 'travel',
    'o': 2440,
    'sn': ':minibus:'
  },
  ':whale:': {
    'tn': 'Wal',
    'uc': '1f433',
    'c': 'nature',
    'o': 888,
    'sn': ':whale:'
  },
  ':snail:': {
    'tn': 'Schnecke',
    'uc': '1f40c',
    'c': 'nature',
    'o': 864,
    'sn': ':snail:'
  },
  ':hamburger:': {
    'tn': 'Hamburger',
    'uc': '1f354',
    'c': 'food',
    'o': 1039,
    'sn': ':hamburger:'
  },
  ':mermaid:': {
    'tn': 'Meerjungfrau',
    'uc': '1f9dc-2640',
    'c': 'people',
    'o': 1997,
    'sn': ':mermaid:'
  },
  ':men_with_bunny_ears_partying:': {
    'tn': 'Männer_Haasenohren',
    'uc': '1f46f-2642',
    'c': 'people',
    'o': 2287,
    'sn': ':men_with_bunny_ears_partying:'
  },
  ':womens:': {
    'tn': 'Frauen',
    'uc': '1f6ba',
    'c': 'symbols',
    'o': 124,
    'sn': ':womens:'
  },
  ':eight_spoked_asterisk:': {
    'tn': 'stumpf_Asterisk',
    'uc': '2733',
    'c': 'symbols',
    'o': 106,
    'sn': ':eight_spoked_asterisk:'
  },
  ':flag_dz:': {
    'tn': 'Fl_Algerien',
    'uc': '1f1e9-1f1ff',
    'c': 'flags',
    'o': 2564,
    'sn': ':flag_dz:'
  },
  ':desert:': {
    'tn': 'Wüste',
    'uc': '1f3dc',
    'c': 'travel',
    'o': 2505,
    'sn': ':desert:'
  },
  ':flag_cy:': {
    'tn': 'Fl_Zypern',
    'uc': '1f1e8-1f1fe',
    'c': 'flags',
    'o': 2620,
    'sn': ':flag_cy:'
  },
  ':u55b6:': {
    'tn': 'Arbeit',
    'uc': '1f23a',
    'c': 'symbols',
    'o': 53,
    'sn': ':u55b6:'
  },
  ':thought_balloon:': {
    'tn': 'Denkblase',
    'uc': '1f4ad',
    'c': 'symbols',
    'o': 243,
    'sn': ':thought_balloon:'
  },
  ':alembic:': {
    'tn': 'Destille',
    'uc': '2697',
    'c': 'objects',
    'o': 699,
    'sn': ':alembic:'
  },
  ':dragon_face:': {
    'tn': 'Drache_Gesicht',
    'uc': '1f432',
    'c': 'nature',
    'o': 925,
    'sn': ':dragon_face:'
  },
  ':flag_aw:': {
    'tn': 'Fl_Aruba',
    'uc': '1f1e6-1f1fc',
    'c': 'flags',
    'o': 2573,
    'sn': ':flag_aw:'
  },
  ':woman_supervillain:': {
    'tn': 'Frau_Supervillain',
    'uc': '1f9b9-2640',
    'c': 'people',
    'o': 1920,
    'sn': ':woman_supervillain:'
  },
  ':shaved_ice:': {
    'tn': 'Eisflocken',
    'uc': '1f367',
    'c': 'food',
    'o': 1063,
    'sn': ':shaved_ice:'
  },
  ':prayer_beads:': {
    'tn': 'Rosenkranz',
    'uc': '1f4ff',
    'c': 'objects',
    'o': 697,
    'sn': ':prayer_beads:'
  },
  ':orange_heart:': {
    'tn': 'Herz_orange',
    'uc': '1f9e1',
    'c': 'symbols',
    'o': 2,
    'sn': ':orange_heart:'
  },
  ':arrow_upper_right:': {
    'tn': 'Pfeil_oben_rechts',
    'uc': '2197',
    'c': 'symbols',
    'o': 175,
    'sn': ':arrow_upper_right:'
  },
  ':saxophone:': {
    'tn': 'Saxophon',
    'uc': '1f3b7',
    'c': 'activity',
    'o': 607,
    'sn': ':saxophone:'
  },
  ':file_cabinet:': {
    'tn': 'Aktenschrank',
    'uc': '1f5c4',
    'c': 'objects',
    'o': 784,
    'sn': ':file_cabinet:'
  },
  ':white_medium_small_square:': {
    'tn': 'Quader_mittel_weiß',
    'uc': '25fd',
    'c': 'symbols',
    'o': 227,
    'sn': ':white_medium_small_square:'
  },
  ':zap:': {
    'tn': 'Blitz',
    'uc': '26a1',
    'c': 'nature',
    'o': 971,
    'sn': ':zap:'
  },
  ':anchor:': {
    'tn': 'Anker',
    'uc': '2693',
    'c': 'travel',
    'o': 2485,
    'sn': ':anchor:'
  },
  ':spaghetti:': {
    'tn': 'Spaghetti',
    'uc': '1f35d',
    'c': 'food',
    'o': 1049,
    'sn': ':spaghetti:'
  },
  ':water_buffalo:': {
    'tn': 'Wasserbüffel',
    'uc': '1f403',
    'c': 'nature',
    'o': 903,
    'sn': ':water_buffalo:'
  },
  ':monorail:': {
    'tn': 'Einschienenbahn',
    'uc': '1f69d',
    'c': 'travel',
    'o': 2459,
    'sn': ':monorail:'
  },
  ':page_with_curl:': {
    'tn': 'Seite_gerollt',
    'uc': '1f4c3',
    'c': 'objects',
    'o': 770,
    'sn': ':page_with_curl:'
  },
  ':neutral_face:': {
    'tn': 'neutral',
    'uc': '1f610',
    'c': 'people',
    'o': 1169,
    'sn': ':neutral_face:'
  },
  ':arrow_heading_down:': {
    'tn': 'Pfeil_nach_unten',
    'uc': '2935',
    'c': 'symbols',
    'o': 184,
    'sn': ':arrow_heading_down:'
  },
  ':gemini:': {
    'tn': 'Zwillinge_Zeichen',
    'uc': '264a',
    'c': 'symbols',
    'o': 32,
    'sn': ':gemini:'
  },
  ':incoming_envelope:': {
    'tn': 'Umschlag_Striche',
    'uc': '1f4e8',
    'c': 'objects',
    'o': 756,
    'sn': ':incoming_envelope:'
  },
  ':monkey_face:': {
    'tn': 'Affe_Gesicht',
    'uc': '1f435',
    'c': 'nature',
    'o': 839,
    'sn': ':monkey_face:'
  },
  ':island:': {
    'tn': 'Insel',
    'uc': '1f3dd',
    'c': 'travel',
    'o': 2504,
    'sn': ':island:'
  },
  ':railway_track:': {
    'tn': 'Schienen',
    'uc': '1f6e4',
    'c': 'travel',
    'o': 2535,
    'sn': ':railway_track:'
  },
  ':flag_tj:': {
    'tn': 'Fl_Tadschikistan',
    'uc': '1f1f9-1f1ef',
    'c': 'flags',
    'o': 2779,
    'sn': ':flag_tj:'
  },
  ':flag_si:': {
    'tn': 'Fl_Slovenien',
    'uc': '1f1f8-1f1ee',
    'c': 'flags',
    'o': 2757,
    'sn': ':flag_si:'
  },
  ':woman_bowing:': {
    'tn': 'Frau_bücken',
    'uc': '1f647-2640',
    'c': 'people',
    'o': 2051,
    'sn': ':woman_bowing:'
  },
  ':england:': {
    'tn': 'Fl_England',
    'uc': '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f',
    'c': 'flags',
    'o': 2797,
    'sn': ':england:'
  },
  ':trumpet:': {
    'tn': 'Trompete',
    'uc': '1f3ba',
    'c': 'activity',
    'o': 608,
    'sn': ':trumpet:'
  },
  ':flag_pf:': {
    'tn': 'Fl_FPolynesien',
    'uc': '1f1f5-1f1eb',
    'c': 'flags',
    'o': 2640,
    'sn': ':flag_pf:'
  },
  ':department_store:': {
    'tn': 'Kaufhaus',
    'uc': '1f3ec',
    'c': 'travel',
    'o': 2519,
    'sn': ':department_store:'
  },
  ':flag_nc:': {
    'tn': 'Fl_Neukaledonien',
    'uc': '1f1f3-1f1e8',
    'c': 'flags',
    'o': 2718,
    'sn': ':flag_nc:'
  },
  ':flag_la:': {
    'tn': 'Fl_Laos',
    'uc': '1f1f1-1f1e6',
    'c': 'flags',
    'o': 2682,
    'sn': ':flag_la:'
  },
  ':footprints:': {
    'tn': 'Fußabdrücke',
    'uc': '1f463',
    'c': 'people',
    'o': 1424,
    'sn': ':footprints:'
  },
  ':no_entry_sign:': {
    'tn': 'kein_Zugang2',
    'uc': '1f6ab',
    'c': 'symbols',
    'o': 76,
    'sn': ':no_entry_sign:'
  },
  ':family_woman_boy:': {
    'tn': 'Single_Frau_M',
    'uc': '1f469-1f466',
    'c': 'people',
    'o': 2357,
    'sn': ':family_woman_boy:'
  },
  ':flag_cx:': {
    'tn': 'Fl_Weihnachtsinseln',
    'uc': '1f1e8-1f1fd',
    'c': 'flags',
    'o': 2608,
    'sn': ':flag_cx:'
  },
  ':pizza:': {
    'tn': 'Pizza',
    'uc': '1f355',
    'c': 'food',
    'o': 1041,
    'sn': ':pizza:'
  },
  ':flag_bw:': {
    'tn': 'Fl_Botswana',
    'uc': '1f1e7-1f1fc',
    'c': 'flags',
    'o': 2589,
    'sn': ':flag_bw:'
  },
  ':movie_camera:': {
    'tn': 'Kamera_Film',
    'uc': '1f3a5',
    'c': 'objects',
    'o': 637,
    'sn': ':movie_camera:'
  },
  ':woman_bald:': {
    'tn': 'Frau_kahl',
    'uc': '1f469-1f9b2',
    'c': 'people',
    'o': 1529,
    'sn': ':woman_bald:'
  },
  ':school:': {
    'tn': 'Schule',
    'uc': '1f3eb',
    'c': 'travel',
    'o': 2526,
    'sn': ':school:'
  },
  ':woman_white_haired:': {
    'tn': 'Frau_weißhaarig',
    'uc': '1f469-1f9b3',
    'c': 'people',
    'o': 1517,
    'sn': ':woman_white_haired:'
  },
  ':money_mouth:': {
    'tn': 'Geldgier',
    'uc': '1f911',
    'c': 'people',
    'o': 1190,
    'sn': ':money_mouth:'
  },
  ':smirk:': {
    'tn': 'feixen',
    'uc': '1f60f',
    'c': 'people',
    'o': 1135,
    'sn': ':smirk:'
  },
  ':microphone2:': {
    'tn': 'Mikrofon2',
    'uc': '1f399',
    'c': 'objects',
    'o': 646,
    'sn': ':microphone2:'
  },
  ':woman_in_steamy_room:': {
    'tn': 'Frau_Sauna',
    'uc': '1f9d6-2640',
    'c': 'people',
    'o': 2249,
    'sn': ':woman_in_steamy_room:'
  },
  ':bamboo:': {
    'tn': 'Bambus',
    'uc': '1f38d',
    'c': 'nature',
    'o': 935,
    'sn': ':bamboo:'
  },
  ':full_moon_with_face:': {
    'tn': 'Mond_voll_Gesicht',
    'uc': '1f31d',
    'c': 'nature',
    'o': 951,
    'sn': ':full_moon_with_face:'
  },
  ':rocket:': {
    'tn': 'Rakete',
    'uc': '1f680',
    'c': 'travel',
    'o': 2475,
    'sn': ':rocket:'
  },
  ':space_invader:': {
    'tn': 'space_invader',
    'uc': '1f47e',
    'c': 'people',
    'o': 1202,
    'sn': ':space_invader:'
  },
  ':woman_guard:': {
    'tn': 'Wächterin',
    'uc': '1f482-2640',
    'c': 'people',
    'o': 1637,
    'sn': ':woman_guard:'
  },
  ':arrow_lower_right:': {
    'tn': 'Pfei_unten_rechts',
    'uc': '2198',
    'c': 'symbols',
    'o': 176,
    'sn': ':arrow_lower_right:'
  },
  ':smile:': {
    'tn': 'lächeln',
    'uc': '1f604',
    'c': 'people',
    'o': 1105,
    'sn': ':smile:'
  },
  ':heavy_dollar_sign:': {
    'tn': 'Dollarzeichen',
    'uc': '1f4b2',
    'c': 'symbols',
    'o': 196,
    'sn': ':heavy_dollar_sign:'
  },
  ':bear:': {
    'tn': 'Bär',
    'uc': '1f43b',
    'c': 'nature',
    'o': 828,
    'sn': ':bear:'
  },
  ':tooth:': {
    'tn': 'Zahn',
    'uc': '1f9b7',
    'c': 'people',
    'o': 1429,
    'sn': ':tooth:'
  },
  ':no_entry:': {
    'tn': 'kein_Zugang',
    'uc': '26d4',
    'c': 'symbols',
    'o': 74,
    'sn': ':no_entry:'
  },
  ':fountain:': {
    'tn': 'Springbrunnen',
    'uc': '26f2',
    'c': 'travel',
    'o': 2501,
    'sn': ':fountain:'
  },
  ':dolls:': {
    'tn': 'Puppen',
    'uc': '1f38e',
    'c': 'objects',
    'o': 750,
    'sn': ':dolls:'
  },
  ':flag_sh:': {
    'tn': 'Fl_StHelena',
    'uc': '1f1f8-1f1ed',
    'c': 'flags',
    'o': 2767,
    'sn': ':flag_sh:'
  },
  ':mount_fuji:': {
    'tn': 'Fuji',
    'uc': '1f5fb',
    'c': 'travel',
    'o': 2509,
    'sn': ':mount_fuji:'
  },
  ':woman_getting_haircut:': {
    'tn': 'Frau_Haarschnitt',
    'uc': '1f487-2640',
    'c': 'people',
    'o': 2213,
    'sn': ':woman_getting_haircut:'
  },
  ':european_castle:': {
    'tn': 'Burg',
    'uc': '1f3f0',
    'c': 'travel',
    'o': 2495,
    'sn': ':european_castle:'
  },
  ':flag_pe:': {
    'tn': 'Fl_Peru',
    'uc': '1f1f5-1f1ea',
    'c': 'flags',
    'o': 2735,
    'sn': ':flag_pe:'
  },
  ':man_red_haired:': {
    'tn': 'Mann_rothaarig',
    'uc': '1f468-1f9b0',
    'c': 'people',
    'o': 1499,
    'sn': ':man_red_haired:'
  },
  ':hot_pepper:': {
    'tn': 'Chilli',
    'uc': '1f336',
    'c': 'food',
    'o': 1020,
    'sn': ':hot_pepper:'
  },
  ':train:': {
    'tn': 'Zug',
    'uc': '1f68b',
    'c': 'travel',
    'o': 2457,
    'sn': ':train:'
  },
  ':flag_ma:': {
    'tn': 'Fl_Marokko',
    'uc': '1f1f2-1f1e6',
    'c': 'flags',
    'o': 2711,
    'sn': ':flag_ma:'
  },
  ':man_surfing:': {
    'tn': 'Surfer',
    'uc': '1f3c4-2642',
    'c': 'activity',
    'o': 456,
    'sn': ':man_surfing:'
  },
  ':tickets:': {
    'tn': 'Ticket2',
    'uc': '1f39f',
    'c': 'activity',
    'o': 579,
    'sn': ':tickets:'
  },
  ':virgo:': {
    'tn': 'Jungfrau_Zeichen',
    'uc': '264d',
    'c': 'symbols',
    'o': 35,
    'sn': ':virgo:'
  },
  ':ramen:': {
    'tn': 'Ramen',
    'uc': '1f35c',
    'c': 'food',
    'o': 1050,
    'sn': ':ramen:'
  },
  ':cyclone:': {
    'tn': 'Zyklon_Zeichen',
    'uc': '1f300',
    'c': 'symbols',
    'o': 111,
    'sn': ':cyclone:'
  },
  ':crossed_flags:': {
    'tn': 'Fl_gekreuzt',
    'uc': '1f38c',
    'c': 'flags',
    'o': 2673,
    'sn': ':crossed_flags:'
  },
  ':police_car:': {
    'tn': 'Auto_Polizei',
    'uc': '1f693',
    'c': 'travel',
    'o': 2437,
    'sn': ':police_car:'
  },
  ':key2:': {
    'tn': 'Schlüssel2',
    'uc': '1f5dd',
    'c': 'objects',
    'o': 730,
    'sn': ':key2:'
  },
  ':game_die:': {
    'tn': 'Würfel',
    'uc': '1f3b2',
    'c': 'activity',
    'o': 611,
    'sn': ':game_die:'
  },
  ':copyright:': {
    'tn': 'Urheberrecht',
    'uc': '00a9',
    'c': 'symbols',
    'o': 199,
    'sn': ':copyright:'
  },
  ':sunflower:': {
    'tn': 'Sonnenblume',
    'uc': '1f33b',
    'c': 'nature',
    'o': 949,
    'sn': ':sunflower:'
  },
  ':flag_cw:': {
    'tn': 'Fl_Curacao',
    'uc': '1f1e8-1f1fc',
    'c': 'flags',
    'o': 2619,
    'sn': ':flag_cw:'
  },
  ':monkey:': {
    'tn': 'Affe',
    'uc': '1f412',
    'c': 'nature',
    'o': 843,
    'sn': ':monkey:'
  },
  ':flag_bv:': {
    'tn': 'Fl_Bouvet',
    'uc': '1f1e7-1f1fb',
    'c': 'flags',
    'o': 2813,
    'sn': ':flag_bv:'
  },
  ':microbe:': {
    'tn': 'Mikrobe',
    'uc': '1f9a0',
    'c': 'nature',
    'o': 873,
    'sn': ':microbe:'
  },
  ':woman_pouting:': {
    'tn': 'Frau_schmollt',
    'uc': '1f64e-2640',
    'c': 'people',
    'o': 2177,
    'sn': ':woman_pouting:'
  },
  ':curry:': {
    'tn': 'Curry',
    'uc': '1f35b',
    'c': 'food',
    'o': 1052,
    'sn': ':curry:'
  },
  ':flag_au:': {
    'tn': 'Fl_Australien',
    'uc': '1f1e6-1f1fa',
    'c': 'flags',
    'o': 2574,
    'sn': ':flag_au:'
  },
  ':tiger2:': {
    'tn': 'Tiger',
    'uc': '1f405',
    'c': 'nature',
    'o': 892,
    'sn': ':tiger2:'
  },
  ':potable_water:': {
    'tn': 'Wasserhahn',
    'uc': '1f6b0',
    'c': 'objects',
    'o': 711,
    'sn': ':potable_water:'
  },
  ':anger:': {
    'tn': 'pow',
    'uc': '1f4a2',
    'c': 'symbols',
    'o': 78,
    'sn': ':anger:'
  },
  ':white_sun_rain_cloud:': {
    'tn': 'Sonne_Regen',
    'uc': '1f326',
    'c': 'nature',
    'o': 982,
    'sn': ':white_sun_rain_cloud:'
  },
  ':ant:': {
    'tn': 'Ameise',
    'uc': '1f41c',
    'c': 'nature',
    'o': 867,
    'sn': ':ant:'
  },
  ':french_bread:': {
    'tn': 'Baguette',
    'uc': '1f956',
    'c': 'food',
    'o': 1027,
    'sn': ':french_bread:'
  },
  ':speedboat:': {
    'tn': 'Schnellboot',
    'uc': '1f6a4',
    'c': 'travel',
    'o': 2480,
    'sn': ':speedboat:'
  },
  ':metal:': {
    'tn': 'Metal',
    'uc': '1f918',
    'c': 'people',
    'o': 1293,
    'sn': ':metal:'
  },
  ':nose:': {
    'tn': 'Nase',
    'uc': '1f443',
    'c': 'people',
    'o': 1418,
    'sn': ':nose:'
  },
  ':bookmark_tabs:': {
    'tn': 'Lesezeichen_dig',
    'uc': '1f4d1',
    'c': 'objects',
    'o': 773,
    'sn': ':bookmark_tabs:'
  },
  ':man_construction_worker:': {
    'tn': 'Bauarbeiter_Mann',
    'uc': '1f477-2642',
    'c': 'people',
    'o': 1625,
    'sn': ':man_construction_worker:'
  },
  ':alien:': {
    'tn': 'Alien',
    'uc': '1f47d',
    'c': 'people',
    'o': 1201,
    'sn': ':alien:'
  },
  ':dragon:': {
    'tn': 'Drache',
    'uc': '1f409',
    'c': 'nature',
    'o': 924,
    'sn': ':dragon:'
  },
  ':black_nib:': {
    'tn': 'Füllhalter',
    'uc': '2712',
    'c': 'objects',
    'o': 812,
    'sn': ':black_nib:'
  },
  ':heartpulse:': {
    'tn': 'Puls',
    'uc': '1f497',
    'c': 'symbols',
    'o': 13,
    'sn': ':heartpulse:'
  },
  ':large_blue_diamond:': {
    'tn': 'Viereck_groß_blau',
    'uc': '1f537',
    'c': 'symbols',
    'o': 221,
    'sn': ':large_blue_diamond:'
  },
  ':flag_th:': {
    'tn': 'Fl_Thailand',
    'uc': '1f1f9-1f1ed',
    'c': 'flags',
    'o': 2781,
    'sn': ':flag_th:'
  },
  ':flags:': {
    'tn': 'Fisch-Flaggen',
    'uc': '1f38f',
    'c': 'objects',
    'o': 746,
    'sn': ':flags:'
  },
  ':flag_sg:': {
    'tn': 'Fl_Singapur',
    'uc': '1f1f8-1f1ec',
    'c': 'flags',
    'o': 2754,
    'sn': ':flag_sg:'
  },
  ':black_medium_square:': {
    'tn': 'Quader_mittel_schwarz2',
    'uc': '25fc',
    'c': 'symbols',
    'o': 228,
    'sn': ':black_medium_square:'
  },
  ':man_genie:': {
    'tn': 'Geist',
    'uc': '1f9de-2642',
    'c': 'people',
    'o': 1990,
    'sn': ':man_genie:'
  },
  ':dark_sunglasses:': {
    'tn': 'Sonnenbrille',
    'uc': '1f576',
    'c': 'people',
    'o': 2398,
    'sn': ':dark_sunglasses:'
  },
  ':goal:': {
    'tn': 'Tor',
    'uc': '1f945',
    'c': 'activity',
    'o': 302,
    'sn': ':goal:'
  },
  ':motor_scooter:': {
    'tn': 'Motorroller',
    'uc': '1f6f5',
    'c': 'travel',
    'o': 2446,
    'sn': ':motor_scooter:'
  },
  ':bath:': {
    'tn': 'Badewanne2',
    'uc': '1f6c0',
    'c': 'objects',
    'o': 714,
    'sn': ':bath:'
  },
  ':stew:': {
    'tn': 'Eintopf',
    'uc': '1f372',
    'c': 'food',
    'o': 1051,
    'sn': ':stew:'
  },
  ':non-potable_water:': {
    'tn': 'kein_Trinkwasser',
    'uc': '1f6b1',
    'c': 'symbols',
    'o': 83,
    'sn': ':non-potable_water:'
  },
  ':curly_haired:': {
    'tn': 'lockiges Haar',
    'uc': '1f9b1',
    'c': 'people',
    'o': 2402,
    'sn': ':curly_haired:'
  },
  ':asterisk:': {
    'tn': '*',
    'uc': '002a-20e3',
    'c': 'symbols',
    'o': 155,
    'sn': ':asterisk:'
  },
  ':canoe:': {
    'tn': 'Kanu',
    'uc': '1f6f6',
    'c': 'travel',
    'o': 2478,
    'sn': ':canoe:'
  },
  ':red_car:': {
    'tn': 'Auto_rot',
    'uc': '1f697',
    'c': 'travel',
    'o': 2431,
    'sn': ':red_car:'
  },
  ':wolf:': {
    'tn': 'Wolf',
    'uc': '1f43a',
    'c': 'nature',
    'o': 857,
    'sn': ':wolf:'
  },
  ':star:': {
    'tn': 'Stern',
    'uc': '2b50',
    'c': 'nature',
    'o': 968,
    'sn': ':star:'
  },
  ':airplane:': {
    'tn': 'Flugzeug',
    'uc': '2708',
    'c': 'travel',
    'o': 2468,
    'sn': ':airplane:'
  },
  ':thermometer:': {
    'tn': 'Thermometer',
    'uc': '1f321',
    'c': 'objects',
    'o': 709,
    'sn': ':thermometer:'
  },
  ':bricks:': {
    'tn': 'Ziegelsteine',
    'uc': '1f9f1',
    'c': 'objects',
    'o': 675,
    'sn': ':bricks:'
  },
  ':aries:': {
    'tn': 'Widder_Zeichen',
    'uc': '2648',
    'c': 'symbols',
    'o': 30,
    'sn': ':aries:'
  },
  ':right_facing_fist:': {
    'tn': 'Faust_nach_rechts',
    'uc': '1f91c',
    'c': 'people',
    'o': 1269,
    'sn': ':right_facing_fist:'
  },
  ':heart_eyes_cat:': {
    'tn': 'Herzaugen_Katze',
    'uc': '1f63b',
    'c': 'people',
    'o': 1208,
    'sn': ':heart_eyes_cat:'
  },
  ':compression:': {
    'tn': 'Kompression',
    'uc': '1f5dc',
    'c': 'objects',
    'o': 628,
    'sn': ':compression:'
  },
  ':see_no_evil:': {
    'tn': 'sehe_nichts',
    'uc': '1f648',
    'c': 'nature',
    'o': 840,
    'sn': ':see_no_evil:'
  },
  ':mage:': {
    'tn': 'Magier',
    'uc': '1f9d9',
    'c': 'people',
    'o': 1931,
    'sn': ':mage:'
  },
  ':flag_cv:': {
    'tn': 'Fl_KapVerde',
    'uc': '1f1e8-1f1fb',
    'c': 'flags',
    'o': 2601,
    'sn': ':flag_cv:'
  },
  ':woman_police_officer:': {
    'tn': 'Polizistin',
    'uc': '1f46e-2640',
    'c': 'people',
    'o': 1601,
    'sn': ':woman_police_officer:'
  },
  ':roll_of_paper:': {
    'tn': 'Papierrolle',
    'uc': '1f9fb',
    'c': 'objects',
    'o': 722,
    'sn': ':roll_of_paper:'
  },
  ':speech_balloon:': {
    'tn': 'Sprechblase_weiß',
    'uc': '1f4ac',
    'c': 'symbols',
    'o': 242,
    'sn': ':speech_balloon:'
  },
  ':flag_at:': {
    'tn': 'Fl_Österreich',
    'uc': '1f1e6-1f1f9',
    'c': 'flags',
    'o': 2575,
    'sn': ':flag_at:'
  },
  ':heart:': {
    'tn': 'Herz',
    'uc': '2764',
    'c': 'symbols',
    'o': 1,
    'sn': ':heart:'
  },
  ':bento:': {
    'tn': 'Bento',
    'uc': '1f371',
    'c': 'food',
    'o': 1054,
    'sn': ':bento:'
  },
  ':woman_gesturing_ok:': {
    'tn': 'Frau_ok',
    'uc': '1f646-2640',
    'c': 'people',
    'o': 2105,
    'sn': ':woman_gesturing_ok:'
  },
  ':japan:': {
    'tn': 'Japan',
    'uc': '1f5fe',
    'c': 'travel',
    'o': 2537,
    'sn': ':japan:'
  },
  ':nine:': {
    'tn': '9',
    'uc': '0039-20e3',
    'c': 'symbols',
    'o': 151,
    'sn': ':nine:'
  },
  ':one:': {
    'tn': '1',
    'uc': '0031-20e3',
    'c': 'symbols',
    'o': 143,
    'sn': ':one:'
  },
  ':mega:': {
    'tn': 'Sprachrohr',
    'uc': '1f4e3',
    'c': 'symbols',
    'o': 238,
    'sn': ':mega:'
  },
  ':man_climbing:': {
    'tn': 'Mann_Klettern',
    'uc': '1f9d7-2642',
    'c': 'activity',
    'o': 528,
    'sn': ':man_climbing:'
  },
  ':disappointed:': {
    'tn': 'enttäuscht',
    'uc': '1f61e',
    'c': 'people',
    'o': 1137,
    'sn': ':disappointed:'
  },
  ':black_heart:': {
    'tn': 'Herz_schwarz',
    'uc': '1f5a4',
    'c': 'symbols',
    'o': 7,
    'sn': ':black_heart:'
  },
  ':ice_skate:': {
    'tn': 'Schlittschuh',
    'uc': '26f8',
    'c': 'activity',
    'o': 315,
    'sn': ':ice_skate:'
  },
  ':flag_zm:': {
    'tn': 'Fl_Zambia',
    'uc': '1f1ff-1f1f2',
    'c': 'flags',
    'o': 2810,
    'sn': ':flag_zm:'
  },
  ':grey_question:': {
    'tn': 'Fragezeichen_grau',
    'uc': '2754',
    'c': 'symbols',
    'o': 90,
    'sn': ':grey_question:'
  },
  ':flag_xk:': {
    'tn': 'Fl_Kosovo',
    'uc': '1f1fd-1f1f0',
    'c': 'flags',
    'o': 2679,
    'sn': ':flag_xk:'
  },
  ':writing_hand:': {
    'tn': 'Schreibende Hand',
    'uc': '270d',
    'c': 'people',
    'o': 1395,
    'sn': ':writing_hand:'
  },
  ':zebra:': {
    'tn': 'Zebra',
    'uc': '1f993',
    'c': 'nature',
    'o': 894,
    'sn': ':zebra:'
  },
  ':sob:': {
    'tn': 'weinen',
    'uc': '1f62d',
    'c': 'people',
    'o': 1148,
    'sn': ':sob:'
  },
  ':badminton:': {
    'tn': 'Badminton',
    'uc': '1f3f8',
    'c': 'activity',
    'o': 301,
    'sn': ':badminton:'
  },
  ':flag_vi:': {
    'tn': 'Fl_VirginIS',
    'uc': '1f1fb-1f1ee',
    'c': 'flags',
    'o': 2791,
    'sn': ':flag_vi:'
  },
  ':cruise_ship:': {
    'tn': 'Kreuzfahrtschiff',
    'uc': '1f6f3',
    'c': 'travel',
    'o': 2482,
    'sn': ':cruise_ship:'
  },
  ':bellhop:': {
    'tn': 'Tischklingel',
    'uc': '1f6ce',
    'c': 'objects',
    'o': 728,
    'sn': ':bellhop:'
  },
  ':raised_back_of_hand:': {
    'tn': 'Handrücken_erhoben',
    'uc': '1f91a',
    'c': 'people',
    'o': 1341,
    'sn': ':raised_back_of_hand:'
  },
  ':dash:': {
    'tn': 'Böe',
    'uc': '1f4a8',
    'c': 'nature',
    'o': 991,
    'sn': ':dash:'
  },
  ':bride_with_veil:': {
    'tn': 'Braut_Schleier',
    'uc': '1f470',
    'c': 'people',
    'o': 1859,
    'sn': ':bride_with_veil:'
  },
  ':package:': {
    'tn': 'Packet',
    'uc': '1f4e6',
    'c': 'objects',
    'o': 761,
    'sn': ':package:'
  },
  ':flag_tg:': {
    'tn': 'Fl_Togo',
    'uc': '1f1f9-1f1ec',
    'c': 'flags',
    'o': 2783,
    'sn': ':flag_tg:'
  },
  ':beginner:': {
    'tn': 'Anfänger',
    'uc': '1f530',
    'c': 'symbols',
    'o': 100,
    'sn': ':beginner:'
  },
  ':eight_pointed_black_star:': {
    'tn': 'spitz_Asterisk',
    'uc': '2734',
    'c': 'symbols',
    'o': 55,
    'sn': ':eight_pointed_black_star:'
  },
  ':chains:': {
    'tn': 'Ketten',
    'uc': '26d3',
    'c': 'objects',
    'o': 685,
    'sn': ':chains:'
  },
  ':pleading_face:': {
    'tn': 'bittendes Gesicht',
    'uc': '1f97a',
    'c': 'people',
    'o': 1160,
    'sn': ':pleading_face:'
  },
  ':flag_re:': {
    'tn': 'Fl_Reunion',
    'uc': '1f1f7-1f1ea',
    'c': 'flags',
    'o': 2742,
    'sn': ':flag_re:'
  },
  ':sagittarius:': {
    'tn': 'Schütze_Zeichen',
    'uc': '2650',
    'c': 'symbols',
    'o': 38,
    'sn': ':sagittarius:'
  },
  ':fried_shrimp:': {
    'tn': 'Garnele_fritiert',
    'uc': '1f364',
    'c': 'food',
    'o': 1055,
    'sn': ':fried_shrimp:'
  },
  ':open_mouth:': {
    'tn': 'offener_Mund',
    'uc': '1f62e',
    'c': 'people',
    'o': 1176,
    'sn': ':open_mouth:'
  },
  ':breast_feeding:': {
    'tn': 'Stillen',
    'uc': '1f931',
    'c': 'people',
    'o': 2039,
    'sn': ':breast_feeding:'
  },
  ':boot:': {
    'tn': 'Stiefel',
    'uc': '1f462',
    'c': 'people',
    'o': 2378,
    'sn': ':boot:'
  },
  ':arrow_right:': {
    'tn': 'Pfeil_rechts',
    'uc': '27a1',
    'c': 'symbols',
    'o': 171,
    'sn': ':arrow_right:'
  },
  ':flag_na:': {
    'tn': 'Fl_Namibia',
    'uc': '1f1f3-1f1e6',
    'c': 'flags',
    'o': 2714,
    'sn': ':flag_na:'
  },
  ':five:': {
    'tn': '5',
    'uc': '0035-20e3',
    'c': 'symbols',
    'o': 147,
    'sn': ':five:'
  },
  ':japanese_castle:': {
    'tn': 'Japanisches Schloss',
    'uc': '1f3ef',
    'c': 'travel',
    'o': 2496,
    'sn': ':japanese_castle:'
  },
  ':boxing_glove:': {
    'tn': 'Boxhandschuh',
    'uc': '1f94a',
    'c': 'activity',
    'o': 311,
    'sn': ':boxing_glove:'
  },
  ':egg:': {
    'tn': 'Ei',
    'uc': '1f95a',
    'c': 'food',
    'o': 1031,
    'sn': ':egg:'
  },
  ':motorcycle:': {
    'tn': 'Motorrad',
    'uc': '1f3cd',
    'c': 'travel',
    'o': 2447,
    'sn': ':motorcycle:'
  },
  ':elephant:': {
    'tn': 'Elefant',
    'uc': '1f418',
    'c': 'nature',
    'o': 896,
    'sn': ':elephant:'
  },
  ':flag_gy:': {
    'tn': 'Fl_Guyana',
    'uc': '1f1ec-1f1fe',
    'c': 'flags',
    'o': 2657,
    'sn': ':flag_gy:'
  },
  ':coffin:': {
    'tn': 'Sarg',
    'uc': '26b0',
    'c': 'objects',
    'o': 693,
    'sn': ':coffin:'
  },
  ':swan:': {
    'tn': 'Schwan',
    'uc': '1f9a2',
    'c': 'nature',
    'o': 851,
    'sn': ':swan:'
  },
  ':arrow_up:': {
    'tn': 'Pfeil_hoch',
    'uc': '2b06',
    'c': 'symbols',
    'o': 173,
    'sn': ':arrow_up:'
  },
  ':flying_disc:': {
    'tn': 'fliegende Scheibe',
    'uc': '1f94f',
    'c': 'activity',
    'o': 308,
    'sn': ':flying_disc:'
  },
  ':flag_cu:': {
    'tn': 'Fl_Kuba',
    'uc': '1f1e8-1f1fa',
    'c': 'flags',
    'o': 2618,
    'sn': ':flag_cu:'
  },
  ':mouse:': {
    'tn': 'Maus',
    'uc': '1f42d',
    'c': 'nature',
    'o': 823,
    'sn': ':mouse:'
  },
  ':japanese_goblin:': {
    'tn': 'japanischer_Goblin',
    'uc': '1f47a',
    'c': 'people',
    'o': 1195,
    'sn': ':japanese_goblin:'
  },
  ':flag_bt:': {
    'tn': 'Fl_Bhutan',
    'uc': '1f1e7-1f1f9',
    'c': 'flags',
    'o': 2586,
    'sn': ':flag_bt:'
  },
  ':atom:': {
    'tn': 'Atom',
    'uc': '269b',
    'c': 'symbols',
    'o': 43,
    'sn': ':atom:'
  },
  ':candy:': {
    'tn': 'Bonbon',
    'uc': '1f36c',
    'c': 'food',
    'o': 1073,
    'sn': ':candy:'
  },
  ':white_flower:': {
    'tn': 'Kirschblüte',
    'uc': '1f4ae',
    'c': 'symbols',
    'o': 57,
    'sn': ':white_flower:'
  },
  ':flag_as:': {
    'tn': 'Fl_Samoa2',
    'uc': '1f1e6-1f1f8',
    'c': 'flags',
    'o': 2565,
    'sn': ':flag_as:'
  },
  ':skull_crossbones:': {
    'tn': 'Totenkopf',
    'uc': '2620',
    'c': 'people',
    'o': 1200,
    'sn': ':skull_crossbones:'
  },
  ':face_vomiting:': {
    'tn': 'brechen',
    'uc': '1f92e',
    'c': 'people',
    'o': 1185,
    'sn': ':face_vomiting:'
  },
  ':man_shrugging:': {
    'tn': 'Mann_keine_Ahnung',
    'uc': '1f937-2642',
    'c': 'people',
    'o': 2165,
    'sn': ':man_shrugging:'
  },
  ':rugby_football:': {
    'tn': 'Ball_Rugby',
    'uc': '1f3c9',
    'c': 'activity',
    'o': 298,
    'sn': ':rugby_football:'
  },
  ':shark:': {
    'tn': 'Hai',
    'uc': '1f988',
    'c': 'nature',
    'o': 890,
    'sn': ':shark:'
  },
  ':speak_no_evil:': {
    'tn': 'spreche_nicht',
    'uc': '1f64a',
    'c': 'nature',
    'o': 842,
    'sn': ':speak_no_evil:'
  },
  ':cinema:': {
    'tn': 'Kino',
    'uc': '1f3a6',
    'c': 'symbols',
    'o': 128,
    'sn': ':cinema:'
  },
  ':left_facing_fist:': {
    'tn': 'Faust_nach_links',
    'uc': '1f91b',
    'c': 'people',
    'o': 1263,
    'sn': ':left_facing_fist:'
  },
  ':ping_pong:': {
    'tn': 'Tischtennis',
    'uc': '1f3d3',
    'c': 'activity',
    'o': 300,
    'sn': ':ping_pong:'
  },
  ':asterisk_symbol:': {
    'tn': 'Sternchen-Symbol',
    'uc': '002a',
    'c': 'symbols',
    'o': 287,
    'sn': ':asterisk_symbol:'
  },
  ':family_mwgg:': {
    'tn': 'Familie_MFFF',
    'uc': '1f468-1f469-1f467-1f467',
    'c': 'people',
    'o': 2346,
    'sn': ':family_mwgg:'
  },
  ':lab_coat:': {
    'tn': 'Laborkittel',
    'uc': '1f97c',
    'c': 'people',
    'o': 2375,
    'sn': ':lab_coat:'
  },
  ':pencil2:': {
    'tn': 'Stift2',
    'uc': '270f',
    'c': 'objects',
    'o': 816,
    'sn': ':pencil2:'
  },
  ':hippopotamus:': {
    'tn': 'Nilpferd',
    'uc': '1f99b',
    'c': 'nature',
    'o': 898,
    'sn': ':hippopotamus:'
  },
  ':timer:': {
    'tn': 'Timer',
    'uc': '23f2',
    'c': 'objects',
    'o': 650,
    'sn': ':timer:'
  },
  ':smiley:': {
    'tn': 'smiley',
    'uc': '1f603',
    'c': 'people',
    'o': 1104,
    'sn': ':smiley:'
  },
  ':sailboat:': {
    'tn': 'Segelboot',
    'uc': '26f5',
    'c': 'travel',
    'o': 2479,
    'sn': ':sailboat:'
  },
  ':expressionless:': {
    'tn': 'ausdruckslos',
    'uc': '1f611',
    'c': 'people',
    'o': 1170,
    'sn': ':expressionless:'
  },
  ':family_mwbb:': {
    'tn': 'Familie_MFMM',
    'uc': '1f468-1f469-1f466-1f466',
    'c': 'people',
    'o': 2345,
    'sn': ':family_mwbb:'
  },
  ':flag_ug:': {
    'tn': 'Fl_Uganda',
    'uc': '1f1fa-1f1ec',
    'c': 'flags',
    'o': 2793,
    'sn': ':flag_ug:'
  },
  ':mailbox_with_mail:': {
    'tn': 'Briefkasten_voll',
    'uc': '1f4ec',
    'c': 'objects',
    'o': 765,
    'sn': ':mailbox_with_mail:'
  },
  ':guard:': {
    'tn': 'Wächter',
    'uc': '1f482',
    'c': 'people',
    'o': 1631,
    'sn': ':guard:'
  },
  ':rice_ball:': {
    'tn': 'Reisball',
    'uc': '1f359',
    'c': 'food',
    'o': 1056,
    'sn': ':rice_ball:'
  },
  ':mrs_claus:': {
    'tn': 'Nikolaus_Frau',
    'uc': '1f936',
    'c': 'people',
    'o': 1883,
    'sn': ':mrs_claus:'
  },
  ':keycap_ten:': {
    'tn': '10',
    'uc': '1f51f',
    'c': 'symbols',
    'o': 152,
    'sn': ':keycap_ten:'
  },
  ':knife:': {
    'tn': 'Messer',
    'uc': '1f52a',
    'c': 'objects',
    'o': 688,
    'sn': ':knife:'
  },
  ':flag_tf:': {
    'tn': 'Fl_SFT',
    'uc': '1f1f9-1f1eb',
    'c': 'flags',
    'o': 2641,
    'sn': ':flag_tf:'
  },
  ':flag_se:': {
    'tn': 'Fl_Schweden',
    'uc': '1f1f8-1f1ea',
    'c': 'flags',
    'o': 2775,
    'sn': ':flag_se:'
  },
  ':clapper:': {
    'tn': 'Filmklappe',
    'uc': '1f3ac',
    'c': 'activity',
    'o': 601,
    'sn': ':clapper:'
  },
  ':muscle:': {
    'tn': 'Muskeln',
    'uc': '1f4aa',
    'c': 'people',
    'o': 1371,
    'sn': ':muscle:'
  },
  ':woman_teacher:': {
    'tn': 'Lehrerin',
    'uc': '1f469-1f3eb',
    'c': 'people',
    'o': 1727,
    'sn': ':woman_teacher:'
  },
  ':straight_ruler:': {
    'tn': 'Lineal',
    'uc': '1f4cf',
    'c': 'objects',
    'o': 805,
    'sn': ':straight_ruler:'
  },
  ':aquarius:': {
    'tn': 'Wassermann_Zeichen',
    'uc': '2652',
    'c': 'symbols',
    'o': 40,
    'sn': ':aquarius:'
  },
  ':scarf:': {
    'tn': 'Schal',
    'uc': '1f9e3',
    'c': 'people',
    'o': 2385,
    'sn': ':scarf:'
  },
  ':construction:': {
    'tn': 'Absperrung',
    'uc': '1f6a7',
    'c': 'travel',
    'o': 2487,
    'sn': ':construction:'
  },
  ':chipmunk:': {
    'tn': 'Streifenhörnchen',
    'uc': '1f43f',
    'c': 'nature',
    'o': 921,
    'sn': ':chipmunk:'
  },
  ':people_wrestling:': {
    'tn': 'Leute_Ringen',
    'uc': '1f93c',
    'c': 'activity',
    'o': 344,
    'sn': ':people_wrestling:'
  },
  ':rat:': {
    'tn': 'Ratte',
    'uc': '1f400',
    'c': 'nature',
    'o': 920,
    'sn': ':rat:'
  },
  ':point_down:': {
    'tn': 'zeigen_unten',
    'uc': '1f447',
    'c': 'people',
    'o': 1323,
    'sn': ':point_down:'
  },
  ':ring:': {
    'tn': 'Ring',
    'uc': '1f48d',
    'c': 'people',
    'o': 1407,
    'sn': ':ring:'
  },
  ':kissing:': {
    'tn': 'Kuss',
    'uc': '1f617',
    'c': 'people',
    'o': 1121,
    'sn': ':kissing:'
  },
  ':owl:': {
    'tn': 'Eule',
    'uc': '1f989',
    'c': 'nature',
    'o': 853,
    'sn': ':owl:'
  },
  ':telephone:': {
    'tn': 'Telefon',
    'uc': '260e',
    'c': 'objects',
    'o': 641,
    'sn': ':telephone:'
  },
  ':speech_left:': {
    'tn': 'Sprechblase_schwarz',
    'uc': '1f5e8',
    'c': 'symbols',
    'o': 240,
    'sn': ':speech_left:'
  },
  ':flag_bs:': {
    'tn': 'Fl_Bahamas',
    'uc': '1f1e7-1f1f8',
    'c': 'flags',
    'o': 2577,
    'sn': ':flag_bs:'
  },
  ':flag_ar:': {
    'tn': 'Fl_Argentinien',
    'uc': '1f1e6-1f1f7',
    'c': 'flags',
    'o': 2571,
    'sn': ':flag_ar:'
  },
  ':gift:': {
    'tn': 'Geschenk',
    'uc': '1f381',
    'c': 'objects',
    'o': 744,
    'sn': ':gift:'
  },
  ':woman_curly_haired:': {
    'tn': 'Frau_lockige_Haare',
    'uc': '1f469-1f9b1',
    'c': 'people',
    'o': 1505,
    'sn': ':woman_curly_haired:'
  },
  ':crab:': {
    'tn': 'Krabbe',
    'uc': '1f980',
    'c': 'nature',
    'o': 882,
    'sn': ':crab:'
  },
  ':thinking:': {
    'tn': 'nachdenken',
    'uc': '1f914',
    'c': 'people',
    'o': 1164,
    'sn': ':thinking:'
  },
  ':kiwi:': {
    'tn': 'Kiwi',
    'uc': '1f95d',
    'c': 'food',
    'o': 1013,
    'sn': ':kiwi:'
  },
  ':bullettrain_side:': {
    'tn': 'Magnetschwebebahn 1',
    'uc': '1f684',
    'c': 'travel',
    'o': 2460,
    'sn': ':bullettrain_side:'
  },
  ':beer:': {
    'tn': 'Bier',
    'uc': '1f37a',
    'c': 'food',
    'o': 1089,
    'sn': ':beer:'
  },
  ':secret:': {
    'tn': 'Geheimnis',
    'uc': '3299',
    'c': 'symbols',
    'o': 59,
    'sn': ':secret:'
  },
  ':anger_right:': {
    'tn': 'Wutblase',
    'uc': '1f5ef',
    'c': 'symbols',
    'o': 244,
    'sn': ':anger_right:'
  },
  ':calling:': {
    'tn': 'Anruf',
    'uc': '1f4f2',
    'c': 'objects',
    'o': 618,
    'sn': ':calling:'
  },
  ':horse_racing:': {
    'tn': 'Pferderennen',
    'uc': '1f3c7',
    'c': 'activity',
    'o': 420,
    'sn': ':horse_racing:'
  },
  ':flag_vg:': {
    'tn': 'Fl_Virgin',
    'uc': '1f1fb-1f1ec',
    'c': 'flags',
    'o': 2592,
    'sn': ':flag_vg:'
  },
  ':trophy:': {
    'tn': 'Trophäe',
    'uc': '1f3c6',
    'c': 'activity',
    'o': 570,
    'sn': ':trophy:'
  },
  ':ballot_box:': {
    'tn': 'Wahlurne',
    'uc': '1f5f3',
    'c': 'objects',
    'o': 783,
    'sn': ':ballot_box:'
  },
  ':waxing_crescent_moon:': {
    'tn': 'Mond_zunehmend_halb',
    'uc': '1f312',
    'c': 'nature',
    'o': 960,
    'sn': ':waxing_crescent_moon:'
  },
  ':mosque:': {
    'tn': 'Moschee',
    'uc': '1f54c',
    'c': 'travel',
    'o': 2531,
    'sn': ':mosque:'
  },
  ':bangbang:': {
    'tn': 'Ausrufezeichen2',
    'uc': '203c',
    'c': 'symbols',
    'o': 91,
    'sn': ':bangbang:'
  },
  ':wavy_dash:': {
    'tn': 'Wellenlinie',
    'uc': '3030',
    'c': 'symbols',
    'o': 201,
    'sn': ':wavy_dash:'
  },
  ':baseball:': {
    'tn': 'Ball_Baseball',
    'uc': '26be',
    'c': 'activity',
    'o': 294,
    'sn': ':baseball:'
  },
  ':grin:': {
    'tn': 'grinser',
    'uc': '1f601',
    'c': 'people',
    'o': 1106,
    'sn': ':grin:'
  },
  ':flag_sd:': {
    'tn': 'Fl_Sudan',
    'uc': '1f1f8-1f1e9',
    'c': 'flags',
    'o': 2772,
    'sn': ':flag_sd:'
  },
  ':passport_control:': {
    'tn': 'Passkontrolle',
    'uc': '1f6c2',
    'c': 'symbols',
    'o': 119,
    'sn': ':passport_control:'
  },
  ':black_circle:': {
    'tn': 'Kreis_schwarz',
    'uc': '26ab',
    'c': 'symbols',
    'o': 213,
    'sn': ':black_circle:'
  },
  ':woman_health_worker:': {
    'tn': 'Frau_MFA',
    'uc': '1f469-2695',
    'c': 'people',
    'o': 1667,
    'sn': ':woman_health_worker:'
  },
  ':page_facing_up:': {
    'tn': 'Seite',
    'uc': '1f4c4',
    'c': 'objects',
    'o': 771,
    'sn': ':page_facing_up:'
  },
  ':flag_pa:': {
    'tn': 'Fl_Panama',
    'uc': '1f1f5-1f1e6',
    'c': 'flags',
    'o': 2732,
    'sn': ':flag_pa:'
  },
  ':mountain_cableway:': {
    'tn': 'Gondel2',
    'uc': '1f6a0',
    'c': 'travel',
    'o': 2454,
    'sn': ':mountain_cableway:'
  },
  ':envelope:': {
    'tn': 'Umschlag',
    'uc': '2709',
    'c': 'objects',
    'o': 754,
    'sn': ':envelope:'
  },
  ':eagle:': {
    'tn': 'Adler',
    'uc': '1f985',
    'c': 'nature',
    'o': 852,
    'sn': ':eagle:'
  },
  ':woman_factory_worker:': {
    'tn': 'Fabrikarbeiterin',
    'uc': '1f469-1f3ed',
    'c': 'people',
    'o': 1739,
    'sn': ':woman_factory_worker:'
  },
  ':meat_on_bone:': {
    'tn': 'Haxe',
    'uc': '1f356',
    'c': 'food',
    'o': 1037,
    'sn': ':meat_on_bone:'
  },
  ':woman_office_worker:': {
    'tn': 'Beamte',
    'uc': '1f469-1f4bc',
    'c': 'people',
    'o': 1763,
    'sn': ':woman_office_worker:'
  },
  ':vibration_mode:': {
    'tn': 'vibration',
    'uc': '1f4f3',
    'c': 'symbols',
    'o': 49,
    'sn': ':vibration_mode:'
  },
  ':microscope:': {
    'tn': 'Mikroskop',
    'uc': '1f52c',
    'c': 'objects',
    'o': 705,
    'sn': ':microscope:'
  },
  ':united_nations:': {
    'tn': 'Fl_UN',
    'uc': '1f1fa-1f1f3',
    'c': 'flags',
    'o': 2822,
    'sn': ':united_nations:'
  },
  ':hot_face:': {
    'tn': 'heißes Gesicht',
    'uc': '1f975',
    'c': 'people',
    'o': 1158,
    'sn': ':hot_face:'
  },
  ':earth_africa:': {
    'tn': 'Erde_Afrika',
    'uc': '1f30d',
    'c': 'nature',
    'o': 965,
    'sn': ':earth_africa:'
  },
  ':flag_gw:': {
    'tn': 'Fl_GuineaBissau',
    'uc': '1f1ec-1f1fc',
    'c': 'flags',
    'o': 2656,
    'sn': ':flag_gw:'
  },
  ':flushed:': {
    'tn': 'errötet',
    'uc': '1f633',
    'c': 'people',
    'o': 1154,
    'sn': ':flushed:'
  },
  ':strawberry:': {
    'tn': 'Erdbeere',
    'uc': '1f353',
    'c': 'food',
    'o': 1006,
    'sn': ':strawberry:'
  },
  ':inbox_tray:': {
    'tn': 'Posteingang',
    'uc': '1f4e5',
    'c': 'objects',
    'o': 759,
    'sn': ':inbox_tray:'
  },
  ':restroom:': {
    'tn': 'Toiletten',
    'uc': '1f6bb',
    'c': 'symbols',
    'o': 126,
    'sn': ':restroom:'
  },
  ':flag_eu:': {
    'tn': 'Fl_Europa',
    'uc': '1f1ea-1f1fa',
    'c': 'flags',
    'o': 2633,
    'sn': ':flag_eu:'
  },
  ':bacon:': {
    'tn': 'Speck',
    'uc': '1f953',
    'c': 'food',
    'o': 1034,
    'sn': ':bacon:'
  },
  ':gear:': {
    'tn': 'Zahnrad',
    'uc': '2699',
    'c': 'objects',
    'o': 684,
    'sn': ':gear:'
  },
  ':cup_with_straw:': {
    'tn': 'Becher_Strohhalm',
    'uc': '1f964',
    'c': 'food',
    'o': 1087,
    'sn': ':cup_with_straw:'
  },
  ':blue_car:': {
    'tn': 'Auto_blau',
    'uc': '1f699',
    'c': 'travel',
    'o': 2433,
    'sn': ':blue_car:'
  },
  ':musical_score:': {
    'tn': 'Violinenschlüssel',
    'uc': '1f3bc',
    'c': 'activity',
    'o': 604,
    'sn': ':musical_score:'
  },
  ':scream:': {
    'tn': 'Schrei',
    'uc': '1f631',
    'c': 'people',
    'o': 1155,
    'sn': ':scream:'
  },
  ':name_badge:': {
    'tn': 'Namensschild',
    'uc': '1f4db',
    'c': 'symbols',
    'o': 75,
    'sn': ':name_badge:'
  },
  ':family_man_woman_boy:': {
    'tn': 'Familie',
    'uc': '1f468-1f469-1f466',
    'c': 'people',
    'o': 2342,
    'sn': ':family_man_woman_boy:'
  },
  ':rose:': {
    'tn': 'Rose',
    'uc': '1f339',
    'c': 'nature',
    'o': 944,
    'sn': ':rose:'
  },
  ':flag_br:': {
    'tn': 'Fl_Brasilien',
    'uc': '1f1e7-1f1f7',
    'c': 'flags',
    'o': 2590,
    'sn': ':flag_br:'
  },
  ':flag_aq:': {
    'tn': 'Fl_Antarktis',
    'uc': '1f1e6-1f1f6',
    'c': 'flags',
    'o': 2569,
    'sn': ':flag_aq:'
  },
  ':sandal:': {
    'tn': 'Sandale',
    'uc': '1f461',
    'c': 'people',
    'o': 2377,
    'sn': ':sandal:'
  },
  ':notepad_spiral:': {
    'tn': 'Notizblock',
    'uc': '1f5d2',
    'c': 'objects',
    'o': 777,
    'sn': ':notepad_spiral:'
  },
  ':rotating_light:': {
    'tn': 'Blaulicht',
    'uc': '1f6a8',
    'c': 'travel',
    'o': 2448,
    'sn': ':rotating_light:'
  },
  ':wind_blowing_face:': {
    'tn': 'Wind_Gesicht',
    'uc': '1f32c',
    'c': 'nature',
    'o': 990,
    'sn': ':wind_blowing_face:'
  },
  ':hatching_chick:': {
    'tn': 'Küken im Ei',
    'uc': '1f423',
    'c': 'nature',
    'o': 848,
    'sn': ':hatching_chick:'
  },
  ':art:': {
    'tn': 'Palette',
    'uc': '1f3a8',
    'c': 'activity',
    'o': 600,
    'sn': ':art:'
  },
  ':woman_mage:': {
    'tn': 'Magierin',
    'uc': '1f9d9-2640',
    'c': 'people',
    'o': 1937,
    'sn': ':woman_mage:'
  },
  ':pager:': {
    'tn': 'Piepser',
    'uc': '1f4df',
    'c': 'objects',
    'o': 642,
    'sn': ':pager:'
  },
  ':open_hands:': {
    'tn': 'offene_Hände',
    'uc': '1f450',
    'c': 'people',
    'o': 1220,
    'sn': ':open_hands:'
  },
  ':wink:': {
    'tn': 'zwinker',
    'uc': '1f609',
    'c': 'people',
    'o': 1116,
    'sn': ':wink:'
  },
  ':red_haired:': {
    'tn': 'rothaarig',
    'uc': '1f9b0',
    'c': 'people',
    'o': 2401,
    'sn': ':red_haired:'
  },
  ':shrimp:': {
    'tn': 'Garnele',
    'uc': '1f990',
    'c': 'nature',
    'o': 881,
    'sn': ':shrimp:'
  },
  ':flag_td:': {
    'tn': 'Fl_Chad',
    'uc': '1f1f9-1f1e9',
    'c': 'flags',
    'o': 2605,
    'sn': ':flag_td:'
  },
  ':woman_golfing:': {
    'tn': 'Golferin',
    'uc': '1f3cc-2640',
    'c': 'activity',
    'o': 408,
    'sn': ':woman_golfing:'
  },
  ':hotdog:': {
    'tn': 'Hotdog',
    'uc': '1f32d',
    'c': 'food',
    'o': 1038,
    'sn': ':hotdog:'
  },
  ':flag_sc:': {
    'tn': 'Fl_Seychellen',
    'uc': '1f1f8-1f1e8',
    'c': 'flags',
    'o': 2752,
    'sn': ':flag_sc:'
  },
  ':night_with_stars:': {
    'tn': 'Skyline Nacht',
    'uc': '1f303',
    'c': 'travel',
    'o': 2549,
    'sn': ':night_with_stars:'
  },
  ':beers:': {
    'tn': 'Biere',
    'uc': '1f37b',
    'c': 'food',
    'o': 1090,
    'sn': ':beers:'
  },
  ':flag_qa:': {
    'tn': 'Fl_Katar',
    'uc': '1f1f6-1f1e6',
    'c': 'flags',
    'o': 2741,
    'sn': ':flag_qa:'
  },
  ':sun_with_face:': {
    'tn': 'Sonne_Gesicht',
    'uc': '1f31e',
    'c': 'nature',
    'o': 950,
    'sn': ':sun_with_face:'
  },
  ':badger:': {
    'tn': 'Dachs',
    'uc': '1f9a1',
    'c': 'nature',
    'o': 831,
    'sn': ':badger:'
  },
  ':reminder_ribbon:': {
    'tn': 'Gelbe_Schleife',
    'uc': '1f397',
    'c': 'activity',
    'o': 577,
    'sn': ':reminder_ribbon:'
  },
  ':avocado:': {
    'tn': 'Avocado',
    'uc': '1f951',
    'c': 'food',
    'o': 1016,
    'sn': ':avocado:'
  },
  ':mosquito:': {
    'tn': 'Moskito',
    'uc': '1f99f',
    'c': 'nature',
    'o': 872,
    'sn': ':mosquito:'
  },
  ':blossom:': {
    'tn': 'Blüte',
    'uc': '1f33c',
    'c': 'nature',
    'o': 948,
    'sn': ':blossom:'
  },
  ':nut_and_bolt:': {
    'tn': 'Schraube_Mutter',
    'uc': '1f529',
    'c': 'objects',
    'o': 683,
    'sn': ':nut_and_bolt:'
  },
  ':beach:': {
    'tn': 'Strand',
    'uc': '1f3d6',
    'c': 'travel',
    'o': 2503,
    'sn': ':beach:'
  },
  ':busstop:': {
    'tn': 'Zapfsäule',
    'uc': '1f68f',
    'c': 'travel',
    'o': 2490,
    'sn': ':busstop:'
  },
  ':children_crossing:': {
    'tn': 'Kinder_Übergang',
    'uc': '1f6b8',
    'c': 'symbols',
    'o': 97,
    'sn': ':children_crossing:'
  },
  ':flag_et:': {
    'tn': 'Fl_Ethiopien',
    'uc': '1f1ea-1f1f9',
    'c': 'flags',
    'o': 2632,
    'sn': ':flag_et:'
  },
  ':feet:': {
    'tn': 'Füße',
    'uc': '1f43e',
    'c': 'nature',
    'o': 923,
    'sn': ':feet:'
  },
  ':triangular_ruler:': {
    'tn': 'Geodreieck',
    'uc': '1f4d0',
    'c': 'objects',
    'o': 804,
    'sn': ':triangular_ruler:'
  },
  ':flag_cr:': {
    'tn': 'Fl_CostaRica',
    'uc': '1f1e8-1f1f7',
    'c': 'flags',
    'o': 2615,
    'sn': ':flag_cr:'
  },
  ':spades:': {
    'tn': 'Pik',
    'uc': '2660',
    'c': 'symbols',
    'o': 245,
    'sn': ':spades:'
  },
  ':flag_bq:': {
    'tn': 'Fl_KarNL',
    'uc': '1f1e7-1f1f6',
    'c': 'flags',
    'o': 2602,
    'sn': ':flag_bq:'
  },
  ':flower_playing_cards:': {
    'tn': 'Spielkarten',
    'uc': '1f3b4',
    'c': 'symbols',
    'o': 250,
    'sn': ':flower_playing_cards:'
  },
  ':yen:': {
    'tn': 'Yen',
    'uc': '1f4b4',
    'c': 'objects',
    'o': 668,
    'sn': ':yen:'
  },
  ':information_source:': {
    'tn': 'Information',
    'uc': '2139',
    'c': 'symbols',
    'o': 132,
    'sn': ':information_source:'
  },
  ':hash:': {
    'tn': '#',
    'uc': '0023-20e3',
    'c': 'symbols',
    'o': 154,
    'sn': ':hash:'
  },
  ':deer:': {
    'tn': 'Hirsch',
    'uc': '1f98c',
    'c': 'nature',
    'o': 911,
    'sn': ':deer:'
  },
  ':arrow_heading_up:': {
    'tn': 'Pfeil_nach_oben',
    'uc': '2934',
    'c': 'symbols',
    'o': 183,
    'sn': ':arrow_heading_up:'
  },
  ':left_right_arrow:': {
    'tn': 'links_rechts_Pfeil',
    'uc': '2194',
    'c': 'symbols',
    'o': 180,
    'sn': ':left_right_arrow:'
  },
  ':sa:': {
    'tn': 'kostenfrei',
    'uc': '1f202',
    'c': 'symbols',
    'o': 118,
    'sn': ':sa:'
  },
  ':woman_running:': {
    'tn': 'Frau_rennt',
    'uc': '1f3c3-2640',
    'c': 'people',
    'o': 2318,
    'sn': ':woman_running:'
  },
  ':gorilla:': {
    'tn': 'Gorilla',
    'uc': '1f98d',
    'c': 'nature',
    'o': 895,
    'sn': ':gorilla:'
  },
  ':small_red_triangle:': {
    'tn': 'Dreieck_rot',
    'uc': '1f53a',
    'c': 'symbols',
    'o': 216,
    'sn': ':small_red_triangle:'
  },
  ':shopping_bags:': {
    'tn': 'Einkaufstüten',
    'uc': '1f6cd',
    'c': 'objects',
    'o': 742,
    'sn': ':shopping_bags:'
  },
  ':mango:': {
    'tn': 'Mango',
    'uc': '1f96d',
    'c': 'food',
    'o': 1010,
    'sn': ':mango:'
  },
  ':foot:': {
    'tn': 'Fuß',
    'uc': '1f9b6',
    'c': 'people',
    'o': 1383,
    'sn': ':foot:'
  },
  ':woman:': {
    'tn': 'Frau',
    'uc': '1f469',
    'c': 'people',
    'o': 1457,
    'sn': ':woman:'
  },
  ':blond-haired_man:': {
    'tn': 'blonder_Mann',
    'uc': '1f471-2642',
    'c': 'people',
    'o': 1487,
    'sn': ':blond-haired_man:'
  },
  ':woman_elf:': {
    'tn': 'Elfe',
    'uc': '1f9dd-2640',
    'c': 'people',
    'o': 1955,
    'sn': ':woman_elf:'
  },
  ':turkey:': {
    'tn': 'Truthahn',
    'uc': '1f983',
    'c': 'nature',
    'o': 916,
    'sn': ':turkey:'
  },
  ':b:': {
    'tn': 'Taste B',
    'uc': '1f171',
    'c': 'symbols',
    'o': 66,
    'sn': ':b:'
  },
  ':roller_coaster:': {
    'tn': 'Achterbahn',
    'uc': '1f3a2',
    'c': 'travel',
    'o': 2499,
    'sn': ':roller_coaster:'
  },
  ':flag_wf:': {
    'tn': 'Fl_Wallis',
    'uc': '1f1fc-1f1eb',
    'c': 'flags',
    'o': 2807,
    'sn': ':flag_wf:'
  },
  ':flag_ve:': {
    'tn': 'Fl_Venezuela',
    'uc': '1f1fb-1f1ea',
    'c': 'flags',
    'o': 2805,
    'sn': ':flag_ve:'
  },
  ':date:': {
    'tn': 'Datum',
    'uc': '1f4c5',
    'c': 'objects',
    'o': 780,
    'sn': ':date:'
  },
  ':man_firefighter:': {
    'tn': 'Feuerwehrmann',
    'uc': '1f468-1f692',
    'c': 'people',
    'o': 1817,
    'sn': ':man_firefighter:'
  },
  ':door:': {
    'tn': 'Tür',
    'uc': '1f6aa',
    'c': 'objects',
    'o': 731,
    'sn': ':door:'
  },
  ':flag_tc:': {
    'tn': 'Fl_CaicosIS',
    'uc': '1f1f9-1f1e8',
    'c': 'flags',
    'o': 2790,
    'sn': ':flag_tc:'
  },
  ':face_with_monocle:': {
    'tn': 'Monokel',
    'uc': '1f9d0',
    'c': 'people',
    'o': 1130,
    'sn': ':face_with_monocle:'
  },
  ':flag_sb:': {
    'tn': 'Fl_SolomonIS',
    'uc': '1f1f8-1f1e7',
    'c': 'flags',
    'o': 2759,
    'sn': ':flag_sb:'
  },
  ':innocent:': {
    'tn': 'unschuldig',
    'uc': '1f607',
    'c': 'people',
    'o': 1113,
    'sn': ':innocent:'
  },
  ':six:': {
    'tn': '6',
    'uc': '0036-20e3',
    'c': 'symbols',
    'o': 148,
    'sn': ':six:'
  },
  ':stuck_out_tongue_closed_eyes:': {
    'tn': 'Zunge_zwei_Zwinker',
    'uc': '1f61d',
    'c': 'people',
    'o': 1126,
    'sn': ':stuck_out_tongue_closed_eyes:'
  },
  ':money_with_wings:': {
    'tn': 'Geld_Flügel',
    'uc': '1f4b8',
    'c': 'objects',
    'o': 666,
    'sn': ':money_with_wings:'
  },
  ':bee:': {
    'tn': 'Biene',
    'uc': '1f41d',
    'c': 'nature',
    'o': 861,
    'sn': ':bee:'
  },
  ':hamster:': {
    'tn': 'Hamster',
    'uc': '1f439',
    'c': 'nature',
    'o': 824,
    'sn': ':hamster:'
  },
  ':abc:': {
    'tn': 'abc',
    'uc': '1f524',
    'c': 'symbols',
    'o': 133,
    'sn': ':abc:'
  },
  ':no_smoking:': {
    'tn': 'Rauchverbot',
    'uc': '1f6ad',
    'c': 'symbols',
    'o': 86,
    'sn': ':no_smoking:'
  },
  ':customs:': {
    'tn': 'Zoll',
    'uc': '1f6c3',
    'c': 'symbols',
    'o': 120,
    'sn': ':customs:'
  },
  ':flag_kz:': {
    'tn': 'Fl_Kasachstan',
    'uc': '1f1f0-1f1ff',
    'c': 'flags',
    'o': 2676,
    'sn': ':flag_kz:'
  },
  ':anguished:': {
    'tn': 'gequält',
    'uc': '1f627',
    'c': 'people',
    'o': 1175,
    'sn': ':anguished:'
  },
  ':bridge_at_night:': {
    'tn': 'Brücke_Nacht',
    'uc': '1f309',
    'c': 'travel',
    'o': 2551,
    'sn': ':bridge_at_night:'
  },
  ':kiss_ww:': {
    'tn': 'Frauen_Kuss',
    'uc': '1f469-2764-1f48b-1f469',
    'c': 'people',
    'o': 2339,
    'sn': ':kiss_ww:'
  },
  ':cloud_snow:': {
    'tn': 'Wolke_Schnee',
    'uc': '1f328',
    'c': 'nature',
    'o': 986,
    'sn': ':cloud_snow:'
  },
  ':cactus:': {
    'tn': 'Kaktus',
    'uc': '1f335',
    'c': 'nature',
    'o': 926,
    'sn': ':cactus:'
  },
  ':flag_es:': {
    'tn': 'Fl_Spanien',
    'uc': '1f1ea-1f1f8',
    'c': 'flags',
    'o': 2764,
    'sn': ':flag_es:'
  },
  ':mouse2:': {
    'tn': 'Maus2',
    'uc': '1f401',
    'c': 'nature',
    'o': 919,
    'sn': ':mouse2:'
  },
  ':man_frowning:': {
    'tn': 'Mann_denken',
    'uc': '1f64d-2642',
    'c': 'people',
    'o': 2201,
    'sn': ':man_frowning:'
  },
  ':mountain:': {
    'tn': 'Berg',
    'uc': '26f0',
    'c': 'travel',
    'o': 2507,
    'sn': ':mountain:'
  },
  ':baby_symbol:': {
    'tn': 'Babies',
    'uc': '1f6bc',
    'c': 'symbols',
    'o': 125,
    'sn': ':baby_symbol:'
  },
  ':salad:': {
    'tn': 'Salat',
    'uc': '1f957',
    'c': 'food',
    'o': 1046,
    'sn': ':salad:'
  },
  ':stars:': {
    'tn': 'Sterne',
    'uc': '1f320',
    'c': 'travel',
    'o': 2542,
    'sn': ':stars:'
  },
  ':flag_ao:': {
    'tn': 'Fl_Angola',
    'uc': '1f1e6-1f1f4',
    'c': 'flags',
    'o': 2567,
    'sn': ':flag_ao:'
  },
  ':camping:': {
    'tn': 'Campen',
    'uc': '1f3d5',
    'c': 'travel',
    'o': 2510,
    'sn': ':camping:'
  },
  ':mouse_three_button:': {
    'tn': 'PC Maus',
    'uc': '1f5b1',
    'c': 'objects',
    'o': 623,
    'sn': ':mouse_three_button:'
  },
  ':family_woman_girl_boy:': {
    'tn': 'Single_Fau_FM',
    'uc': '1f469-1f467-1f466',
    'c': 'people',
    'o': 2359,
    'sn': ':family_woman_girl_boy:'
  },
  ':angel:': {
    'tn': 'Engelchen',
    'uc': '1f47c',
    'c': 'people',
    'o': 2027,
    'sn': ':angel:'
  },
  ':high_heel:': {
    'tn': 'Highheel',
    'uc': '1f460',
    'c': 'people',
    'o': 2376,
    'sn': ':high_heel:'
  },
  ':candle:': {
    'tn': 'Kerze',
    'uc': '1f56f',
    'c': 'objects',
    'o': 662,
    'sn': ':candle:'
  },
  ':kiss_mm:': {
    'tn': 'Männer_Kuss',
    'uc': '1f468-2764-1f48b-1f468',
    'c': 'people',
    'o': 2340,
    'sn': ':kiss_mm:'
  },
  ':scroll:': {
    'tn': 'Schriftrolle',
    'uc': '1f4dc',
    'c': 'objects',
    'o': 769,
    'sn': ':scroll:'
  },
  ':circus_tent:': {
    'tn': 'Zirkuszelt',
    'uc': '1f3aa',
    'c': 'activity',
    'o': 580,
    'sn': ':circus_tent:'
  },
  ':a:': {
    'tn': 'Taste A',
    'uc': '1f170',
    'c': 'symbols',
    'o': 65,
    'sn': ':a:'
  },
  ':no_bell:': {
    'tn': 'keine_Glocke',
    'uc': '1f515',
    'c': 'symbols',
    'o': 237,
    'sn': ':no_bell:'
  },
  ':film_frames:': {
    'tn': 'Film',
    'uc': '1f39e',
    'c': 'objects',
    'o': 639,
    'sn': ':film_frames:'
  },
  ':herb:': {
    'tn': 'Kraut',
    'uc': '1f33f',
    'c': 'nature',
    'o': 932,
    'sn': ':herb:'
  },
  ':airplane_arriving:': {
    'tn': 'Flugzeug_landen',
    'uc': '1f6ec',
    'c': 'travel',
    'o': 2470,
    'sn': ':airplane_arriving:'
  },
  ':toilet:': {
    'tn': 'Toilette',
    'uc': '1f6bd',
    'c': 'objects',
    'o': 710,
    'sn': ':toilet:'
  },
  ':notes:': {
    'tn': 'Noten',
    'uc': '1f3b6',
    'c': 'symbols',
    'o': 191,
    'sn': ':notes:'
  },
  ':rage:': {
    'tn': 'wütend',
    'uc': '1f621',
    'c': 'people',
    'o': 1151,
    'sn': ':rage:'
  },
  ':flag_sa:': {
    'tn': 'Fl_SaudiArabien',
    'uc': '1f1f8-1f1e6',
    'c': 'flags',
    'o': 2749,
    'sn': ':flag_sa:'
  },
  ':womans_hat:': {
    'tn': 'Frauen-Hut',
    'uc': '1f452',
    'c': 'people',
    'o': 2388,
    'sn': ':womans_hat:'
  },
  ':radioactive:': {
    'tn': 'Radioaktiv',
    'uc': '2622',
    'c': 'symbols',
    'o': 46,
    'sn': ':radioactive:'
  },
  ':euro:': {
    'tn': 'Euro',
    'uc': '1f4b6',
    'c': 'objects',
    'o': 669,
    'sn': ':euro:'
  },
  ':bed:': {
    'tn': 'Bett',
    'uc': '1f6cf',
    'c': 'objects',
    'o': 733,
    'sn': ':bed:'
  },
  ':notebook_with_decorative_cover:': {
    'tn': 'Notizbuch2',
    'uc': '1f4d4',
    'c': 'objects',
    'o': 792,
    'sn': ':notebook_with_decorative_cover:'
  },
  ':pencil:': {
    'tn': 'Stift',
    'uc': '1f4dd',
    'c': 'objects',
    'o': 815,
    'sn': ':pencil:'
  },
  ':angry:': {
    'tn': 'böse',
    'uc': '1f620',
    'c': 'people',
    'o': 1150,
    'sn': ':angry:'
  },
  ':hearts:': {
    'tn': 'Herz',
    'uc': '2665',
    'c': 'symbols',
    'o': 247,
    'sn': ':hearts:'
  },
  ':flag_ky:': {
    'tn': 'Fl_Caymans',
    'uc': '1f1f0-1f1fe',
    'c': 'flags',
    'o': 2603,
    'sn': ':flag_ky:'
  },
  ':football:': {
    'tn': 'Ball_Football',
    'uc': '1f3c8',
    'c': 'activity',
    'o': 293,
    'sn': ':football:'
  },
  ':vhs:': {
    'tn': 'Videoband',
    'uc': '1f4fc',
    'c': 'objects',
    'o': 633,
    'sn': ':vhs:'
  },
  ':women_with_bunny_ears_partying:': {
    'tn': 'Frauen_Haasenohren',
    'uc': '1f46f-2640',
    'c': 'people',
    'o': 2286,
    'sn': ':women_with_bunny_ears_partying:'
  },
  ':broccoli:': {
    'tn': 'Brokkoli',
    'uc': '1f966',
    'c': 'food',
    'o': 1017,
    'sn': ':broccoli:'
  },
  ':poodle:': {
    'tn': 'Pudel',
    'uc': '1f429',
    'c': 'nature',
    'o': 913,
    'sn': ':poodle:'
  },
  ':grey_exclamation:': {
    'tn': 'Ausrufezeichen_grau',
    'uc': '2755',
    'c': 'symbols',
    'o': 88,
    'sn': ':grey_exclamation:'
  },
  ':man_cook:': {
    'tn': 'Koch',
    'uc': '1f468-1f373',
    'c': 'people',
    'o': 1697,
    'sn': ':man_cook:'
  },
  ':flag_gu:': {
    'tn': 'Fl_Guam',
    'uc': '1f1ec-1f1fa',
    'c': 'flags',
    'o': 2652,
    'sn': ':flag_gu:'
  },
  ':record_button:': {
    'tn': 'aufnehmen_Knopf',
    'uc': '23fa',
    'c': 'symbols',
    'o': 161,
    'sn': ':record_button:'
  },
  ':flag_er:': {
    'tn': 'Fl_Eritrea',
    'uc': '1f1ea-1f1f7',
    'c': 'flags',
    'o': 2630,
    'sn': ':flag_er:'
  },
  ':wastebasket:': {
    'tn': 'Mülleimer',
    'uc': '1f5d1',
    'c': 'objects',
    'o': 664,
    'sn': ':wastebasket:'
  },
  ':women_wrestling:': {
    'tn': 'Ringer (Frauen)',
    'uc': '1f93c-2640',
    'c': 'activity',
    'o': 345,
    'sn': ':women_wrestling:'
  },
  ':tumbler_glass:': {
    'tn': 'Glas_Tumbler',
    'uc': '1f943',
    'c': 'food',
    'o': 1093,
    'sn': ':tumbler_glass:'
  },
  ':man_cartwheeling:': {
    'tn': 'Mann_Radschlag',
    'uc': '1f938-2642',
    'c': 'activity',
    'o': 359,
    'sn': ':man_cartwheeling:'
  },
  ':flag_cp:': {
    'tn': 'Fl_Clipperton',
    'uc': '1f1e8-1f1f5',
    'c': 'flags',
    'o': 2814,
    'sn': ':flag_cp:'
  },
  ':minidisc:': {
    'tn': 'Minidisc',
    'uc': '1f4bd',
    'c': 'objects',
    'o': 629,
    'sn': ':minidisc:'
  },
  ':wc:': {
    'tn': 'WC',
    'uc': '1f6be',
    'c': 'symbols',
    'o': 114,
    'sn': ':wc:'
  },
  ':man_guard:': {
    'tn': 'Wächter_Mann',
    'uc': '1f482-2642',
    'c': 'people',
    'o': 1643,
    'sn': ':man_guard:'
  },
  ':flag_bo:': {
    'tn': 'Fl_Boliviem',
    'uc': '1f1e7-1f1f4',
    'c': 'flags',
    'o': 2587,
    'sn': ':flag_bo:'
  },
  ':coffee:': {
    'tn': 'Kaffee',
    'uc': '2615',
    'c': 'food',
    'o': 1085,
    'sn': ':coffee:'
  },
  ':woman_red_haired:': {
    'tn': 'Frau_rothaarig',
    'uc': '1f469-1f9b0',
    'c': 'people',
    'o': 1493,
    'sn': ':woman_red_haired:'
  },
  ':frame_photo:': {
    'tn': 'Bild_Rahmen',
    'uc': '1f5bc',
    'c': 'objects',
    'o': 741,
    'sn': ':frame_photo:'
  },
  ':cross:': {
    'tn': 'Kreuz',
    'uc': '271d',
    'c': 'symbols',
    'o': 19,
    'sn': ':cross:'
  },
  ':alarm_clock:': {
    'tn': 'Wecker',
    'uc': '23f0',
    'c': 'objects',
    'o': 651,
    'sn': ':alarm_clock:'
  },
  ':star2:': {
    'tn': 'Stern2',
    'uc': '1f31f',
    'c': 'nature',
    'o': 969,
    'sn': ':star2:'
  },
  ':bus:': {
    'tn': 'Bus',
    'uc': '1f68c',
    'c': 'travel',
    'o': 2434,
    'sn': ':bus:'
  },
  ':ticket:': {
    'tn': 'Ticket',
    'uc': '1f3ab',
    'c': 'activity',
    'o': 578,
    'sn': ':ticket:'
  },
  ':volleyball:': {
    'tn': 'Ball_Volleyball',
    'uc': '1f3d0',
    'c': 'activity',
    'o': 297,
    'sn': ':volleyball:'
  },
  ':family_mwgb:': {
    'tn': 'Familie_MFMF',
    'uc': '1f468-1f469-1f467-1f466',
    'c': 'people',
    'o': 2344,
    'sn': ':family_mwgb:'
  },
  ':partying_face:': {
    'tn': 'feierliches Gesicht',
    'uc': '1f973',
    'c': 'people',
    'o': 1134,
    'sn': ':partying_face:'
  },
  ':peacock:': {
    'tn': 'Pfau',
    'uc': '1f99a',
    'c': 'nature',
    'o': 855,
    'sn': ':peacock:'
  },
  ':bowling:': {
    'tn': 'Bowling',
    'uc': '1f3b3',
    'c': 'activity',
    'o': 613,
    'sn': ':bowling:'
  },
  ':family_mmg:': {
    'tn': 'Familie_MMF',
    'uc': '1f468-1f468-1f467',
    'c': 'people',
    'o': 2353,
    'sn': ':family_mmg:'
  },
  ':house:': {
    'tn': 'Haus',
    'uc': '1f3e0',
    'c': 'travel',
    'o': 2512,
    'sn': ':house:'
  },
  ':canned_food:': {
    'tn': 'Konservendose',
    'uc': '1f96b',
    'c': 'food',
    'o': 1048,
    'sn': ':canned_food:'
  },
  ':new:': {
    'tn': 'neu',
    'uc': '1f195',
    'c': 'symbols',
    'o': 140,
    'sn': ':new:'
  },
  ':chestnut:': {
    'tn': 'Kastanie',
    'uc': '1f330',
    'c': 'food',
    'o': 1080,
    'sn': ':chestnut:'
  },
  ':man_with_chinese_cap:': {
    'tn': 'Mann_Hut_China',
    'uc': '1f472',
    'c': 'people',
    'o': 1565,
    'sn': ':man_with_chinese_cap:'
  },
  ':flag_vc:': {
    'tn': 'Fl_StVincent',
    'uc': '1f1fb-1f1e8',
    'c': 'flags',
    'o': 2771,
    'sn': ':flag_vc:'
  },
  ':octagonal_sign:': {
    'tn': 'achteck_Schild',
    'uc': '1f6d1',
    'c': 'symbols',
    'o': 73,
    'sn': ':octagonal_sign:'
  },
  ':gun:': {
    'tn': 'Pistole',
    'uc': '1f52b',
    'c': 'objects',
    'o': 686,
    'sn': ':gun:'
  },
  ':menorah:': {
    'tn': 'Menorah',
    'uc': '1f54e',
    'c': 'symbols',
    'o': 25,
    'sn': ':menorah:'
  },
  ':palms_up_together:': {
    'tn': 'Handfl_zusammen',
    'uc': '1f932',
    'c': 'people',
    'o': 1214,
    'sn': ':palms_up_together:'
  },
  ':diamond_shape_with_a_dot_inside:': {
    'tn': 'Kawaii',
    'uc': '1f4a0',
    'c': 'symbols',
    'o': 109,
    'sn': ':diamond_shape_with_a_dot_inside:'
  },
  ':flag_ta:': {
    'tn': 'Fl_TristanDC',
    'uc': '1f1f9-1f1e6',
    'c': 'flags',
    'o': 2820,
    'sn': ':flag_ta:'
  },
  ':family_man_boy:': {
    'tn': 'Single_Mann_M',
    'uc': '1f468-1f466',
    'c': 'people',
    'o': 2362,
    'sn': ':family_man_boy:'
  },
  ':rooster:': {
    'tn': 'Hahn',
    'uc': '1f413',
    'c': 'nature',
    'o': 915,
    'sn': ':rooster:'
  },
  ':fire_extinguisher:': {
    'tn': 'Feuerlöscher',
    'uc': '1f9ef',
    'c': 'objects',
    'o': 663,
    'sn': ':fire_extinguisher:'
  },
  ':mask:': {
    'tn': 'Maske',
    'uc': '1f637',
    'c': 'people',
    'o': 1187,
    'sn': ':mask:'
  },
  ':family_wwg:': {
    'tn': 'Familie_FFF',
    'uc': '1f469-1f469-1f467',
    'c': 'people',
    'o': 2348,
    'sn': ':family_wwg:'
  },
  ':flag_mz:': {
    'tn': 'Fl_Mosambik',
    'uc': '1f1f2-1f1ff',
    'c': 'flags',
    'o': 2712,
    'sn': ':flag_mz:'
  },
  ':man_getting_haircut:': {
    'tn': 'Mann_Haarschnitt',
    'uc': '1f487-2642',
    'c': 'people',
    'o': 2219,
    'sn': ':man_getting_haircut:'
  },
  ':cloud_lightning:': {
    'tn': 'Wolke_Blitz',
    'uc': '1f329',
    'c': 'nature',
    'o': 985,
    'sn': ':cloud_lightning:'
  },
  ':aerial_tramway:': {
    'tn': 'Gondel1',
    'uc': '1f6a1',
    'c': 'travel',
    'o': 2453,
    'sn': ':aerial_tramway:'
  },
  ':flag_ly:': {
    'tn': 'Fl_Libyen',
    'uc': '1f1f1-1f1fe',
    'c': 'flags',
    'o': 2687,
    'sn': ':flag_ly:'
  },
  ':lion_face:': {
    'tn': 'Löwe',
    'uc': '1f981',
    'c': 'nature',
    'o': 834,
    'sn': ':lion_face:'
  },
  ':skateboard:': {
    'tn': 'Skateboard',
    'uc': '1f6f9',
    'c': 'activity',
    'o': 314,
    'sn': ':skateboard:'
  },
  ':free:': {
    'tn': 'frei',
    'uc': '1f193',
    'c': 'symbols',
    'o': 141,
    'sn': ':free:'
  },
  ':custard:': {
    'tn': 'Pudding',
    'uc': '1f36e',
    'c': 'food',
    'o': 1071,
    'sn': ':custard:'
  },
  ':slight_smile:': {
    'tn': 'leichtes_lächeln',
    'uc': '1f642',
    'c': 'people',
    'o': 1114,
    'sn': ':slight_smile:'
  },
  ':man_artist:': {
    'tn': 'Künstler',
    'uc': '1f468-1f3a8',
    'c': 'people',
    'o': 1805,
    'sn': ':man_artist:'
  },
  ':snake:': {
    'tn': 'Schlange',
    'uc': '1f40d',
    'c': 'nature',
    'o': 875,
    'sn': ':snake:'
  },
  ':flag_hu:': {
    'tn': 'Fl_Ungarn',
    'uc': '1f1ed-1f1fa',
    'c': 'flags',
    'o': 2661,
    'sn': ':flag_hu:'
  },
  ':flag_gt:': {
    'tn': 'Fl_Guatemala',
    'uc': '1f1ec-1f1f9',
    'c': 'flags',
    'o': 2653,
    'sn': ':flag_gt:'
  },
  ':flag_black:': {
    'tn': 'Fl_schwarz',
    'uc': '1f3f4',
    'c': 'flags',
    'o': 2556,
    'sn': ':flag_black:'
  },
  ':blush:': {
    'tn': 'erröten',
    'uc': '1f60a',
    'c': 'people',
    'o': 1112,
    'sn': ':blush:'
  },
  ':waxing_gibbous_moon:': {
    'tn': 'Mond_abnehmend_dreiviertel',
    'uc': '1f314',
    'c': 'nature',
    'o': 962,
    'sn': ':waxing_gibbous_moon:'
  },
  ':fish_cake:': {
    'tn': 'Fischkuchen',
    'uc': '1f365',
    'c': 'food',
    'o': 1059,
    'sn': ':fish_cake:'
  },
  ':tiger:': {
    'tn': 'Tiger',
    'uc': '1f42f',
    'c': 'nature',
    'o': 833,
    'sn': ':tiger:'
  },
  ':couple_ww:': {
    'tn': 'Pärchen_Herz_WW',
    'uc': '1f469-2764-1f469',
    'c': 'people',
    'o': 2335,
    'sn': ':couple_ww:'
  },
  ':flag_co:': {
    'tn': 'Fl_Kolumbien',
    'uc': '1f1e8-1f1f4',
    'c': 'flags',
    'o': 2610,
    'sn': ':flag_co:'
  },
  ':black_medium_small_square:': {
    'tn': 'Quader_mittel_schwarz',
    'uc': '25fe',
    'c': 'symbols',
    'o': 226,
    'sn': ':black_medium_small_square:'
  },
  ':envelope_with_arrow:': {
    'tn': 'Umschlag_Pfeil',
    'uc': '1f4e9',
    'c': 'objects',
    'o': 755,
    'sn': ':envelope_with_arrow:'
  },
  ':head_bandage:': {
    'tn': 'verletzt',
    'uc': '1f915',
    'c': 'people',
    'o': 1189,
    'sn': ':head_bandage:'
  },
  ':flag_bn:': {
    'tn': 'Fl_Brunei',
    'uc': '1f1e7-1f1f3',
    'c': 'flags',
    'o': 2593,
    'sn': ':flag_bn:'
  },
  ':man_zombie:': {
    'tn': 'Zombie',
    'uc': '1f9df-2642',
    'c': 'people',
    'o': 1987,
    'sn': ':man_zombie:'
  },
  ':flag_am:': {
    'tn': 'Fl_Armenien',
    'uc': '1f1e6-1f1f2',
    'c': 'flags',
    'o': 2572,
    'sn': ':flag_am:'
  },
  ':truck:': {
    'tn': 'LKW (2 Achsen)',
    'uc': '1f69a',
    'c': 'travel',
    'o': 2441,
    'sn': ':truck:'
  },
  ':lock:': {
    'tn': 'Schloss',
    'uc': '1f512',
    'c': 'objects',
    'o': 2552,
    'sn': ':lock:'
  },
  ':lollipop:': {
    'tn': 'Lutscher',
    'uc': '1f36d',
    'c': 'food',
    'o': 1072,
    'sn': ':lollipop:'
  },
  ':vertical_traffic_light:': {
    'tn': 'Ampel',
    'uc': '1f6a6',
    'c': 'travel',
    'o': 2488,
    'sn': ':vertical_traffic_light:'
  },
  ':key:': {
    'tn': 'Schlüssel1',
    'uc': '1f511',
    'c': 'objects',
    'o': 729,
    'sn': ':key:'
  },
  ':octopus:': {
    'tn': 'Oktopus',
    'uc': '1f419',
    'c': 'nature',
    'o': 879,
    'sn': ':octopus:'
  },
  ':raccoon:': {
    'tn': 'Waschbär',
    'uc': '1f99d',
    'c': 'nature',
    'o': 827,
    'sn': ':raccoon:'
  },
  ':smirk_cat:': {
    'tn': 'grinsen_Katze',
    'uc': '1f63c',
    'c': 'people',
    'o': 1209,
    'sn': ':smirk_cat:'
  },
  ':man_pouting:': {
    'tn': 'Mann_schmollt',
    'uc': '1f64e-2642',
    'c': 'people',
    'o': 2183,
    'sn': ':man_pouting:'
  },
  ':pound_symbol:': {
    'tn': 'Pfund-Symbol',
    'uc': '0023',
    'c': 'symbols',
    'o': 286,
    'sn': ':pound_symbol:'
  },
  ':sleeping:': {
    'tn': 'schlafend',
    'uc': '1f634',
    'c': 'people',
    'o': 1178,
    'sn': ':sleeping:'
  },
  ':couple_mm:': {
    'tn': 'Pärchen_Herz_MM',
    'uc': '1f468-2764-1f468',
    'c': 'people',
    'o': 2336,
    'sn': ':couple_mm:'
  },
  ':european_post_office:': {
    'tn': 'Postamt_EU',
    'uc': '1f3e4',
    'c': 'travel',
    'o': 2521,
    'sn': ':european_post_office:'
  },
  ':flag_ye:': {
    'tn': 'Fl_Jemen',
    'uc': '1f1fe-1f1ea',
    'c': 'flags',
    'o': 2809,
    'sn': ':flag_ye:'
  },
  ':smile_cat:': {
    'tn': 'lachen_Katze',
    'uc': '1f638',
    'c': 'people',
    'o': 1206,
    'sn': ':smile_cat:'
  },
  ':flag_ua:': {
    'tn': 'Fl_Ukraine',
    'uc': '1f1fa-1f1e6',
    'c': 'flags',
    'o': 2794,
    'sn': ':flag_ua:'
  },
  ':soap:': {
    'tn': 'Seife',
    'uc': '1f9fc',
    'c': 'objects',
    'o': 723,
    'sn': ':soap:'
  },
  ':mountain_railway:': {
    'tn': 'Eisenbahnwagen 2',
    'uc': '1f69e',
    'c': 'travel',
    'o': 2458,
    'sn': ':mountain_railway:'
  },
  ':clock9:': {
    'tn': '9 Uhr',
    'uc': '1f558',
    'c': 'symbols',
    'o': 260,
    'sn': ':clock9:'
  },
  ':u6709:': {
    'tn': 'besitzen',
    'uc': '1f236',
    'c': 'symbols',
    'o': 50,
    'sn': ':u6709:'
  },
  ':scorpion:': {
    'tn': 'Skorpion',
    'uc': '1f982',
    'c': 'nature',
    'o': 871,
    'sn': ':scorpion:'
  },
  ':speaker:': {
    'tn': 'Lautsprecher',
    'uc': '1f508',
    'c': 'symbols',
    'o': 232,
    'sn': ':speaker:'
  },
  ':globe_with_meridians:': {
    'tn': 'Globus_Meridiane',
    'uc': '1f310',
    'c': 'symbols',
    'o': 108,
    'sn': ':globe_with_meridians:'
  },
  ':leafy_green:': {
    'tn': 'Blattgrün',
    'uc': '1f96c',
    'c': 'food',
    'o': 1018,
    'sn': ':leafy_green:'
  },
  ':boom:': {
    'tn': 'Knall',
    'uc': '1f4a5',
    'c': 'nature',
    'o': 973,
    'sn': ':boom:'
  },
  ':elf:': {
    'tn': 'Elf',
    'uc': '1f9dd',
    'c': 'people',
    'o': 1949,
    'sn': ':elf:'
  },
  ':track_previous:': {
    'tn': 'Vorheriger',
    'uc': '23ee',
    'c': 'symbols',
    'o': 163,
    'sn': ':track_previous:'
  },
  ':purse:': {
    'tn': 'Geldbörse',
    'uc': '1f45b',
    'c': 'people',
    'o': 2393,
    'sn': ':purse:'
  },
  ':flag_nz:': {
    'tn': 'Fl_Neuseeland',
    'uc': '1f1f3-1f1ff',
    'c': 'flags',
    'o': 2719,
    'sn': ':flag_nz:'
  },
  ':flag_my:': {
    'tn': 'Fl_Malaysien',
    'uc': '1f1f2-1f1fe',
    'c': 'flags',
    'o': 2695,
    'sn': ':flag_my:'
  },
  ':beetle:': {
    'tn': 'Käfer',
    'uc': '1f41e',
    'c': 'nature',
    'o': 866,
    'sn': ':beetle:'
  },
  ':flag_kw:': {
    'tn': 'Fl_Kuwait',
    'uc': '1f1f0-1f1fc',
    'c': 'flags',
    'o': 2680,
    'sn': ':flag_kw:'
  },
  ':moyai:': {
    'tn': 'Moyai',
    'uc': '1f5ff',
    'c': 'travel',
    'o': 2492,
    'sn': ':moyai:'
  },
  ':white_small_square:': {
    'tn': 'Quader_klein_weiß',
    'uc': '25ab',
    'c': 'symbols',
    'o': 225,
    'sn': ':white_small_square:'
  },
  ':teddy_bear:': {
    'tn': 'Teddybär',
    'uc': '1f9f8',
    'c': 'objects',
    'o': 740,
    'sn': ':teddy_bear:'
  },
  ':flag_ht:': {
    'tn': 'Fl_Haiti',
    'uc': '1f1ed-1f1f9',
    'c': 'flags',
    'o': 2658,
    'sn': ':flag_ht:'
  },
  ':flag_gs:': {
    'tn': 'Fl_SandwichIS',
    'uc': '1f1ec-1f1f8',
    'c': 'flags',
    'o': 2758,
    'sn': ':flag_gs:'
  },
  ':flag_fr:': {
    'tn': 'Fl_Frankreich',
    'uc': '1f1eb-1f1f7',
    'c': 'flags',
    'o': 2638,
    'sn': ':flag_fr:'
  },
  ':play_pause:': {
    'tn': 'start_stop',
    'uc': '23ef',
    'c': 'symbols',
    'o': 159,
    'sn': ':play_pause:'
  },
  ':flag_cn:': {
    'tn': 'Fl_China',
    'uc': '1f1e8-1f1f3',
    'c': 'flags',
    'o': 2607,
    'sn': ':flag_cn:'
  },
  ':white_square_button:': {
    'tn': 'Quader_Knopf',
    'uc': '1f533',
    'c': 'symbols',
    'o': 222,
    'sn': ':white_square_button:'
  },
  ':flag_bm:': {
    'tn': 'Fl_Bermuda',
    'uc': '1f1e7-1f1f2',
    'c': 'flags',
    'o': 2585,
    'sn': ':flag_bm:'
  },
  ':woman_student:': {
    'tn': 'Studentin',
    'uc': '1f469-1f393',
    'c': 'people',
    'o': 1703,
    'sn': ':woman_student:'
  },
  ':flag_al:': {
    'tn': 'Fl_Albanien',
    'uc': '1f1e6-1f1f1',
    'c': 'flags',
    'o': 2563,
    'sn': ':flag_al:'
  },
  ':dolphin:': {
    'tn': 'Delfin',
    'uc': '1f42c',
    'c': 'nature',
    'o': 887,
    'sn': ':dolphin:'
  },
  ':dagger:': {
    'tn': 'Dolch',
    'uc': '1f5e1',
    'c': 'objects',
    'o': 689,
    'sn': ':dagger:'
  },
  ':man_raising_hand:': {
    'tn': 'Mann_aufzeigen',
    'uc': '1f64b-2642',
    'c': 'people',
    'o': 2129,
    'sn': ':man_raising_hand:'
  },
  ':magnet:': {
    'tn': 'Magnet',
    'uc': '1f9f2',
    'c': 'objects',
    'o': 659,
    'sn': ':magnet:'
  },
  ':wheelchair:': {
    'tn': 'behindert',
    'uc': '267f',
    'c': 'symbols',
    'o': 115,
    'sn': ':wheelchair:'
  },
  ':chart:': {
    'tn': 'Diagramm_Yen',
    'uc': '1f4b9',
    'c': 'symbols',
    'o': 104,
    'sn': ':chart:'
  },
  ':woman_climbing:': {
    'tn': 'Frau_Klettern',
    'uc': '1f9d7-2640',
    'c': 'activity',
    'o': 522,
    'sn': ':woman_climbing:'
  },
  ':train2:': {
    'tn': 'Zug2',
    'uc': '1f686',
    'c': 'travel',
    'o': 2464,
    'sn': ':train2:'
  },
  ':smiling_face_with_3_hearts:': {
    'tn': 'Lächelndes Gesicht mit Herzen',
    'uc': '1f970',
    'c': 'people',
    'o': 1120,
    'sn': ':smiling_face_with_3_hearts:'
  },
  ':croissant:': {
    'tn': 'Croissant',
    'uc': '1f950',
    'c': 'food',
    'o': 1025,
    'sn': ':croissant:'
  },
  ':blowfish:': {
    'tn': 'Kugelfisch',
    'uc': '1f421',
    'c': 'nature',
    'o': 884,
    'sn': ':blowfish:'
  },
  ':scorpius:': {
    'tn': 'Skorpion_Zeichen',
    'uc': '264f',
    'c': 'symbols',
    'o': 37,
    'sn': ':scorpius:'
  },
  ':park:': {
    'tn': 'Park',
    'uc': '1f3de',
    'c': 'travel',
    'o': 2539,
    'sn': ':park:'
  },
  ':flag_va:': {
    'tn': 'Fl_Vatikan',
    'uc': '1f1fb-1f1e6',
    'c': 'flags',
    'o': 2804,
    'sn': ':flag_va:'
  },
  ':tada:': {
    'tn': 'Tröte',
    'uc': '1f389',
    'c': 'objects',
    'o': 749,
    'sn': ':tada:'
  },
  ':thread:': {
    'tn': 'Faden',
    'uc': '1f9f5',
    'c': 'objects',
    'o': 726,
    'sn': ':thread:'
  },
  ':green_apple:': {
    'tn': 'Apfel_grün',
    'uc': '1f34f',
    'c': 'food',
    'o': 998,
    'sn': ':green_apple:'
  },
  ':clock8:': {
    'tn': '8 Uhr',
    'uc': '1f557',
    'c': 'symbols',
    'o': 259,
    'sn': ':clock8:'
  },
  ':pensive:': {
    'tn': 'nachdenklich',
    'uc': '1f614',
    'c': 'people',
    'o': 1138,
    'sn': ':pensive:'
  },
  ':u6708:': {
    'tn': 'Monatlich',
    'uc': '1f237',
    'c': 'symbols',
    'o': 54,
    'sn': ':u6708:'
  },
  ':tram:': {
    'tn': 'Trambahn',
    'uc': '1f68a',
    'c': 'travel',
    'o': 2466,
    'sn': ':tram:'
  },
  ':fog:': {
    'tn': 'Nebel',
    'uc': '1f32b',
    'c': 'nature',
    'o': 997,
    'sn': ':fog:'
  },
  ':dumpling:': {
    'tn': 'Teigtasche',
    'uc': '1f95f',
    'c': 'food',
    'o': 1078,
    'sn': ':dumpling:'
  },
  ':point_up:': {
    'tn': 'zeigen_oben',
    'uc': '261d',
    'c': 'people',
    'o': 1329,
    'sn': ':point_up:'
  },
  ':flag_mx:': {
    'tn': 'Fl_Mexiko',
    'uc': '1f1f2-1f1fd',
    'c': 'flags',
    'o': 2704,
    'sn': ':flag_mx:'
  },
  ':ram:': {
    'tn': 'Widder',
    'uc': '1f40f',
    'c': 'nature',
    'o': 908,
    'sn': ':ram:'
  },
  ':three:': {
    'tn': '3',
    'uc': '0033-20e3',
    'c': 'symbols',
    'o': 145,
    'sn': ':three:'
  },
  ':skier:': {
    'tn': 'Skifahrer',
    'uc': '26f7',
    'c': 'activity',
    'o': 319,
    'sn': ':skier:'
  },
  ':telephone_receiver:': {
    'tn': 'Hörer',
    'uc': '1f4de',
    'c': 'objects',
    'o': 640,
    'sn': ':telephone_receiver:'
  },
  ':flag_it:': {
    'tn': 'Fl_Italien',
    'uc': '1f1ee-1f1f9',
    'c': 'flags',
    'o': 2670,
    'sn': ':flag_it:'
  },
  ':guitar:': {
    'tn': 'Gitarre',
    'uc': '1f3b8',
    'c': 'activity',
    'o': 609,
    'sn': ':guitar:'
  },
  ':shower:': {
    'tn': 'Dusche',
    'uc': '1f6bf',
    'c': 'objects',
    'o': 712,
    'sn': ':shower:'
  },
  ':flag_gr:': {
    'tn': 'Fl_Griechenland',
    'uc': '1f1ec-1f1f7',
    'c': 'flags',
    'o': 2648,
    'sn': ':flag_gr:'
  },
  ':ocean:': {
    'tn': 'Ozean',
    'uc': '1f30a',
    'c': 'nature',
    'o': 996,
    'sn': ':ocean:'
  },
  ':microphone:': {
    'tn': 'Mikrofon',
    'uc': '1f3a4',
    'c': 'activity',
    'o': 602,
    'sn': ':microphone:'
  },
  ':ballot_box_with_check:': {
    'tn': 'blaues_Häkchen',
    'uc': '2611',
    'c': 'symbols',
    'o': 210,
    'sn': ':ballot_box_with_check:'
  },
  ':flag_do:': {
    'tn': 'Fl_DomRep',
    'uc': '1f1e9-1f1f4',
    'c': 'flags',
    'o': 2625,
    'sn': ':flag_do:'
  },
  ':tomato:': {
    'tn': 'Tomate',
    'uc': '1f345',
    'c': 'food',
    'o': 1014,
    'sn': ':tomato:'
  },
  ':flag_bl:': {
    'tn': 'Fl_StBarth',
    'uc': '1f1e7-1f1f1',
    'c': 'flags',
    'o': 2766,
    'sn': ':flag_bl:'
  },
  ':baggage_claim:': {
    'tn': 'Gepäckband',
    'uc': '1f6c4',
    'c': 'symbols',
    'o': 121,
    'sn': ':baggage_claim:'
  },
  ':bulb:': {
    'tn': 'Glühbirne',
    'uc': '1f4a1',
    'c': 'objects',
    'o': 660,
    'sn': ':bulb:'
  },
  ':broom:': {
    'tn': 'Besen',
    'uc': '1f9f9',
    'c': 'objects',
    'o': 720,
    'sn': ':broom:'
  },
  ':shield:': {
    'tn': 'Schild',
    'uc': '1f6e1',
    'c': 'objects',
    'o': 691,
    'sn': ':shield:'
  },
  ':horse:': {
    'tn': 'Pferd',
    'uc': '1f434',
    'c': 'nature',
    'o': 859,
    'sn': ':horse:'
  },
  ':oncoming_taxi:': {
    'tn': 'Taxi_front',
    'uc': '1f696',
    'c': 'travel',
    'o': 2452,
    'sn': ':oncoming_taxi:'
  },
  ':ox:': {
    'tn': 'Ochse',
    'uc': '1f402',
    'c': 'nature',
    'o': 904,
    'sn': ':ox:'
  },
  ':princess:': {
    'tn': 'Prinzessin',
    'uc': '1f478',
    'c': 'people',
    'o': 1871,
    'sn': ':princess:'
  },
  ':articulated_lorry:': {
    'tn': 'LKW (3 Achsen)',
    'uc': '1f69b',
    'c': 'travel',
    'o': 2442,
    'sn': ':articulated_lorry:'
  },
  ':skull:': {
    'tn': 'Totenschädel',
    'uc': '1f480',
    'c': 'people',
    'o': 1199,
    'sn': ':skull:'
  },
  ':softball:': {
    'tn': 'weicher Ball',
    'uc': '1f94e',
    'c': 'activity',
    'o': 295,
    'sn': ':softball:'
  },
  ':no_mouth:': {
    'tn': 'kein_Mund',
    'uc': '1f636',
    'c': 'people',
    'o': 1168,
    'sn': ':no_mouth:'
  },
  ':man_getting_face_massage:': {
    'tn': 'Mann_Massage',
    'uc': '1f486-2642',
    'c': 'people',
    'o': 2237,
    'sn': ':man_getting_face_massage:'
  },
  ':last_quarter_moon:': {
    'tn': 'Mond_abnehmend',
    'uc': '1f317',
    'c': 'nature',
    'o': 957,
    'sn': ':last_quarter_moon:'
  },
  ':clock7:': {
    'tn': '7 Uhr',
    'uc': '1f556',
    'c': 'symbols',
    'o': 258,
    'sn': ':clock7:'
  },
  ':heart_decoration:': {
    'tn': 'Herz_Icon',
    'uc': '1f49f',
    'c': 'symbols',
    'o': 17,
    'sn': ':heart_decoration:'
  },
  ':digit_eight:': {
    'tn': 'Ziffer acht',
    'uc': '0038',
    'c': 'symbols',
    'o': 284,
    'sn': ':digit_eight:'
  },
  ':clubs:': {
    'tn': 'Kreuz',
    'uc': '2663',
    'c': 'symbols',
    'o': 246,
    'sn': ':clubs:'
  },
  ':cool:': {
    'tn': 'cool',
    'uc': '1f192',
    'c': 'symbols',
    'o': 139,
    'sn': ':cool:'
  },
  ':clown:': {
    'tn': 'Clown',
    'uc': '1f921',
    'c': 'people',
    'o': 1196,
    'sn': ':clown:'
  },
  ':stadium:': {
    'tn': 'Stadion',
    'uc': '1f3df',
    'c': 'travel',
    'o': 2497,
    'sn': ':stadium:'
  },
  ':ledger:': {
    'tn': 'Hauptbuch',
    'uc': '1f4d2',
    'c': 'objects',
    'o': 793,
    'sn': ':ledger:'
  },
  ':book:': {
    'tn': 'Buch',
    'uc': '1f4d6',
    'c': 'objects',
    'o': 799,
    'sn': ':book:'
  },
  ':soccer:': {
    'tn': 'Ball_Fußball',
    'uc': '26bd',
    'c': 'activity',
    'o': 291,
    'sn': ':soccer:'
  },
  ':chopsticks:': {
    'tn': 'Essstäbchen',
    'uc': '1f962',
    'c': 'food',
    'o': 1102,
    'sn': ':chopsticks:'
  },
  ':cl:': {
    'tn': 'Taste CL',
    'uc': '1f191',
    'c': 'symbols',
    'o': 68,
    'sn': ':cl:'
  },
  ':city_dusk:': {
    'tn': 'Stadt Dämmerung',
    'uc': '1f306',
    'c': 'travel',
    'o': 2547,
    'sn': ':city_dusk:'
  },
  ':prince:': {
    'tn': 'Prinz',
    'uc': '1f934',
    'c': 'people',
    'o': 1877,
    'sn': ':prince:'
  },
  ':man_mechanic:': {
    'tn': 'Mechaniker',
    'uc': '1f468-1f527',
    'c': 'people',
    'o': 1781,
    'sn': ':man_mechanic:'
  },
  ':flag_mw:': {
    'tn': 'Fl_Malawi',
    'uc': '1f1f2-1f1fc',
    'c': 'flags',
    'o': 2694,
    'sn': ':flag_mw:'
  },
  ':flag_lv:': {
    'tn': 'Fl_Lettland',
    'uc': '1f1f1-1f1fb',
    'c': 'flags',
    'o': 2683,
    'sn': ':flag_lv:'
  },
  ':woman_with_headscarf:': {
    'tn': 'Frau_Kopftuch',
    'uc': '1f9d5',
    'c': 'people',
    'o': 1589,
    'sn': ':woman_with_headscarf:'
  },
  ':man_teacher:': {
    'tn': 'Lehrer',
    'uc': '1f468-1f3eb',
    'c': 'people',
    'o': 1733,
    'sn': ':man_teacher:'
  },
  ':nerd:': {
    'tn': 'Streber',
    'uc': '1f913',
    'c': 'people',
    'o': 1131,
    'sn': ':nerd:'
  },
  ':flag_is:': {
    'tn': 'Fl_Island',
    'uc': '1f1ee-1f1f8',
    'c': 'flags',
    'o': 2662,
    'sn': ':flag_is:'
  },
  ':flag_hr:': {
    'tn': 'Fl_Kroatien',
    'uc': '1f1ed-1f1f7',
    'c': 'flags',
    'o': 2617,
    'sn': ':flag_hr:'
  },
  ':scales:': {
    'tn': 'Waage',
    'uc': '2696',
    'c': 'objects',
    'o': 676,
    'sn': ':scales:'
  },
  ':flag_gq:': {
    'tn': 'Fl_EqGuinea',
    'uc': '1f1ec-1f1f6',
    'c': 'flags',
    'o': 2629,
    'sn': ':flag_gq:'
  },
  ':sweat_smile:': {
    'tn': 'schweiß_lachen',
    'uc': '1f605',
    'c': 'people',
    'o': 1108,
    'sn': ':sweat_smile:'
  },
  ':whale2:': {
    'tn': 'Blauwal',
    'uc': '1f40b',
    'c': 'nature',
    'o': 889,
    'sn': ':whale2:'
  },
  ':wrench:': {
    'tn': 'Schraubenschlüssel',
    'uc': '1f527',
    'c': 'objects',
    'o': 678,
    'sn': ':wrench:'
  },
  ':fax:': {
    'tn': 'Fax',
    'uc': '1f4e0',
    'c': 'objects',
    'o': 643,
    'sn': ':fax:'
  },
  ':flag_cm:': {
    'tn': 'Fl_Kamerun',
    'uc': '1f1e8-1f1f2',
    'c': 'flags',
    'o': 2598,
    'sn': ':flag_cm:'
  },
  ':video_camera:': {
    'tn': 'Kamera_Video',
    'uc': '1f4f9',
    'c': 'objects',
    'o': 636,
    'sn': ':video_camera:'
  },
  ':infinity:': {
    'tn': 'Unendlichkeit',
    'uc': '267e',
    'c': 'symbols',
    'o': 44,
    'sn': ':infinity:'
  },
  ':woman_bouncing_ball:': {
    'tn': 'Frau_dribbelt',
    'uc': '26f9-2640',
    'c': 'activity',
    'o': 371,
    'sn': ':woman_bouncing_ball:'
  },
  ':u6e80:': {
    'tn': 'voll',
    'uc': '1f235',
    'c': 'symbols',
    'o': 62,
    'sn': ':u6e80:'
  },
  ':paperclip:': {
    'tn': 'Büroklammer',
    'uc': '1f4ce',
    'c': 'objects',
    'o': 802,
    'sn': ':paperclip:'
  },
  ':projector:': {
    'tn': 'Projektor',
    'uc': '1f4fd',
    'c': 'objects',
    'o': 638,
    'sn': ':projector:'
  },
  ':clock930:': {
    'tn': '09:30 Uhr',
    'uc': '1f564',
    'c': 'symbols',
    'o': 272,
    'sn': ':clock930:'
  },
  ':woman_walking:': {
    'tn': 'Frau_geht',
    'uc': '1f6b6-2640',
    'c': 'people',
    'o': 2300,
    'sn': ':woman_walking:'
  },
  ':man_health_worker:': {
    'tn': 'Mann_MFA',
    'uc': '1f468-2695',
    'c': 'people',
    'o': 1673,
    'sn': ':man_health_worker:'
  },
  ':deciduous_tree:': {
    'tn': 'Laubbaum',
    'uc': '1f333',
    'c': 'nature',
    'o': 929,
    'sn': ':deciduous_tree:'
  },
  ':sake:': {
    'tn': 'Sake',
    'uc': '1f376',
    'c': 'food',
    'o': 1088,
    'sn': ':sake:'
  },
  ':man_office_worker:': {
    'tn': 'Beamter',
    'uc': '1f468-1f4bc',
    'c': 'people',
    'o': 1769,
    'sn': ':man_office_worker:'
  },
  ':u5408:': {
    'tn': 'Übereinkunft',
    'uc': '1f234',
    'c': 'symbols',
    'o': 61,
    'sn': ':u5408:'
  },
  ':corn:': {
    'tn': 'Mais',
    'uc': '1f33d',
    'c': 'food',
    'o': 1021,
    'sn': ':corn:'
  },
  ':map:': {
    'tn': 'Karte',
    'uc': '1f5fa',
    'c': 'travel',
    'o': 2491,
    'sn': ':map:'
  },
  ':dog:': {
    'tn': 'Hund',
    'uc': '1f436',
    'c': 'nature',
    'o': 821,
    'sn': ':dog:'
  },
  ':crystal_ball:': {
    'tn': 'Kristallkugel',
    'uc': '1f52e',
    'c': 'objects',
    'o': 696,
    'sn': ':crystal_ball:'
  },
  ':desktop:': {
    'tn': 'PC',
    'uc': '1f5a5',
    'c': 'objects',
    'o': 621,
    'sn': ':desktop:'
  },
  ':ambulance:': {
    'tn': 'Krankenwagen',
    'uc': '1f691',
    'c': 'travel',
    'o': 2438,
    'sn': ':ambulance:'
  },
  ':clock6:': {
    'tn': '6 Uhr',
    'uc': '1f555',
    'c': 'symbols',
    'o': 257,
    'sn': ':clock6:'
  },
  ':taurus:': {
    'tn': 'Stier_Zeichen',
    'uc': '2649',
    'c': 'symbols',
    'o': 31,
    'sn': ':taurus:'
  },
  ':safety_pin:': {
    'tn': 'Sicherheitsnadel',
    'uc': '1f9f7',
    'c': 'objects',
    'o': 806,
    'sn': ':safety_pin:'
  },
  ':flag_py:': {
    'tn': 'Fl_Paraguay',
    'uc': '1f1f5-1f1fe',
    'c': 'flags',
    'o': 2734,
    'sn': ':flag_py:'
  },
  ':selfie:': {
    'tn': 'Selfie',
    'uc': '1f933',
    'c': 'people',
    'o': 2267,
    'sn': ':selfie:'
  },
  ':warning:': {
    'tn': 'Warunung',
    'uc': '26a0',
    'c': 'symbols',
    'o': 96,
    'sn': ':warning:'
  },
  ':heartbeat:': {
    'tn': 'Herzschlag',
    'uc': '1f493',
    'c': 'symbols',
    'o': 12,
    'sn': ':heartbeat:'
  },
  ':flag_mv:': {
    'tn': 'Fl_Malediven',
    'uc': '1f1f2-1f1fb',
    'c': 'flags',
    'o': 2696,
    'sn': ':flag_mv:'
  },
  ':zero:': {
    'tn': '0',
    'uc': '0030-20e3',
    'c': 'symbols',
    'o': 142,
    'sn': ':zero:'
  },
  ':accept:': {
    'tn': 'akzeptieren',
    'uc': '1f251',
    'c': 'symbols',
    'o': 45,
    'sn': ':accept:'
  },
  ':flag_lu:': {
    'tn': 'Fl_Luxemburg',
    'uc': '1f1f1-1f1fa',
    'c': 'flags',
    'o': 2690,
    'sn': ':flag_lu:'
  },
  ':man_farmer:': {
    'tn': 'Bauer',
    'uc': '1f468-1f33e',
    'c': 'people',
    'o': 1685,
    'sn': ':man_farmer:'
  },
  ':people_with_bunny_ears_partying:': {
    'tn': 'Menschen_Haasenohren',
    'uc': '1f46f',
    'c': 'people',
    'o': 2285,
    'sn': ':people_with_bunny_ears_partying:'
  },
  ':moneybag:': {
    'tn': 'Geldsack',
    'uc': '1f4b0',
    'c': 'objects',
    'o': 671,
    'sn': ':moneybag:'
  },
  ':closed_book:': {
    'tn': 'Buch_rot',
    'uc': '1f4d5',
    'c': 'objects',
    'o': 794,
    'sn': ':closed_book:'
  },
  ':family_man_girl:': {
    'tn': 'Single_Mann_F',
    'uc': '1f468-1f467',
    'c': 'people',
    'o': 2363,
    'sn': ':family_man_girl:'
  },
  ':flag_ir:': {
    'tn': 'Fl_Iran',
    'uc': '1f1ee-1f1f7',
    'c': 'flags',
    'o': 2665,
    'sn': ':flag_ir:'
  },
  ':grapes:': {
    'tn': 'Trauben',
    'uc': '1f347',
    'c': 'food',
    'o': 1005,
    'sn': ':grapes:'
  },
  ':maple_leaf:': {
    'tn': 'Ahornblatt',
    'uc': '1f341',
    'c': 'nature',
    'o': 939,
    'sn': ':maple_leaf:'
  },
  ':child:': {
    'tn': 'Kind',
    'uc': '1f9d2',
    'c': 'people',
    'o': 1445,
    'sn': ':child:'
  },
  ':champagne:': {
    'tn': 'Champagner',
    'uc': '1f37e',
    'c': 'food',
    'o': 1096,
    'sn': ':champagne:'
  },
  ':flag_gp:': {
    'tn': 'Fl_Guadeloupe',
    'uc': '1f1ec-1f1f5',
    'c': 'flags',
    'o': 2651,
    'sn': ':flag_gp:'
  },
  ':flag_fo:': {
    'tn': 'Fl_Färöer',
    'uc': '1f1eb-1f1f4',
    'c': 'flags',
    'o': 2635,
    'sn': ':flag_fo:'
  },
  ':koko:': {
    'tn': 'hier',
    'uc': '1f201',
    'c': 'symbols',
    'o': 130,
    'sn': ':koko:'
  },
  ':dizzy_face:': {
    'tn': 'schwindelig',
    'uc': '1f635',
    'c': 'people',
    'o': 1181,
    'sn': ':dizzy_face:'
  },
  ':field_hockey:': {
    'tn': 'Hockey_Feld',
    'uc': '1f3d1',
    'c': 'activity',
    'o': 304,
    'sn': ':field_hockey:'
  },
  ':flag_dm:': {
    'tn': 'Fl_Dominica',
    'uc': '1f1e9-1f1f2',
    'c': 'flags',
    'o': 2624,
    'sn': ':flag_dm:'
  },
  ':smiley_cat:': {
    'tn': 'smiley_Katze',
    'uc': '1f63a',
    'c': 'people',
    'o': 1205,
    'sn': ':smiley_cat:'
  },
  ':frowning:': {
    'tn': 'missbilligend',
    'uc': '1f626',
    'c': 'people',
    'o': 1174,
    'sn': ':frowning:'
  },
  ':flag_cl:': {
    'tn': 'Fl_Chile',
    'uc': '1f1e8-1f1f1',
    'c': 'flags',
    'o': 2606,
    'sn': ':flag_cl:'
  },
  ':cityscape:': {
    'tn': 'Skyline',
    'uc': '1f3d9',
    'c': 'travel',
    'o': 2548,
    'sn': ':cityscape:'
  },
  ':seedling:': {
    'tn': 'Setzling',
    'uc': '1f331',
    'c': 'nature',
    'o': 931,
    'sn': ':seedling:'
  },
  ':back:': {
    'tn': 'Zurück',
    'uc': '1f519',
    'c': 'symbols',
    'o': 205,
    'sn': ':back:'
  },
  ':clock830:': {
    'tn': '08:30 Uhr',
    'uc': '1f563',
    'c': 'symbols',
    'o': 271,
    'sn': ':clock830:'
  },
  ':radio:': {
    'tn': 'Radio',
    'uc': '1f4fb',
    'c': 'objects',
    'o': 645,
    'sn': ':radio:'
  },
  ':mailbox_with_no_mail:': {
    'tn': 'Briefkasten_leer',
    'uc': '1f4ed',
    'c': 'objects',
    'o': 766,
    'sn': ':mailbox_with_no_mail:'
  },
  ':family_woman_girl_girl:': {
    'tn': 'Single_Frau_FF',
    'uc': '1f469-1f467-1f467',
    'c': 'people',
    'o': 2361,
    'sn': ':family_woman_girl_girl:'
  },
  ':kissing_cat:': {
    'tn': 'Kuss_Katze',
    'uc': '1f63d',
    'c': 'people',
    'o': 1210,
    'sn': ':kissing_cat:'
  },
  ':woman_pilot:': {
    'tn': 'Pilotin',
    'uc': '1f469-2708',
    'c': 'people',
    'o': 1823,
    'sn': ':woman_pilot:'
  },
  ':family_wwgg:': {
    'tn': 'Familie_FFFF',
    'uc': '1f469-1f469-1f467-1f467',
    'c': 'people',
    'o': 2351,
    'sn': ':family_wwgg:'
  },
  ':cow2:': {
    'tn': 'Kuh2',
    'uc': '1f404',
    'c': 'nature',
    'o': 905,
    'sn': ':cow2:'
  },
  ':family_mmb:': {
    'tn': 'Familie_MMM',
    'uc': '1f468-1f468-1f466',
    'c': 'people',
    'o': 2352,
    'sn': ':family_mmb:'
  },
  ':pouting_cat:': {
    'tn': 'schmollend_Katze',
    'uc': '1f63e',
    'c': 'people',
    'o': 1213,
    'sn': ':pouting_cat:'
  },
  ':post_office:': {
    'tn': 'Postamt',
    'uc': '1f3e3',
    'c': 'travel',
    'o': 2520,
    'sn': ':post_office:'
  },
  ':pushpin:': {
    'tn': 'Reißzwecke1',
    'uc': '1f4cc',
    'c': 'objects',
    'o': 807,
    'sn': ':pushpin:'
  },
  ':family_wwbb:': {
    'tn': 'Familie_FFMM',
    'uc': '1f469-1f469-1f466-1f466',
    'c': 'people',
    'o': 2350,
    'sn': ':family_wwbb:'
  },
  ':clock5:': {
    'tn': '5 Uhr',
    'uc': '1f554',
    'c': 'symbols',
    'o': 256,
    'sn': ':clock5:'
  },
  ':church:': {
    'tn': 'Kirche',
    'uc': '26ea',
    'c': 'travel',
    'o': 2530,
    'sn': ':church:'
  },
  ':love_hotel:': {
    'tn': 'Liebeshotel',
    'uc': '1f3e9',
    'c': 'travel',
    'o': 2527,
    'sn': ':love_hotel:'
  },
  ':end:': {
    'tn': 'Ende',
    'uc': '1f51a',
    'c': 'symbols',
    'o': 204,
    'sn': ':end:'
  },
  ':satellite:': {
    'tn': 'Radioteleskop',
    'uc': '1f4e1',
    'c': 'objects',
    'o': 655,
    'sn': ':satellite:'
  },
  ':bouquet:': {
    'tn': 'Blumenstrauß',
    'uc': '1f490',
    'c': 'nature',
    'o': 942,
    'sn': ':bouquet:'
  },
  ':keyboard:': {
    'tn': 'Tastatur',
    'uc': '2328',
    'c': 'objects',
    'o': 620,
    'sn': ':keyboard:'
  },
  ':chess_pawn:': {
    'tn': 'Schachfigur',
    'uc': '265f',
    'c': 'objects',
    'o': 626,
    'sn': ':chess_pawn:'
  },
  ':digit_seven:': {
    'tn': 'Ziffer sieben',
    'uc': '0037',
    'c': 'symbols',
    'o': 283,
    'sn': ':digit_seven:'
  },
  ':family_mmgg:': {
    'tn': 'Familie_MMFF',
    'uc': '1f468-1f468-1f467-1f467',
    'c': 'people',
    'o': 2356,
    'sn': ':family_mmgg:'
  },
  ':airplane_departure:': {
    'tn': 'Flugzeug_abheben',
    'uc': '1f6eb',
    'c': 'travel',
    'o': 2469,
    'sn': ':airplane_departure:'
  },
  ':family_wwb:': {
    'tn': 'Familie_FFM',
    'uc': '1f469-1f469-1f466',
    'c': 'people',
    'o': 2347,
    'sn': ':family_wwb:'
  },
  ':man_golfing:': {
    'tn': 'Golfer',
    'uc': '1f3cc-2642',
    'c': 'activity',
    'o': 414,
    'sn': ':man_golfing:'
  },
  ':tools:': {
    'tn': 'Werkzeuge',
    'uc': '1f6e0',
    'c': 'objects',
    'o': 681,
    'sn': ':tools:'
  },
  ':flag_mu:': {
    'tn': 'Fl_Mauritius',
    'uc': '1f1f2-1f1fa',
    'c': 'flags',
    'o': 2702,
    'sn': ':flag_mu:'
  },
  ':part_alternation_mark:': {
    'tn': 'Teilwechselmarke',
    'uc': '303d',
    'c': 'symbols',
    'o': 95,
    'sn': ':part_alternation_mark:'
  },
  ':flag_lt:': {
    'tn': 'Fl_Litauen',
    'uc': '1f1f1-1f1f9',
    'c': 'flags',
    'o': 2689,
    'sn': ':flag_lt:'
  },
  ':closed_lock_with_key:': {
    'tn': 'Schloss_Schlüssel',
    'uc': '1f510',
    'c': 'objects',
    'o': 820,
    'sn': ':closed_lock_with_key:'
  },
  ':school_satchel:': {
    'tn': 'Schultasche',
    'uc': '1f392',
    'c': 'people',
    'o': 2396,
    'sn': ':school_satchel:'
  },
  ':put_litter_in_its_place:': {
    'tn': 'Müll_wegschmeißen',
    'uc': '1f6ae',
    'c': 'symbols',
    'o': 127,
    'sn': ':put_litter_in_its_place:'
  },
  ':family_mmbb:': {
    'tn': 'Familie_MMMM',
    'uc': '1f468-1f468-1f466-1f466',
    'c': 'people',
    'o': 2355,
    'sn': ':family_mmbb:'
  },
  ':sheep:': {
    'tn': 'Schaf',
    'uc': '1f411',
    'c': 'nature',
    'o': 909,
    'sn': ':sheep:'
  },
  ':flag_iq:': {
    'tn': 'Fl_Irak',
    'uc': '1f1ee-1f1f6',
    'c': 'flags',
    'o': 2666,
    'sn': ':flag_iq:'
  },
  ':underage:': {
    'tn': 'nicht für Minderjährige',
    'uc': '1f51e',
    'c': 'symbols',
    'o': 84,
    'sn': ':underage:'
  },
  ':control_knobs:': {
    'tn': 'Knöpfe',
    'uc': '1f39b',
    'c': 'objects',
    'o': 648,
    'sn': ':control_knobs:'
  },
  ':pouch:': {
    'tn': 'Beutel',
    'uc': '1f45d',
    'c': 'people',
    'o': 2392,
    'sn': ':pouch:'
  },
  ':triumph:': {
    'tn': 'schnauben',
    'uc': '1f624',
    'c': 'people',
    'o': 1149,
    'sn': ':triumph:'
  },
  ':bust_in_silhouette:': {
    'tn': 'Schattenriss',
    'uc': '1f464',
    'c': 'people',
    'o': 1431,
    'sn': ':bust_in_silhouette:'
  },
  ':track_next:': {
    'tn': 'Nächster',
    'uc': '23ed',
    'c': 'symbols',
    'o': 162,
    'sn': ':track_next:'
  },
  ':woman_scientist:': {
    'tn': 'Wissenschaftlerin',
    'uc': '1f469-1f52c',
    'c': 'people',
    'o': 1787,
    'sn': ':woman_scientist:'
  },
  ':large_orange_diamond:': {
    'tn': 'Viereck_groß_orange',
    'uc': '1f536',
    'c': 'symbols',
    'o': 220,
    'sn': ':large_orange_diamond:'
  },
  ':potato:': {
    'tn': 'Kartoffel',
    'uc': '1f954',
    'c': 'food',
    'o': 1023,
    'sn': ':potato:'
  },
  ':lying_face:': {
    'tn': 'Lügner',
    'uc': '1f925',
    'c': 'people',
    'o': 1167,
    'sn': ':lying_face:'
  },
  ':flag_ck:': {
    'tn': 'Fl_Cookinseln',
    'uc': '1f1e8-1f1f0',
    'c': 'flags',
    'o': 2614,
    'sn': ':flag_ck:'
  },
  ':crescent_moon:': {
    'tn': 'Mond_halb',
    'uc': '1f319',
    'c': 'nature',
    'o': 963,
    'sn': ':crescent_moon:'
  },
  ':flag_bj:': {
    'tn': 'Fl_Benin',
    'uc': '1f1e7-1f1ef',
    'c': 'flags',
    'o': 2584,
    'sn': ':flag_bj:'
  },
  ':symbols:': {
    'tn': 'Symbole',
    'uc': '1f523',
    'c': 'symbols',
    'o': 131,
    'sn': ':symbols:'
  },
  ':flag_ai:': {
    'tn': 'Fl_Anguilla',
    'uc': '1f1e6-1f1ee',
    'c': 'flags',
    'o': 2568,
    'sn': ':flag_ai:'
  },
  ':lock_with_ink_pen:': {
    'tn': 'Schloss_Füller',
    'uc': '1f50f',
    'c': 'objects',
    'o': 819,
    'sn': ':lock_with_ink_pen:'
  },
  ':small_blue_diamond:': {
    'tn': 'Viereck_klein_blau',
    'uc': '1f539',
    'c': 'symbols',
    'o': 219,
    'sn': ':small_blue_diamond:'
  },
  ':arrow_double_down:': {
    'tn': 'Pfeil_doppelt_unten',
    'uc': '23ec',
    'c': 'symbols',
    'o': 167,
    'sn': ':arrow_double_down:'
  },
  ':atm:': {
    'tn': 'Bankautomat',
    'uc': '1f3e7',
    'c': 'symbols',
    'o': 113,
    'sn': ':atm:'
  },
  ':pear:': {
    'tn': 'Birne',
    'uc': '1f350',
    'c': 'food',
    'o': 1000,
    'sn': ':pear:'
  },
  ':biohazard:': {
    'tn': 'Biogefahr',
    'uc': '2623',
    'c': 'symbols',
    'o': 47,
    'sn': ':biohazard:'
  },
  ':kissing_closed_eyes:': {
    'tn': 'Kuss_Augen_auf',
    'uc': '1f61a',
    'c': 'people',
    'o': 1123,
    'sn': ':kissing_closed_eyes:'
  },
  ':man_tipping_hand:': {
    'tn': 'Assistent',
    'uc': '1f481-2642',
    'c': 'people',
    'o': 2075,
    'sn': ':man_tipping_hand:'
  },
  ':eggplant:': {
    'tn': 'Aubergine',
    'uc': '1f346',
    'c': 'food',
    'o': 1015,
    'sn': ':eggplant:'
  },
  ':amphora:': {
    'tn': 'Amphore',
    'uc': '1f3fa',
    'c': 'objects',
    'o': 695,
    'sn': ':amphora:'
  },
  ':race_car:': {
    'tn': 'Auto_Rennen',
    'uc': '1f3ce',
    'c': 'travel',
    'o': 2436,
    'sn': ':race_car:'
  },
  ':woman_judge:': {
    'tn': 'Richterin',
    'uc': '1f469-2696',
    'c': 'people',
    'o': 1847,
    'sn': ':woman_judge:'
  },
  ':wine_glass:': {
    'tn': 'Weinglas',
    'uc': '1f377',
    'c': 'food',
    'o': 1092,
    'sn': ':wine_glass:'
  },
  ':hammer:': {
    'tn': 'Hammer',
    'uc': '1f528',
    'c': 'objects',
    'o': 679,
    'sn': ':hammer:'
  },
  ':man_running:': {
    'tn': 'Mann_rennt',
    'uc': '1f3c3-2642',
    'c': 'people',
    'o': 2324,
    'sn': ':man_running:'
  },
  ':flag_za:': {
    'tn': 'Fl_SüdAfrika',
    'uc': '1f1ff-1f1e6',
    'c': 'flags',
    'o': 2761,
    'sn': ':flag_za:'
  },
  ':apple:': {
    'tn': 'Apfel_rot',
    'uc': '1f34e',
    'c': 'food',
    'o': 999,
    'sn': ':apple:'
  },
  ':scream_cat:': {
    'tn': 'Schrei_Katze',
    'uc': '1f640',
    'c': 'people',
    'o': 1211,
    'sn': ':scream_cat:'
  },
  ':flashlight:': {
    'tn': 'Taschenlampe',
    'uc': '1f526',
    'c': 'objects',
    'o': 661,
    'sn': ':flashlight:'
  },
  ':white_circle:': {
    'tn': 'Kreis_weiß',
    'uc': '26aa',
    'c': 'symbols',
    'o': 212,
    'sn': ':white_circle:'
  },
  ':man:': {
    'tn': 'Mann',
    'uc': '1f468',
    'c': 'people',
    'o': 1469,
    'sn': ':man:'
  },
  ':drum:': {
    'tn': 'Trommel',
    'uc': '1f941',
    'c': 'activity',
    'o': 606,
    'sn': ':drum:'
  },
  ':zombie:': {
    'tn': 'Zombie',
    'uc': '1f9df',
    'c': 'people',
    'o': 1985,
    'sn': ':zombie:'
  },
  ':man_elf:': {
    'tn': 'Elf',
    'uc': '1f9dd-2642',
    'c': 'people',
    'o': 1961,
    'sn': ':man_elf:'
  },
  ':zzz:': {
    'tn': 'zzz',
    'uc': '1f4a4',
    'c': 'symbols',
    'o': 112,
    'sn': ':zzz:'
  },
  ':clock4:': {
    'tn': '4 Uhr',
    'uc': '1f553',
    'c': 'symbols',
    'o': 255,
    'sn': ':clock4:'
  },
  ':printer:': {
    'tn': 'Drucker',
    'uc': '1f5a8',
    'c': 'objects',
    'o': 622,
    'sn': ':printer:'
  },
  ':woozy_face:': {
    'tn': 'verrücktes Gesicht',
    'uc': '1f974',
    'c': 'people',
    'o': 1183,
    'sn': ':woozy_face:'
  },
  ':flag_sz:': {
    'tn': 'Fl_Swaziland',
    'uc': '1f1f8-1f1ff',
    'c': 'flags',
    'o': 2774,
    'sn': ':flag_sz:'
  },
  ':basket:': {
    'tn': 'Korb',
    'uc': '1f9fa',
    'c': 'objects',
    'o': 721,
    'sn': ':basket:'
  },
  ':t_rex:': {
    'tn': 'T_Rex',
    'uc': '1f996',
    'c': 'nature',
    'o': 877,
    'sn': ':t_rex:'
  },
  ':shamrock:': {
    'tn': 'Kleeblatt',
    'uc': '2618',
    'c': 'nature',
    'o': 933,
    'sn': ':shamrock:'
  },
  ':flag_pw:': {
    'tn': 'Fl_Palau',
    'uc': '1f1f5-1f1fc',
    'c': 'flags',
    'o': 2730,
    'sn': ':flag_pw:'
  },
  ':cooking:': {
    'tn': 'Spiegelei_Pfanne',
    'uc': '1f373',
    'c': 'food',
    'o': 1032,
    'sn': ':cooking:'
  },
  ':question:': {
    'tn': 'Fragezeichen_rot',
    'uc': '2753',
    'c': 'symbols',
    'o': 89,
    'sn': ':question:'
  },
  ':flag_nu:': {
    'tn': 'Fl_Niue',
    'uc': '1f1f3-1f1fa',
    'c': 'flags',
    'o': 2723,
    'sn': ':flag_nu:'
  },
  ':sparkling_heart:': {
    'tn': 'Herz_glitzernd',
    'uc': '1f496',
    'c': 'symbols',
    'o': 14,
    'sn': ':sparkling_heart:'
  },
  ':orange_book:': {
    'tn': 'Buch_orange',
    'uc': '1f4d9',
    'c': 'objects',
    'o': 797,
    'sn': ':orange_book:'
  },
  ':place_of_worship:': {
    'tn': 'Anbetungsstätte',
    'uc': '1f6d0',
    'c': 'symbols',
    'o': 28,
    'sn': ':place_of_worship:'
  },
  ':flag_mt:': {
    'tn': 'Fl_Malta',
    'uc': '1f1f2-1f1f9',
    'c': 'flags',
    'o': 2698,
    'sn': ':flag_mt:'
  },
  ':tophat:': {
    'tn': 'Zylinder',
    'uc': '1f3a9',
    'c': 'people',
    'o': 2386,
    'sn': ':tophat:'
  },
  ':adult:': {
    'tn': 'Erwachsener',
    'uc': '1f9d1',
    'c': 'people',
    'o': 1463,
    'sn': ':adult:'
  },
  ':star_and_crescent:': {
    'tn': 'Halbmond_Stern',
    'uc': '262a',
    'c': 'symbols',
    'o': 20,
    'sn': ':star_and_crescent:'
  },
  ':crayon:': {
    'tn': 'Wachsmalstift',
    'uc': '1f58d',
    'c': 'objects',
    'o': 814,
    'sn': ':crayon:'
  },
  ':medical_symbol:': {
    'tn': 'Medizin',
    'uc': '2695',
    'c': 'symbols',
    'o': 290,
    'sn': ':medical_symbol:'
  },
  ':flag_ls:': {
    'tn': 'Fl_Lesotho',
    'uc': '1f1f1-1f1f8',
    'c': 'flags',
    'o': 2685,
    'sn': ':flag_ls:'
  },
  ':cucumber:': {
    'tn': 'Gurke',
    'uc': '1f952',
    'c': 'food',
    'o': 1019,
    'sn': ':cucumber:'
  },
  ':flag_kr:': {
    'tn': 'Fl_Korea',
    'uc': '1f1f0-1f1f7',
    'c': 'flags',
    'o': 2762,
    'sn': ':flag_kr:'
  },
  ':hammer_pick:': {
    'tn': 'Hammer_Hacke',
    'uc': '2692',
    'c': 'objects',
    'o': 680,
    'sn': ':hammer_pick:'
  },
  ':rice_scene:': {
    'tn': 'Reis_Szene',
    'uc': '1f391',
    'c': 'travel',
    'o': 2538,
    'sn': ':rice_scene:'
  },
  ':digit_two:': {
    'tn': 'Ziffer zwei',
    'uc': '0032',
    'c': 'symbols',
    'o': 278,
    'sn': ':digit_two:'
  },
  ':ferry:': {
    'tn': 'Fähre',
    'uc': '26f4',
    'c': 'travel',
    'o': 2483,
    'sn': ':ferry:'
  },
  ':flag_gn:': {
    'tn': 'Fl_Guinea',
    'uc': '1f1ec-1f1f3',
    'c': 'flags',
    'o': 2655,
    'sn': ':flag_gn:'
  },
  ':woman_rowing_boat:': {
    'tn': 'Rudererin',
    'uc': '1f6a3-2640',
    'c': 'activity',
    'o': 504,
    'sn': ':woman_rowing_boat:'
  },
  ':martial_arts_uniform:': {
    'tn': 'Karateanzug',
    'uc': '1f94b',
    'c': 'activity',
    'o': 312,
    'sn': ':martial_arts_uniform:'
  },
  ':flag_fm:': {
    'tn': 'Fl_Mikronesien',
    'uc': '1f1eb-1f1f2',
    'c': 'flags',
    'o': 2705,
    'sn': ':flag_fm:'
  },
  ':weary:': {
    'tn': 'müde2',
    'uc': '1f629',
    'c': 'people',
    'o': 1146,
    'sn': ':weary:'
  },
  ':flag_dk:': {
    'tn': 'Fl_Dänemark',
    'uc': '1f1e9-1f1f0',
    'c': 'flags',
    'o': 2622,
    'sn': ':flag_dk:'
  },
  ':nail_care:': {
    'tn': 'Nagelpflege',
    'uc': '1f485',
    'c': 'people',
    'o': 2261,
    'sn': ':nail_care:'
  },
  ':flag_bi:': {
    'tn': 'Fl_Burundi',
    'uc': '1f1e7-1f1ee',
    'c': 'flags',
    'o': 2596,
    'sn': ':flag_bi:'
  },
  ':man_juggling:': {
    'tn': 'Jongleur',
    'uc': '1f939-2642',
    'c': 'activity',
    'o': 593,
    'sn': ':man_juggling:'
  },
  ':four:': {
    'tn': '4',
    'uc': '0034-20e3',
    'c': 'symbols',
    'o': 146,
    'sn': ':four:'
  },
  ':clock730:': {
    'tn': '07:30 Uhr',
    'uc': '1f562',
    'c': 'symbols',
    'o': 270,
    'sn': ':clock730:'
  },
  ':slot_machine:': {
    'tn': 'Spielautomat',
    'uc': '1f3b0',
    'c': 'activity',
    'o': 615,
    'sn': ':slot_machine:'
  },
  ':popcorn:': {
    'tn': 'Popcorn',
    'uc': '1f37f',
    'c': 'food',
    'o': 1075,
    'sn': ':popcorn:'
  },
  ':shallow_pan_of_food:': {
    'tn': 'Pfanne_mit_Essen',
    'uc': '1f958',
    'c': 'food',
    'o': 1047,
    'sn': ':shallow_pan_of_food:'
  },
  ':military_medal:': {
    'tn': 'Tapferkeitsmedallie',
    'uc': '1f396',
    'c': 'activity',
    'o': 575,
    'sn': ':military_medal:'
  },
  ':japanese_ogre:': {
    'tn': 'japanischer_Oger',
    'uc': '1f479',
    'c': 'people',
    'o': 1194,
    'sn': ':japanese_ogre:'
  },
  ':camera:': {
    'tn': 'Kamera',
    'uc': '1f4f7',
    'c': 'objects',
    'o': 634,
    'sn': ':camera:'
  },
  ':cupid:': {
    'tn': 'Herz_Pfeil',
    'uc': '1f498',
    'c': 'symbols',
    'o': 15,
    'sn': ':cupid:'
  },
  ':handbag:': {
    'tn': 'Handtasche',
    'uc': '1f45c',
    'c': 'people',
    'o': 2394,
    'sn': ':handbag:'
  },
  ':newspaper:': {
    'tn': 'Zeitung2',
    'uc': '1f4f0',
    'c': 'objects',
    'o': 790,
    'sn': ':newspaper:'
  },
  ':spider:': {
    'tn': 'Spinne',
    'uc': '1f577',
    'c': 'nature',
    'o': 869,
    'sn': ':spider:'
  },
  ':convenience_store:': {
    'tn': 'Gemischtwarenladen',
    'uc': '1f3ea',
    'c': 'travel',
    'o': 2525,
    'sn': ':convenience_store:'
  },
  ':u6307:': {
    'tn': 'Richtungsweiser',
    'uc': '1f22f',
    'c': 'symbols',
    'o': 103,
    'sn': ':u6307:'
  },
  ':star_of_david:': {
    'tn': 'Davidstern',
    'uc': '2721',
    'c': 'symbols',
    'o': 23,
    'sn': ':star_of_david:'
  },
  ':four_leaf_clover:': {
    'tn': 'Vielblättriges_Kleeblatt',
    'uc': '1f340',
    'c': 'nature',
    'o': 934,
    'sn': ':four_leaf_clover:'
  },
  ':iphone:': {
    'tn': 'iPhone',
    'uc': '1f4f1',
    'c': 'objects',
    'o': 617,
    'sn': ':iphone:'
  },
  ':sneezing_face:': {
    'tn': 'niesen',
    'uc': '1f927',
    'c': 'people',
    'o': 1186,
    'sn': ':sneezing_face:'
  },
  ':flag_tz:': {
    'tn': 'Fl_Tansania',
    'uc': '1f1f9-1f1ff',
    'c': 'flags',
    'o': 2780,
    'sn': ':flag_tz:'
  },
  ':clock3:': {
    'tn': '3 Uhr',
    'uc': '1f552',
    'c': 'symbols',
    'o': 254,
    'sn': ':clock3:'
  },
  ':flag_sy:': {
    'tn': 'Fl_Syrien',
    'uc': '1f1f8-1f1fe',
    'c': 'flags',
    'o': 2777,
    'sn': ':flag_sy:'
  },
  ':green_book:': {
    'tn': 'Buch_grün',
    'uc': '1f4d7',
    'c': 'objects',
    'o': 795,
    'sn': ':green_book:'
  },
  ':headphones:': {
    'tn': 'Kopfhörer',
    'uc': '1f3a7',
    'c': 'activity',
    'o': 603,
    'sn': ':headphones:'
  },
  ':hiking_boot:': {
    'tn': 'Wanderstiefel',
    'uc': '1f97e',
    'c': 'people',
    'o': 2381,
    'sn': ':hiking_boot:'
  },
  ':champagne_glass:': {
    'tn': 'Champagner_Gläser',
    'uc': '1f942',
    'c': 'food',
    'o': 1091,
    'sn': ':champagne_glass:'
  },
  ':wind_chime:': {
    'tn': 'Windspiel',
    'uc': '1f390',
    'c': 'objects',
    'o': 752,
    'sn': ':wind_chime:'
  },
  ':star_struck:': {
    'tn': 'Augen_Sterne',
    'uc': '1f929',
    'c': 'people',
    'o': 1133,
    'sn': ':star_struck:'
  },
  ':flag_ms:': {
    'tn': 'Fl_Montserrat',
    'uc': '1f1f2-1f1f8',
    'c': 'flags',
    'o': 2710,
    'sn': ':flag_ms:'
  },
  ':flag_lr:': {
    'tn': 'Fl_Liberia',
    'uc': '1f1f1-1f1f7',
    'c': 'flags',
    'o': 2686,
    'sn': ':flag_lr:'
  },
  ':call_me:': {
    'tn': 'Ruf_an',
    'uc': '1f919',
    'c': 'people',
    'o': 1365,
    'sn': ':call_me:'
  },
  ':helmet_with_cross:': {
    'tn': 'Helm_Kreuz',
    'uc': '26d1',
    'c': 'people',
    'o': 2390,
    'sn': ':helmet_with_cross:'
  },
  ':woman_cook:': {
    'tn': 'Köchin',
    'uc': '1f469-1f373',
    'c': 'people',
    'o': 1691,
    'sn': ':woman_cook:'
  },
  ':flag_jp:': {
    'tn': 'Fl_Japan',
    'uc': '1f1ef-1f1f5',
    'c': 'flags',
    'o': 2672,
    'sn': ':flag_jp:'
  },
  ':ferris_wheel:': {
    'tn': 'Riesenrad',
    'uc': '1f3a1',
    'c': 'travel',
    'o': 2498,
    'sn': ':ferris_wheel:'
  },
  ':leopard:': {
    'tn': 'Leopard',
    'uc': '1f406',
    'c': 'nature',
    'o': 893,
    'sn': ':leopard:'
  },
  ':sweat_drops:': {
    'tn': 'Schweißtropfen',
    'uc': '1f4a6',
    'c': 'nature',
    'o': 993,
    'sn': ':sweat_drops:'
  },
  ':flag_io:': {
    'tn': 'Fl_BTIO',
    'uc': '1f1ee-1f1f4',
    'c': 'flags',
    'o': 2591,
    'sn': ':flag_io:'
  },
  ':seat:': {
    'tn': 'Sitz',
    'uc': '1f4ba',
    'c': 'travel',
    'o': 2472,
    'sn': ':seat:'
  },
  ':flag_hn:': {
    'tn': 'Fl_Honduras',
    'uc': '1f1ed-1f1f3',
    'c': 'flags',
    'o': 2659,
    'sn': ':flag_hn:'
  },
  ':woman_frowning:': {
    'tn': 'Frau_denken',
    'uc': '1f64d-2640',
    'c': 'people',
    'o': 2195,
    'sn': ':woman_frowning:'
  },
  ':flag_gm:': {
    'tn': 'Fl_Gambia',
    'uc': '1f1ec-1f1f2',
    'c': 'flags',
    'o': 2643,
    'sn': ':flag_gm:'
  },
  ':metro:': {
    'tn': 'Ubahn',
    'uc': '1f687',
    'c': 'travel',
    'o': 2465,
    'sn': ':metro:'
  },
  ':sunrise_over_mountains:': {
    'tn': 'Sonnenaufgang_Gebirge',
    'uc': '1f304',
    'c': 'travel',
    'o': 2541,
    'sn': ':sunrise_over_mountains:'
  },
  ':fallen_leaf:': {
    'tn': 'Blätter_verwelkt',
    'uc': '1f342',
    'c': 'nature',
    'o': 938,
    'sn': ':fallen_leaf:'
  },
  ':flying_saucer:': {
    'tn': 'UFO',
    'uc': '1f6f8',
    'c': 'travel',
    'o': 2476,
    'sn': ':flying_saucer:'
  },
  ':flag_dj:': {
    'tn': 'Fl_Djibouti',
    'uc': '1f1e9-1f1ef',
    'c': 'flags',
    'o': 2623,
    'sn': ':flag_dj:'
  },
  ':flag_ci:': {
    'tn': 'Fl_Elfenbeinküste',
    'uc': '1f1e8-1f1ee',
    'c': 'flags',
    'o': 2616,
    'sn': ':flag_ci:'
  },
  ':clock630:': {
    'tn': '06:30 Uhr',
    'uc': '1f561',
    'c': 'symbols',
    'o': 269,
    'sn': ':clock630:'
  },
  ':basketball:': {
    'tn': 'Ball_Basketball',
    'uc': '1f3c0',
    'c': 'activity',
    'o': 292,
    'sn': ':basketball:'
  },
  ':flag_bh:': {
    'tn': 'Fl_Bahrain',
    'uc': '1f1e7-1f1ed',
    'c': 'flags',
    'o': 2578,
    'sn': ':flag_bh:'
  },
  ':flag_ag:': {
    'tn': 'Fl_Antigua_B',
    'uc': '1f1e6-1f1ec',
    'c': 'flags',
    'o': 2570,
    'sn': ':flag_ag:'
  },
  ':dango:': {
    'tn': 'Dango',
    'uc': '1f361',
    'c': 'food',
    'o': 1062,
    'sn': ':dango:'
  },
  ':om_symbol:': {
    'tn': 'Om_Symbol',
    'uc': '1f549',
    'c': 'symbols',
    'o': 21,
    'sn': ':om_symbol:'
  },
  ':banana:': {
    'tn': 'Banane',
    'uc': '1f34c',
    'c': 'food',
    'o': 1003,
    'sn': ':banana:'
  },
  ':drooling_face:': {
    'tn': 'sabbern',
    'uc': '1f924',
    'c': 'people',
    'o': 1179,
    'sn': ':drooling_face:'
  },
  ':woman_artist:': {
    'tn': 'Künstlerin',
    'uc': '1f469-1f3a8',
    'c': 'people',
    'o': 1799,
    'sn': ':woman_artist:'
  },
  ':cold_face:': {
    'tn': 'kaltes Gesicht',
    'uc': '1f976',
    'c': 'people',
    'o': 1159,
    'sn': ':cold_face:'
  },
  ':tongue:': {
    'tn': 'Zunge',
    'uc': '1f445',
    'c': 'people',
    'o': 1411,
    'sn': ':tongue:'
  },
  ':pig2:': {
    'tn': 'Schwein2',
    'uc': '1f416',
    'c': 'nature',
    'o': 907,
    'sn': ':pig2:'
  },
  ':umbrella:': {
    'tn': 'Regenschirm',
    'uc': '2614',
    'c': 'nature',
    'o': 994,
    'sn': ':umbrella:'
  },
  ':x:': {
    'tn': 'X',
    'uc': '274c',
    'c': 'symbols',
    'o': 71,
    'sn': ':x:'
  },
  ':man_playing_handball:': {
    'tn': 'Handballspieler',
    'uc': '1f93e-2642',
    'c': 'activity',
    'o': 396,
    'sn': ':man_playing_handball:'
  },
  ':woman_detective:': {
    'tn': 'Detektivin',
    'uc': '1f575-2640',
    'c': 'people',
    'o': 1655,
    'sn': ':woman_detective:'
  },
  ':unicorn:': {
    'tn': 'Einhorn',
    'uc': '1f984',
    'c': 'nature',
    'o': 860,
    'sn': ':unicorn:'
  },
  ':cookie:': {
    'tn': 'Cookie',
    'uc': '1f36a',
    'c': 'food',
    'o': 1079,
    'sn': ':cookie:'
  },
  ':flag_uz:': {
    'tn': 'Fl_Usbekistan',
    'uc': '1f1fa-1f1ff',
    'c': 'flags',
    'o': 2802,
    'sn': ':flag_uz:'
  },
  ':heavy_minus_sign:': {
    'tn': 'Minus',
    'uc': '2796',
    'c': 'symbols',
    'o': 193,
    'sn': ':heavy_minus_sign:'
  },
  ':frog:': {
    'tn': 'Frosch',
    'uc': '1f438',
    'c': 'nature',
    'o': 838,
    'sn': ':frog:'
  },
  ':clock2:': {
    'tn': '2 Uhr',
    'uc': '1f551',
    'c': 'symbols',
    'o': 253,
    'sn': ':clock2:'
  },
  ':flag_sx:': {
    'tn': 'Fl_SintMaarten',
    'uc': '1f1f8-1f1fd',
    'c': 'flags',
    'o': 2755,
    'sn': ':flag_sx:'
  },
  ':yarn:': {
    'tn': 'Garn',
    'uc': '1f9f6',
    'c': 'objects',
    'o': 727,
    'sn': ':yarn:'
  },
  ':flag_rw:': {
    'tn': 'Fl_Rwanda',
    'uc': '1f1f7-1f1fc',
    'c': 'flags',
    'o': 2745,
    'sn': ':flag_rw:'
  },
  ':woman_fairy:': {
    'tn': 'Fee_w',
    'uc': '1f9da-2640',
    'c': 'people',
    'o': 2015,
    'sn': ':woman_fairy:'
  },
  ':cocktail:': {
    'tn': 'Cocktail',
    'uc': '1f378',
    'c': 'food',
    'o': 1094,
    'sn': ':cocktail:'
  },
  ':zipper_mouth:': {
    'tn': 'verschlossener_Mund',
    'uc': '1f910',
    'c': 'people',
    'o': 1182,
    'sn': ':zipper_mouth:'
  },
  ':first_place:': {
    'tn': 'Medallie_1',
    'uc': '1f947',
    'c': 'activity',
    'o': 571,
    'sn': ':first_place:'
  },
  ':grinning:': {
    'tn': 'grinsen',
    'uc': '1f600',
    'c': 'people',
    'o': 1103,
    'sn': ':grinning:'
  },
  ':digit_five:': {
    'tn': 'Ziffer fünf',
    'uc': '0035',
    'c': 'symbols',
    'o': 281,
    'sn': ':digit_five:'
  },
  ':parking:': {
    'tn': 'Parkplatz',
    'uc': '1f17f',
    'c': 'symbols',
    'o': 116,
    'sn': ':parking:'
  },
  ':pig_nose:': {
    'tn': 'Schwein_Rüssel',
    'uc': '1f43d',
    'c': 'nature',
    'o': 837,
    'sn': ':pig_nose:'
  },
  ':men_wrestling:': {
    'tn': 'Ringer',
    'uc': '1f93c-2642',
    'c': 'activity',
    'o': 346,
    'sn': ':men_wrestling:'
  },
  ':bone:': {
    'tn': 'Knochen',
    'uc': '1f9b4',
    'c': 'people',
    'o': 1428,
    'sn': ':bone:'
  },
  ':outbox_tray:': {
    'tn': 'Postausgang',
    'uc': '1f4e4',
    'c': 'objects',
    'o': 760,
    'sn': ':outbox_tray:'
  },
  ':woman_superhero:': {
    'tn': 'Frau_Superheld',
    'uc': '1f9b8-2640',
    'c': 'people',
    'o': 1901,
    'sn': ':woman_superhero:'
  },
  ':loop:': {
    'tn': 'Schleife_doppelt',
    'uc': '27bf',
    'c': 'symbols',
    'o': 203,
    'sn': ':loop:'
  },
  ':ear_of_rice:': {
    'tn': 'Ähren',
    'uc': '1f33e',
    'c': 'nature',
    'o': 941,
    'sn': ':ear_of_rice:'
  },
  ':flag_mr:': {
    'tn': 'Fl_Mauretanien',
    'uc': '1f1f2-1f1f7',
    'c': 'flags',
    'o': 2701,
    'sn': ':flag_mr:'
  },
  ':rabbit2:': {
    'tn': 'Kaninchen2',
    'uc': '1f407',
    'c': 'nature',
    'o': 918,
    'sn': ':rabbit2:'
  },
  ':flag_kp:': {
    'tn': 'Fl_NordKorea',
    'uc': '1f1f0-1f1f5',
    'c': 'flags',
    'o': 2725,
    'sn': ':flag_kp:'
  },
  ':fist:': {
    'tn': 'Faust',
    'uc': '270a',
    'c': 'people',
    'o': 1257,
    'sn': ':fist:'
  },
  ':flag_jo:': {
    'tn': 'Fl_Jordanien',
    'uc': '1f1ef-1f1f4',
    'c': 'flags',
    'o': 2675,
    'sn': ':flag_jo:'
  },
  ':flag_in:': {
    'tn': 'Fl_Indien',
    'uc': '1f1ee-1f1f3',
    'c': 'flags',
    'o': 2663,
    'sn': ':flag_in:'
  },
  ':flag_hm:': {
    'tn': 'Fl_McDonaldIS',
    'uc': '1f1ed-1f1f2',
    'c': 'flags',
    'o': 2817,
    'sn': ':flag_hm:'
  },
  ':no_mobile_phones:': {
    'tn': 'Handyverbot',
    'uc': '1f4f5',
    'c': 'symbols',
    'o': 85,
    'sn': ':no_mobile_phones:'
  },
  ':woman_cartwheeling:': {
    'tn': 'Frau_Radschlag',
    'uc': '1f938-2640',
    'c': 'activity',
    'o': 353,
    'sn': ':woman_cartwheeling:'
  },
  ':flag_gl:': {
    'tn': 'Fl_Grönland',
    'uc': '1f1ec-1f1f1',
    'c': 'flags',
    'o': 2649,
    'sn': ':flag_gl:'
  },
  ':hourglass:': {
    'tn': 'Sanduhr_leer',
    'uc': '231b',
    'c': 'objects',
    'o': 653,
    'sn': ':hourglass:'
  },
  ':steam_locomotive:': {
    'tn': 'Dampflok',
    'uc': '1f682',
    'c': 'travel',
    'o': 2463,
    'sn': ':steam_locomotive:'
  },
  ':bread:': {
    'tn': 'Brot',
    'uc': '1f35e',
    'c': 'food',
    'o': 1026,
    'sn': ':bread:'
  },
  ':flag_fk:': {
    'tn': 'Fl_FalklandIS',
    'uc': '1f1eb-1f1f0',
    'c': 'flags',
    'o': 2634,
    'sn': ':flag_fk:'
  },
  ':clock530:': {
    'tn': '05:30 Uhr',
    'uc': '1f560',
    'c': 'symbols',
    'o': 268,
    'sn': ':clock530:'
  },
  ':receipt:': {
    'tn': 'Quittung',
    'uc': '1f9fe',
    'c': 'objects',
    'o': 772,
    'sn': ':receipt:'
  },
  ':flag_ch:': {
    'tn': 'Fl_Schweiz',
    'uc': '1f1e8-1f1ed',
    'c': 'flags',
    'o': 2776,
    'sn': ':flag_ch:'
  },
  ':flag_bg:': {
    'tn': 'Fl_Bulgarien',
    'uc': '1f1e7-1f1ec',
    'c': 'flags',
    'o': 2594,
    'sn': ':flag_bg:'
  },
  ':signal_strength:': {
    'tn': 'Signalstärke',
    'uc': '1f4f6',
    'c': 'symbols',
    'o': 129,
    'sn': ':signal_strength:'
  },
  ':flag_af:': {
    'tn': 'Fl_Afghanistan',
    'uc': '1f1e6-1f1eb',
    'c': 'flags',
    'o': 2561,
    'sn': ':flag_af:'
  },
  ':digit_nine:': {
    'tn': 'Ziffer neun',
    'uc': '0039',
    'c': 'symbols',
    'o': 285,
    'sn': ':digit_nine:'
  },
  ':family:': {
    'tn': 'Familie',
    'uc': '1f46a',
    'c': 'people',
    'o': 2341,
    'sn': ':family:'
  },
  ':unlock:': {
    'tn': 'entsperrt',
    'uc': '1f513',
    'c': 'objects',
    'o': 2553,
    'sn': ':unlock:'
  },
  ':first_quarter_moon:': {
    'tn': 'Mond_zunehmend',
    'uc': '1f313',
    'c': 'nature',
    'o': 961,
    'sn': ':first_quarter_moon:'
  },
  ':snowman:': {
    'tn': 'Schneemann',
    'uc': '26c4',
    'c': 'nature',
    'o': 989,
    'sn': ':snowman:'
  },
  ':o2:': {
    'tn': 'Taste Kreis',
    'uc': '1f17e',
    'c': 'symbols',
    'o': 69,
    'sn': ':o2:'
  },
  ':closed_umbrella:': {
    'tn': 'Regenschirm',
    'uc': '1f302',
    'c': 'people',
    'o': 2400,
    'sn': ':closed_umbrella:'
  },
  ':purple_heart:': {
    'tn': 'Herz_lila',
    'uc': '1f49c',
    'c': 'symbols',
    'o': 6,
    'sn': ':purple_heart:'
  },
  ':baby_chick:': {
    'tn': 'Küken',
    'uc': '1f424',
    'c': 'nature',
    'o': 847,
    'sn': ':baby_chick:'
  },
  ':sos:': {
    'tn': 'Taste SOS',
    'uc': '1f198',
    'c': 'symbols',
    'o': 70,
    'sn': ':sos:'
  },
  ':rofl:': {
    'tn': 'rofl',
    'uc': '1f923',
    'c': 'people',
    'o': 1110,
    'sn': ':rofl:'
  },
  ':medal:': {
    'tn': 'Medallie',
    'uc': '1f3c5',
    'c': 'activity',
    'o': 574,
    'sn': ':medal:'
  },
  ':flag_uy:': {
    'tn': 'Fl_Uruguay',
    'uc': '1f1fa-1f1fe',
    'c': 'flags',
    'o': 2801,
    'sn': ':flag_uy:'
  },
  ':woman_zombie:': {
    'tn': 'Zombierin',
    'uc': '1f9df-2640',
    'c': 'people',
    'o': 1986,
    'sn': ':woman_zombie:'
  },
  ':man_biking:': {
    'tn': 'Fahrradfahrer',
    'uc': '1f6b4-2642',
    'c': 'activity',
    'o': 564,
    'sn': ':man_biking:'
  },
  ':clock1:': {
    'tn': '1 Uhr',
    'uc': '1f550',
    'c': 'symbols',
    'o': 252,
    'sn': ':clock1:'
  },
  ':womans_flat_shoe:': {
    'tn': 'flacher Schuh der Frau',
    'uc': '1f97f',
    'c': 'people',
    'o': 2382,
    'sn': ':womans_flat_shoe:'
  },
  ':card_index:': {
    'tn': 'Kartei',
    'uc': '1f4c7',
    'c': 'objects',
    'o': 781,
    'sn': ':card_index:'
  },
  ':dna:': {
    'tn': 'DNA',
    'uc': '1f9ec',
    'c': 'objects',
    'o': 702,
    'sn': ':dna:'
  },
  ':8ball:': {
    'tn': 'Billiard_8',
    'uc': '1f3b1',
    'c': 'activity',
    'o': 299,
    'sn': ':8ball:'
  },
  ':carrot:': {
    'tn': 'Karotte',
    'uc': '1f955',
    'c': 'food',
    'o': 1022,
    'sn': ':carrot:'
  },
  ':dress:': {
    'tn': 'Kleid',
    'uc': '1f457',
    'c': 'people',
    'o': 2372,
    'sn': ':dress:'
  },
  ':flag_pt:': {
    'tn': 'Fl_Portugal',
    'uc': '1f1f5-1f1f9',
    'c': 'flags',
    'o': 2739,
    'sn': ':flag_pt:'
  },
  ':heavy_division_sign:': {
    'tn': 'Geteilt',
    'uc': '2797',
    'c': 'symbols',
    'o': 194,
    'sn': ':heavy_division_sign:'
  },
  ':flag_nr:': {
    'tn': 'Fl_Nauru',
    'uc': '1f1f3-1f1f7',
    'c': 'flags',
    'o': 2715,
    'sn': ':flag_nr:'
  },
  ':flag_mq:': {
    'tn': 'Fl_Martinique',
    'uc': '1f1f2-1f1f6',
    'c': 'flags',
    'o': 2700,
    'sn': ':flag_mq:'
  },
  ':shopping_cart:': {
    'tn': 'Einkaufswagen',
    'uc': '1f6d2',
    'c': 'objects',
    'o': 743,
    'sn': ':shopping_cart:'
  },
  ':flag_im:': {
    'tn': 'Fl_Isleofman',
    'uc': '1f1ee-1f1f2',
    'c': 'flags',
    'o': 2668,
    'sn': ':flag_im:'
  },
  ':hockey:': {
    'tn': 'Hockey_Eis',
    'uc': '1f3d2',
    'c': 'activity',
    'o': 303,
    'sn': ':hockey:'
  },
  ':squeeze_bottle:': {
    'tn': 'Flasche drücken',
    'uc': '1f9f4',
    'c': 'objects',
    'o': 725,
    'sn': ':squeeze_bottle:'
  },
  ':sunny:': {
    'tn': 'sonnig',
    'uc': '2600',
    'c': 'nature',
    'o': 977,
    'sn': ':sunny:'
  },
  ':handshake:': {
    'tn': 'Hände_schütteln',
    'uc': '1f91d',
    'c': 'people',
    'o': 1238,
    'sn': ':handshake:'
  },
  ':clock430:': {
    'tn': '04:30 Uhr',
    'uc': '1f55f',
    'c': 'symbols',
    'o': 267,
    'sn': ':clock430:'
  },
  ':flag_fj:': {
    'tn': 'Fl_Fiji',
    'uc': '1f1eb-1f1ef',
    'c': 'flags',
    'o': 2636,
    'sn': ':flag_fj:'
  },
  ':leftwards_arrow_with_hook:': {
    'tn': 'Pfeil_Haken_links',
    'uc': '21a9',
    'c': 'symbols',
    'o': 182,
    'sn': ':leftwards_arrow_with_hook:'
  },
  ':crown:': {
    'tn': 'Krone',
    'uc': '1f451',
    'c': 'people',
    'o': 2391,
    'sn': ':crown:'
  },
  ':tractor:': {
    'tn': 'Traktor',
    'uc': '1f69c',
    'c': 'travel',
    'o': 2443,
    'sn': ':tractor:'
  },
  ':flag_cg:': {
    'tn': 'Fl_Kongo',
    'uc': '1f1e8-1f1ec',
    'c': 'flags',
    'o': 2612,
    'sn': ':flag_cg:'
  },
  ':flag_bf:': {
    'tn': 'Fl_BurkinaF',
    'uc': '1f1e7-1f1eb',
    'c': 'flags',
    'o': 2595,
    'sn': ':flag_bf:'
  },
  ':flag_ae:': {
    'tn': 'Fl_UAE',
    'uc': '1f1e6-1f1ea',
    'c': 'flags',
    'o': 2795,
    'sn': ':flag_ae:'
  },
  ':petri_dish:': {
    'tn': 'Petrischale',
    'uc': '1f9eb',
    'c': 'objects',
    'o': 701,
    'sn': ':petri_dish:'
  },
  ':bell:': {
    'tn': 'Glocke',
    'uc': '1f514',
    'c': 'symbols',
    'o': 236,
    'sn': ':bell:'
  },
  ':older_woman:': {
    'tn': 'ältere_Frau',
    'uc': '1f475',
    'c': 'people',
    'o': 1547,
    'sn': ':older_woman:'
  },
  ':postal_horn:': {
    'tn': 'Posthorn',
    'uc': '1f4ef',
    'c': 'objects',
    'o': 768,
    'sn': ':postal_horn:'
  },
  ':vulcan:': {
    'tn': 'vulkanischer_Gruß',
    'uc': '1f596',
    'c': 'people',
    'o': 1353,
    'sn': ':vulcan:'
  },
  ':sparkle:': {
    'tn': 'Sternchen',
    'uc': '2747',
    'c': 'symbols',
    'o': 105,
    'sn': ':sparkle:'
  },
  ':golf:': {
    'tn': 'Golf',
    'uc': '26f3',
    'c': 'activity',
    'o': 307,
    'sn': ':golf:'
  },
  ':eyes:': {
    'tn': 'Augen',
    'uc': '1f440',
    'c': 'people',
    'o': 1426,
    'sn': ':eyes:'
  },
  ':leo:': {
    'tn': 'Löwe_Zeichen',
    'uc': '264c',
    'c': 'symbols',
    'o': 34,
    'sn': ':leo:'
  },
  ':abcd:': {
    'tn': 'abcd',
    'uc': '1f521',
    'c': 'symbols',
    'o': 134,
    'sn': ':abcd:'
  },
  ':1234:': {
    'tn': '1234',
    'uc': '1f522',
    'c': 'symbols',
    'o': 153,
    'sn': ':1234:'
  },
  ':v:': {
    'tn': 'victory',
    'uc': '270c',
    'c': 'people',
    'o': 1281,
    'sn': ':v:'
  },
  ':man_technologist:': {
    'tn': 'Mann_Laptop',
    'uc': '1f468-1f4bb',
    'c': 'people',
    'o': 1757,
    'sn': ':man_technologist:'
  },
  ':ophiuchus:': {
    'tn': 'Schlangenträger_Zeichen',
    'uc': '26ce',
    'c': 'symbols',
    'o': 29,
    'sn': ':ophiuchus:'
  },
  ':family_wwgb:': {
    'tn': 'Familie_FFFM',
    'uc': '1f469-1f469-1f467-1f466',
    'c': 'people',
    'o': 2349,
    'sn': ':family_wwgb:'
  },
  ':woman_in_lotus_position:': {
    'tn': 'Frau_Lotusposition',
    'uc': '1f9d8-2640',
    'c': 'activity',
    'o': 432,
    'sn': ':woman_in_lotus_position:'
  },
  ':fast_forward:': {
    'tn': 'Spulen_vor',
    'uc': '23e9',
    'c': 'symbols',
    'o': 164,
    'sn': ':fast_forward:'
  },
  ':brain:': {
    'tn': 'Gehirn',
    'uc': '1f9e0',
    'c': 'people',
    'o': 1427,
    'sn': ':brain:'
  },
  ':woman_lifting_weights:': {
    'tn': 'Gewichtheberin',
    'uc': '1f3cb-2640',
    'c': 'activity',
    'o': 332,
    'sn': ':woman_lifting_weights:'
  },
  ':fortune_cookie:': {
    'tn': 'Glückskeks',
    'uc': '1f960',
    'c': 'food',
    'o': 1060,
    'sn': ':fortune_cookie:'
  },
  ':flag_tw:': {
    'tn': 'Fl_Taiwan',
    'uc': '1f1f9-1f1fc',
    'c': 'flags',
    'o': 2778,
    'sn': ':flag_tw:'
  },
  ':luggage:': {
    'tn': 'Gepäck',
    'uc': '1f9f3',
    'c': 'travel',
    'o': 2473,
    'sn': ':luggage:'
  },
  ':clipboard:': {
    'tn': 'Klemmbrett',
    'uc': '1f4cb',
    'c': 'objects',
    'o': 785,
    'sn': ':clipboard:'
  },
  ':flag_sv:': {
    'tn': 'Fl_ElSalvador',
    'uc': '1f1f8-1f1fb',
    'c': 'flags',
    'o': 2628,
    'sn': ':flag_sv:'
  },
  ':flag_ru:': {
    'tn': 'Fl_Russland',
    'uc': '1f1f7-1f1fa',
    'c': 'flags',
    'o': 2744,
    'sn': ':flag_ru:'
  },
  ':doughnut:': {
    'tn': 'Doughnut',
    'uc': '1f369',
    'c': 'food',
    'o': 1077,
    'sn': ':doughnut:'
  },
  ':registered:': {
    'tn': 'Eingetragen',
    'uc': '00ae',
    'c': 'symbols',
    'o': 200,
    'sn': ':registered:'
  },
  ':flag_ps:': {
    'tn': 'Fl_Palästina',
    'uc': '1f1f5-1f1f8',
    'c': 'flags',
    'o': 2731,
    'sn': ':flag_ps:'
  },
  ':family_mmgb:': {
    'tn': 'Familie_MMFM',
    'uc': '1f468-1f468-1f467-1f466',
    'c': 'people',
    'o': 2354,
    'sn': ':family_mmgb:'
  },
  ':shirt:': {
    'tn': 'Shirt',
    'uc': '1f455',
    'c': 'people',
    'o': 2369,
    'sn': ':shirt:'
  },
  ':raised_hand:': {
    'tn': 'Hand_erhoben',
    'uc': '270b',
    'c': 'people',
    'o': 1335,
    'sn': ':raised_hand:'
  },
  ':bomb:': {
    'tn': 'Bombe',
    'uc': '1f4a3',
    'c': 'objects',
    'o': 687,
    'sn': ':bomb:'
  },
  ':flag_mp:': {
    'tn': 'Fl_NMarianen',
    'uc': '1f1f2-1f1f5',
    'c': 'flags',
    'o': 2726,
    'sn': ':flag_mp:'
  },
  ':moon_cake:': {
    'tn': 'Mondkuchen',
    'uc': '1f96e',
    'c': 'food',
    'o': 1069,
    'sn': ':moon_cake:'
  },
  ':loud_sound:': {
    'tn': 'Ton_laut',
    'uc': '1f50a',
    'c': 'symbols',
    'o': 235,
    'sn': ':loud_sound:'
  },
  ':flag_kn:': {
    'tn': 'Fl_StKitts',
    'uc': '1f1f0-1f1f3',
    'c': 'flags',
    'o': 2768,
    'sn': ':flag_kn:'
  },
  ':flag_jm:': {
    'tn': 'Fl_Jamaica',
    'uc': '1f1ef-1f1f2',
    'c': 'flags',
    'o': 2671,
    'sn': ':flag_jm:'
  },
  ':repeat_one:': {
    'tn': 'Wiederholen 1 Mal',
    'uc': '1f502',
    'c': 'symbols',
    'o': 187,
    'sn': ':repeat_one:'
  },
  ':panda_face:': {
    'tn': 'Panda',
    'uc': '1f43c',
    'c': 'nature',
    'o': 829,
    'sn': ':panda_face:'
  },
  ':man_swimming:': {
    'tn': 'Schwimmer',
    'uc': '1f3ca-2642',
    'c': 'activity',
    'o': 474,
    'sn': ':man_swimming:'
  },
  ':cat:': {
    'tn': 'Katze',
    'uc': '1f431',
    'c': 'nature',
    'o': 822,
    'sn': ':cat:'
  },
  ':confetti_ball:': {
    'tn': 'Konfettiball',
    'uc': '1f38a',
    'c': 'objects',
    'o': 748,
    'sn': ':confetti_ball:'
  },
  ':flag_il:': {
    'tn': 'Fl_Isreal',
    'uc': '1f1ee-1f1f1',
    'c': 'flags',
    'o': 2669,
    'sn': ':flag_il:'
  },
  ':synagogue:': {
    'tn': 'Synagoge',
    'uc': '1f54d',
    'c': 'travel',
    'o': 2532,
    'sn': ':synagogue:'
  },
  ':sleepy:': {
    'tn': 'schläfrig',
    'uc': '1f62a',
    'c': 'people',
    'o': 1180,
    'sn': ':sleepy:'
  },
  ':yin_yang:': {
    'tn': 'Ying_Yang',
    'uc': '262f',
    'c': 'symbols',
    'o': 26,
    'sn': ':yin_yang:'
  },
  ':clock330:': {
    'tn': '03:30 Uhr',
    'uc': '1f55e',
    'c': 'symbols',
    'o': 266,
    'sn': ':clock330:'
  },
  ':flag_hk:': {
    'tn': 'Fl_Hongkong',
    'uc': '1f1ed-1f1f0',
    'c': 'flags',
    'o': 2660,
    'sn': ':flag_hk:'
  },
  ':flag_fi:': {
    'tn': 'Fl_Finnland',
    'uc': '1f1eb-1f1ee',
    'c': 'flags',
    'o': 2637,
    'sn': ':flag_fi:'
  },
  ':waning_gibbous_moon:': {
    'tn': 'Mond_abnehmend_dreiviertel',
    'uc': '1f316',
    'c': 'nature',
    'o': 956,
    'sn': ':waning_gibbous_moon:'
  },
  ':ear:': {
    'tn': 'Ohr',
    'uc': '1f442',
    'c': 'people',
    'o': 1412,
    'sn': ':ear:'
  },
  ':flag_eh:': {
    'tn': 'Fl_WestSahara',
    'uc': '1f1ea-1f1ed',
    'c': 'flags',
    'o': 2808,
    'sn': ':flag_eh:'
  },
  ':camel:': {
    'tn': 'Kamel',
    'uc': '1f42b',
    'c': 'nature',
    'o': 900,
    'sn': ':camel:'
  },
  ':flag_dg:': {
    'tn': 'Fl_DiegoG',
    'uc': '1f1e9-1f1ec',
    'c': 'flags',
    'o': 2816,
    'sn': ':flag_dg:'
  },
  ':rosette:': {
    'tn': 'Rosette',
    'uc': '1f3f5',
    'c': 'activity',
    'o': 576,
    'sn': ':rosette:'
  },
  ':woman_raising_hand:': {
    'tn': 'Frau_aufzeigen',
    'uc': '1f64b-2640',
    'c': 'people',
    'o': 2123,
    'sn': ':woman_raising_hand:'
  },
  ':flag_cf:': {
    'tn': 'Fl_ZAR',
    'uc': '1f1e8-1f1eb',
    'c': 'flags',
    'o': 2604,
    'sn': ':flag_cf:'
  },
  ':flag_be:': {
    'tn': 'Fl_Belgien',
    'uc': '1f1e7-1f1ea',
    'c': 'flags',
    'o': 2582,
    'sn': ':flag_be:'
  },
  ':family_mwg:': {
    'tn': 'Familie_FMF',
    'uc': '1f468-1f469-1f467',
    'c': 'people',
    'o': 2343,
    'sn': ':family_mwg:'
  },
  ':flag_ad:': {
    'tn': 'Fl_Andorra',
    'uc': '1f1e6-1f1e9',
    'c': 'flags',
    'o': 2566,
    'sn': ':flag_ad:'
  },
  ':tv:': {
    'tn': 'Fernseher',
    'uc': '1f4fa',
    'c': 'objects',
    'o': 644,
    'sn': ':tv:'
  },
  ':rainbow:': {
    'tn': 'Regenbogen',
    'uc': '1f308',
    'c': 'nature',
    'o': 976,
    'sn': ':rainbow:'
  },
  ':woman_facepalming:': {
    'tn': 'Frau_Hand_Gesicht',
    'uc': '1f926-2640',
    'c': 'people',
    'o': 2141,
    'sn': ':woman_facepalming:'
  },
  ':credit_card:': {
    'tn': 'Kreditkarte',
    'uc': '1f4b3',
    'c': 'objects',
    'o': 672,
    'sn': ':credit_card:'
  },
  ':cupcake:': {
    'tn': 'kleiner Kuchen',
    'uc': '1f9c1',
    'c': 'food',
    'o': 1070,
    'sn': ':cupcake:'
  },
  ':unamused:': {
    'tn': 'unfroh',
    'uc': '1f612',
    'c': 'people',
    'o': 1136,
    'sn': ':unamused:'
  },
  ':chart_with_upwards_trend:': {
    'tn': 'Graph_pos',
    'uc': '1f4c8',
    'c': 'objects',
    'o': 775,
    'sn': ':chart_with_upwards_trend:'
  },
  ':man_student:': {
    'tn': 'Stundet',
    'uc': '1f468-1f393',
    'c': 'people',
    'o': 1709,
    'sn': ':man_student:'
  },
  ':cut_of_meat:': {
    'tn': 'Fleisch_roh',
    'uc': '1f969',
    'c': 'food',
    'o': 1035,
    'sn': ':cut_of_meat:'
  },
  ':wilted_rose:': {
    'tn': 'Rose_verwelkt',
    'uc': '1f940',
    'c': 'nature',
    'o': 945,
    'sn': ':wilted_rose:'
  },
  ':pick:': {
    'tn': 'Spitzhacke',
    'uc': '26cf',
    'c': 'objects',
    'o': 682,
    'sn': ':pick:'
  },
  ':bowl_with_spoon:': {
    'tn': 'Schale_Löffel',
    'uc': '1f963',
    'c': 'food',
    'o': 1100,
    'sn': ':bowl_with_spoon:'
  },
  ':confused:': {
    'tn': 'verwirrt',
    'uc': '1f615',
    'c': 'people',
    'o': 1140,
    'sn': ':confused:'
  },
  ':woman_getting_face_massage:': {
    'tn': 'Frau_Massage',
    'uc': '1f486-2640',
    'c': 'people',
    'o': 2231,
    'sn': ':woman_getting_face_massage:'
  },
  ':bike:': {
    'tn': 'Fahrrad',
    'uc': '1f6b2',
    'c': 'travel',
    'o': 2445,
    'sn': ':bike:'
  },
  ':izakaya_lantern:': {
    'tn': 'Izakaya_Laterne',
    'uc': '1f3ee',
    'c': 'objects',
    'o': 751,
    'sn': ':izakaya_lantern:'
  },
  ':superhero:': {
    'tn': 'Superheld',
    'uc': '1f9b8',
    'c': 'people',
    'o': 1895,
    'sn': ':superhero:'
  },
  ':musical_note:': {
    'tn': 'Note',
    'uc': '1f3b5',
    'c': 'symbols',
    'o': 190,
    'sn': ':musical_note:'
  },
  ':top:': {
    'tn': 'Auf',
    'uc': '1f51d',
    'c': 'symbols',
    'o': 207,
    'sn': ':top:'
  },
  ':exploding_head:': {
    'tn': 'unglaublich',
    'uc': '1f92f',
    'c': 'people',
    'o': 1153,
    'sn': ':exploding_head:'
  },
  ':flag_tv:': {
    'tn': 'Fl_Tuvalu',
    'uc': '1f1f9-1f1fb',
    'c': 'flags',
    'o': 2792,
    'sn': ':flag_tv:'
  },
  ':family_woman_boy_boy:': {
    'tn': 'Single_Frau_MM',
    'uc': '1f469-1f466-1f466',
    'c': 'people',
    'o': 2360,
    'sn': ':family_woman_boy_boy:'
  },
  ':abacus:': {
    'tn': 'Abakus',
    'uc': '1f9ee',
    'c': 'objects',
    'o': 703,
    'sn': ':abacus:'
  },
  ':woman_mechanic:': {
    'tn': 'Mechanikerin',
    'uc': '1f469-1f527',
    'c': 'people',
    'o': 1775,
    'sn': ':woman_mechanic:'
  },
  ':ideograph_advantage:': {
    'tn': 'Schnäppchen',
    'uc': '1f250',
    'c': 'symbols',
    'o': 58,
    'sn': ':ideograph_advantage:'
  },
  ':cloud:': {
    'tn': 'Wolke',
    'uc': '2601',
    'c': 'nature',
    'o': 981,
    'sn': ':cloud:'
  },
  ':flag_pr:': {
    'tn': 'Fl_PuertoRico',
    'uc': '1f1f5-1f1f7',
    'c': 'flags',
    'o': 2740,
    'sn': ':flag_pr:'
  },
  ':cd:': {
    'tn': 'CD',
    'uc': '1f4bf',
    'c': 'objects',
    'o': 631,
    'sn': ':cd:'
  },
  ':flag_np:': {
    'tn': 'Fl_Nepal',
    'uc': '1f1f3-1f1f5',
    'c': 'flags',
    'o': 2716,
    'sn': ':flag_np:'
  },
  ':kimono:': {
    'tn': 'Kimono',
    'uc': '1f458',
    'c': 'people',
    'o': 2374,
    'sn': ':kimono:'
  },
  ':mountain_snow:': {
    'tn': 'Berg_Schnee',
    'uc': '1f3d4',
    'c': 'travel',
    'o': 2508,
    'sn': ':mountain_snow:'
  },
  ':fairy:': {
    'tn': 'Fee',
    'uc': '1f9da',
    'c': 'people',
    'o': 2009,
    'sn': ':fairy:'
  },
  ':ab:': {
    'tn': 'Taste AB',
    'uc': '1f18e',
    'c': 'symbols',
    'o': 67,
    'sn': ':ab:'
  },
  ':flag_mo:': {
    'tn': 'Fl_Macau',
    'uc': '1f1f2-1f1f4',
    'c': 'flags',
    'o': 2691,
    'sn': ':flag_mo:'
  },
  ':man_singer:': {
    'tn': 'Sänger',
    'uc': '1f468-1f3a4',
    'c': 'people',
    'o': 1721,
    'sn': ':man_singer:'
  },
  ':sauropod:': {
    'tn': 'Sauropod',
    'uc': '1f995',
    'c': 'nature',
    'o': 878,
    'sn': ':sauropod:'
  },
  ':bat:': {
    'tn': 'Fledermaus',
    'uc': '1f987',
    'c': 'nature',
    'o': 856,
    'sn': ':bat:'
  },
  ':flag_km:': {
    'tn': 'Fl_Comoros',
    'uc': '1f1f0-1f1f2',
    'c': 'flags',
    'o': 2611,
    'sn': ':flag_km:'
  },
  ':sunrise:': {
    'tn': 'Sonnenaufgang',
    'uc': '1f305',
    'c': 'travel',
    'o': 2540,
    'sn': ':sunrise:'
  },
  ':clock230:': {
    'tn': '02:30 Uhr',
    'uc': '1f55d',
    'c': 'symbols',
    'o': 265,
    'sn': ':clock230:'
  },
  ':hear_no_evil:': {
    'tn': 'höre_nichts_',
    'uc': '1f649',
    'c': 'nature',
    'o': 841,
    'sn': ':hear_no_evil:'
  },
  ':coconut:': {
    'tn': 'Kokosnuss',
    'uc': '1f965',
    'c': 'food',
    'o': 1012,
    'sn': ':coconut:'
  },
  ':cowboy:': {
    'tn': 'Cowboy',
    'uc': '1f920',
    'c': 'people',
    'o': 1191,
    'sn': ':cowboy:'
  },
  ':triangular_flag_on_post:': {
    'tn': 'Fl_dreieck',
    'uc': '1f6a9',
    'c': 'flags',
    'o': 2558,
    'sn': ':triangular_flag_on_post:'
  },
  ':flag_gi:': {
    'tn': 'Fl_Gibraltar',
    'uc': '1f1ec-1f1ee',
    'c': 'flags',
    'o': 2647,
    'sn': ':flag_gi:'
  },
  ':construction_site:': {
    'tn': 'Kran',
    'uc': '1f3d7',
    'c': 'travel',
    'o': 2516,
    'sn': ':construction_site:'
  },
  ':hushed:': {
    'tn': 'beschwichtigen',
    'uc': '1f62f',
    'c': 'people',
    'o': 1173,
    'sn': ':hushed:'
  },
  ':congratulations:': {
    'tn': 'Glückwunsch',
    'uc': '3297',
    'c': 'symbols',
    'o': 60,
    'sn': ':congratulations:'
  },
  ':flag_eg:': {
    'tn': 'Fl_Ägypten',
    'uc': '1f1ea-1f1ec',
    'c': 'flags',
    'o': 2627,
    'sn': ':flag_eg:'
  },
  ':jigsaw:': {
    'tn': 'Puzzle',
    'uc': '1f9e9',
    'c': 'objects',
    'o': 627,
    'sn': ':jigsaw:'
  },
  ':black_large_square:': {
    'tn': 'Quader_groß_schwarz',
    'uc': '2b1b',
    'c': 'symbols',
    'o': 230,
    'sn': ':black_large_square:'
  },
  ':hugging:': {
    'tn': 'Umarmen',
    'uc': '1f917',
    'c': 'people',
    'o': 1163,
    'sn': ':hugging:'
  },
  ':flag_bd:': {
    'tn': 'Fl_Bangladesch',
    'uc': '1f1e7-1f1e9',
    'c': 'flags',
    'o': 2579,
    'sn': ':flag_bd:'
  },
  ':twisted_rightwards_arrows:': {
    'tn': 'Pfeil_überkreuzt',
    'uc': '1f500',
    'c': 'symbols',
    'o': 185,
    'sn': ':twisted_rightwards_arrows:'
  },
  ':oncoming_bus:': {
    'tn': 'Bus von vorn',
    'uc': '1f68d',
    'c': 'travel',
    'o': 2450,
    'sn': ':oncoming_bus:'
  },
  ':detective:': {
    'tn': 'Detektiv',
    'uc': '1f575',
    'c': 'people',
    'o': 1649,
    'sn': ':detective:'
  },
  ':flag_ac:': {
    'tn': 'Fl_Ascension',
    'uc': '1f1e6-1f1e8',
    'c': 'flags',
    'o': 2812,
    'sn': ':flag_ac:'
  },
  ':chicken:': {
    'tn': 'Huhn',
    'uc': '1f414',
    'c': 'nature',
    'o': 844,
    'sn': ':chicken:'
  },
  ':motorboat:': {
    'tn': 'Motorboot',
    'uc': '1f6e5',
    'c': 'travel',
    'o': 2481,
    'sn': ':motorboat:'
  },
  ':llama:': {
    'tn': 'Lama',
    'uc': '1f999',
    'c': 'nature',
    'o': 902,
    'sn': ':llama:'
  },
  ':laughing:': {
    'tn': 'lachend',
    'uc': '1f606',
    'c': 'people',
    'o': 1107,
    'sn': ':laughing:'
  },
  ':house_abandoned:': {
    'tn': 'Haus_verlassen',
    'uc': '1f3da',
    'c': 'travel',
    'o': 2515,
    'sn': ':house_abandoned:'
  },
  ':mobile_phone_off:': {
    'tn': 'Mobilgerät_aus',
    'uc': '1f4f4',
    'c': 'symbols',
    'o': 48,
    'sn': ':mobile_phone_off:'
  },
  ':blue_heart:': {
    'tn': 'Herz_blau',
    'uc': '1f499',
    'c': 'symbols',
    'o': 5,
    'sn': ':blue_heart:'
  },
  ':blue_circle:': {
    'tn': 'Kreis_blau',
    'uc': '1f535',
    'c': 'symbols',
    'o': 215,
    'sn': ':blue_circle:'
  },
  ':rice_cracker:': {
    'tn': 'Reiskeks',
    'uc': '1f358',
    'c': 'food',
    'o': 1058,
    'sn': ':rice_cracker:'
  },
  ':face_with_hand_over_mouth:': {
    'tn': 'oops',
    'uc': '1f92d',
    'c': 'people',
    'o': 1165,
    'sn': ':face_with_hand_over_mouth:'
  }
};
var tmpShortNames = [],
    emoji;

for (emoji in emojione.emojioneList) {
  if (!emojione.emojioneList.hasOwnProperty(emoji) || emoji === '') continue;
  tmpShortNames.push(emoji.replace(/[+]/g, '\\$&'));
}

emojione.shortnames = tmpShortNames.join('|'); // noinspection NonAsciiCharacters

emojione.asciiList = {
  '*\\0/*': '1f646',
  '*\\O/*': '1f646',
  '-___-': '1f611',
  ':\'-)': '1f602',
  '\':-)': '1f605',
  '\':-D': '1f605',
  '>:-)': '1f606',
  '\':-(': '1f613',
  '>:-(': '1f620',
  ':\'-(': '1f622',
  'O:-)': '1f607',
  '0:-3': '1f607',
  '0:-)': '1f607',
  '0;^)': '1f607',
  'O;-)': '1f607',
  '0;-)': '1f607',
  'O:-3': '1f607',
  '-__-': '1f611',
  ':-Þ': '1f61b',
  '</3': '1f494',
  ':\')': '1f602',
  ':-D': '1f603',
  '\':)': '1f605',
  '\'=)': '1f605',
  '\':D': '1f605',
  '\'=D': '1f605',
  '>:)': '1f606',
  '>;)': '1f606',
  '>=)': '1f606',
  ';-)': '1f609',
  '*-)': '1f609',
  ';-]': '1f609',
  ';^)': '1f609',
  '\':(': '1f613',
  '\'=(': '1f613',
  ':-*': '1f618',
  ':^*': '1f618',
  '>:P': '1f61c',
  'X-P': '1f61c',
  '>:[': '1f61e',
  ':-(': '1f61e',
  ':-[': '1f61e',
  '>:(': '1f620',
  ':\'(': '1f622',
  ';-(': '1f622',
  '>.<': '1f623',
  '#-)': '1f635',
  '%-)': '1f635',
  'X-)': '1f635',
  '\\0/': '1f646',
  '\\O/': '1f646',
  '0:3': '1f607',
  '0:)': '1f607',
  'O:)': '1f607',
  'O=)': '1f607',
  'O:3': '1f607',
  'B-)': '1f60e',
  '8-)': '1f60e',
  'B-D': '1f60e',
  '8-D': '1f60e',
  '-_-': '1f611',
  '>:\\': '1f615',
  '>:/': '1f615',
  ':-/': '1f615',
  ':-.': '1f615',
  ':-P': '1f61b',
  ':Þ': '1f61b',
  ':-b': '1f61b',
  ':-O': '1f62e',
  'O_O': '1f62e',
  '>:O': '1f62e',
  ':-X': '1f636',
  ':-#': '1f636',
  ':-)': '1f642',
  '(y)': '1f44d',
  '<3': '2764',
  ':D': '1f603',
  '=D': '1f603',
  ';)': '1f609',
  '*)': '1f609',
  ';]': '1f609',
  ';D': '1f609',
  ':*': '1f618',
  '=*': '1f618',
  ':(': '1f61e',
  ':[': '1f61e',
  '=(': '1f61e',
  ':@': '1f620',
  ';(': '1f622',
  'D:': '1f628',
  ':$': '1f633',
  '=$': '1f633',
  '#)': '1f635',
  '%)': '1f635',
  'X)': '1f635',
  'B)': '1f60e',
  '8)': '1f60e',
  ':/': '1f615',
  ':\\': '1f615',
  '=/': '1f615',
  '=\\': '1f615',
  ':L': '1f615',
  '=L': '1f615',
  ':P': '1f61b',
  '=P': '1f61b',
  ':b': '1f61b',
  ':O': '1f62e',
  ':X': '1f636',
  ':#': '1f636',
  '=X': '1f636',
  '=#': '1f636',
  ':)': '1f642',
  '=]': '1f642',
  '=)': '1f642',
  ':]': '1f642'
};
emojione.asciiRegexp = '(\\*\\\\0\\/\\*|\\*\\\\O\\/\\*|\\-___\\-|\\:\'\\-\\)|\'\\:\\-\\)|\'\\:\\-D|\\>\\:\\-\\)|>\\:\\-\\)|\'\\:\\-\\(|\\>\\:\\-\\(|>\\:\\-\\(|\\:\'\\-\\(|O\\:\\-\\)|0\\:\\-3|0\\:\\-\\)|0;\\^\\)|O;\\-\\)|0;\\-\\)|O\\:\\-3|\\-__\\-|\\:\\-Þ|\\:\\-Þ|\\<\\/3|<\\/3|\\:\'\\)|\\:\\-D|\'\\:\\)|\'\\=\\)|\'\\:D|\'\\=D|\\>\\:\\)|>\\:\\)|\\>;\\)|>;\\)|\\>\\=\\)|>\\=\\)|;\\-\\)|\\*\\-\\)|;\\-\\]|;\\^\\)|\'\\:\\(|\'\\=\\(|\\:\\-\\*|\\:\\^\\*|\\>\\:P|>\\:P|X\\-P|\\>\\:\\[|>\\:\\[|\\:\\-\\(|\\:\\-\\[|\\>\\:\\(|>\\:\\(|\\:\'\\(|;\\-\\(|\\>\\.\\<|>\\.<|#\\-\\)|%\\-\\)|X\\-\\)|\\\\0\\/|\\\\O\\/|0\\:3|0\\:\\)|O\\:\\)|O\\=\\)|O\\:3|B\\-\\)|8\\-\\)|B\\-D|8\\-D|\\-_\\-|\\>\\:\\\\|>\\:\\\\|\\>\\:\\/|>\\:\\/|\\:\\-\\/|\\:\\-\\.|\\:\\-P|\\:Þ|\\:Þ|\\:\\-b|\\:\\-O|O_O|\\>\\:O|>\\:O|\\:\\-X|\\:\\-#|\\:\\-\\)|\\(y\\)|\\<3|<3|\\:D|\\=D|;\\)|\\*\\)|;\\]|;D|\\:\\*|\\=\\*|\\:\\(|\\:\\[|\\=\\(|\\:@|;\\(|D\\:|\\:\\$|\\=\\$|#\\)|%\\)|X\\)|B\\)|8\\)|\\:\\/|\\:\\\\|\\=\\/|\\=\\\\|\\:L|\\=L|\\:P|\\=P|\\:b|\\:O|\\:X|\\:#|\\=X|\\=#|\\:\\)|\\=\\]|\\=\\)|\\:\\])';
emojione.emojiVersion = '4.0'; // you can [optionally] modify this to load alternate emoji versions. see readme for backwards compatibility and version options

emojione.emojiSize = '32';
emojione.greedyMatch = false; // set to true for greedy unicode matching

emojione.blacklistChars = '';
emojione.imagePathPNG = 'https://cdn.jsdelivr.net/emojione/assets/' + emojione.emojiVersion + '/png/';
emojione.defaultPathPNG = emojione.imagePathPNG;
emojione.fileExtension = '.png';
emojione.imageTitleTag = true; // set to false to remove title attribute from img tag

emojione.sprites = false; // if this is true then sprite markup will be used

emojione.spriteSize = 32; // change to '64' to get bigger sprite size

emojione.unicodeAlt = true; // use the unicode char as the alt attribute (makes copy and pasting the resulting text better)

emojione.ascii = false; // change to true to convert ascii smileys

emojione.riskyMatchAscii = false; // set true to match ascii without leading/trailing space char

emojione.regShortNames = new RegExp('<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(' + emojione.shortnames + ')', 'gi');
emojione.regAscii = new RegExp('<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|((\\s|^)' + emojione.asciiRegexp + '(?=\\s|$|[!,.?]))', 'gi');
emojione.regAsciiRisky = new RegExp('<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(()' + emojione.asciiRegexp + '())', 'gi');

emojione.toImage = function (str) {
  str = emojione.toShort(str);
  str = emojione.shortnameToImage(str);
  return str;
}; // will output unicode from shortname
// useful for sending emojis back to mobile devices


emojione.shortnameToUnicode = function (str) {
  // replace regular shortnames first
  var unicode, fname;
  str = str.replace(emojione.regShortNames, function (shortname) {
    if (typeof shortname === 'undefined' || shortname === '' || !(shortname in emojione.emojioneList)) {
      // if the shortname doesnt exist just return the entire matchhju
      return shortname;
    }

    unicode = emojione.emojioneList[shortname].uc.toUpperCase();
    fname = emojione.emojioneList[shortname].uc;
    return emojione.convert(unicode);
  }); // if ascii smileys are turned on, then we'll replace them!

  if (emojione.ascii) {
    var asciiRX = emojione.riskyMatchAscii ? emojione.regAsciiRisky : emojione.regAscii;
    str = str.replace(asciiRX, function (entire, m1, m2, m3) {
      if (typeof m3 === 'undefined' || m3 === '' || !(emojione.unescapeHTML(m3) in emojione.asciiList)) {
        // if the ascii doesnt exist just return the entire match
        return entire;
      }

      m3 = emojione.unescapeHTML(m3);
      unicode = emojione.asciiList[m3].toUpperCase();
      return m2 + emojione.convert(unicode);
    });
  }

  return str;
};

emojione.shortnameToImage = function (str) {
  // replace regular shortnames first
  var replaceWith, shortname, unicode, fname, alt, category, title, size, ePath;
  var mappedUnicode = emojione.mapUnicodeToShort();
  str = str.replace(emojione.regShortNames, function (shortname) {
    if (typeof shortname === 'undefined' || shortname === '' || emojione.shortnames.indexOf(shortname) === -1) {
      // if the shortname doesnt exist just return the entire match
      return shortname;
    } else {
      // map shortname to parent
      if (!emojione.emojioneList[shortname]) {
        for (var _emoji in emojione.emojioneList) {
          if (!emojione.emojioneList.hasOwnProperty(_emoji) || _emoji === '') continue;
          if (emojione.emojioneList[_emoji] !== shortname) continue;
          shortname = _emoji;
          break;
        }
      }

      unicode = emojione.emojioneList[shortname].uc;
      fname = emojione.emojioneList[shortname].uc;
      category = fname.indexOf('-1f3f') >= 0 ? 'diversity' : emojione.emojioneList[shortname].c;
      title = emojione.imageTitleTag ? ' title="' + shortname + '"' : '';
      size = emojione.spriteSize === '32' || emojione.spriteSize === '64' ? emojione.spriteSize : '32';
      ePath = emojione.defaultPathPNG !== emojione.imagePathPNG ? emojione.imagePathPNG : emojione.defaultPathPNG + emojione.emojiSize + '/';
      alt = emojione.unicodeAlt ? emojione.convert(unicode.toUpperCase()) : shortname;

      if (emojione.sprites) {
        replaceWith = '<span class="emojione emojione-' + size + '-' + category + ' _' + fname + '"' + title + '>' + alt + '</span>';
      } else {
        replaceWith = '<img class="emojione" alt="' + alt + '"' + title + ' src="' + ePath + fname + emojione.fileExtension + '"/>';
      }

      return replaceWith;
    }
  });

  if (emojione.ascii) {
    var asciiRX = emojione.riskyMatchAscii ? emojione.regAsciiRisky : emojione.regAscii;
    str = str.replace(asciiRX, function (entire, m1, m2, m3) {
      if (typeof m3 === 'undefined' || m3 === '' || !(emojione.unescapeHTML(m3) in emojione.asciiList)) {
        // if the ascii doesnt exist just return the entire match
        return entire;
      }

      m3 = emojione.unescapeHTML(m3);
      unicode = emojione.asciiList[m3];
      shortname = mappedUnicode[unicode];
      category = unicode.indexOf('-1f3f') >= 0 ? 'diversity' : emojione.emojioneList[shortname].c;
      title = emojione.imageTitleTag ? ' title="' + emojione.escapeHTML(m3) + '"' : '';
      size = emojione.spriteSize === '32' || emojione.spriteSize === '64' ? emojione.spriteSize : '32'; //if the emoji path has been set, we'll use the provided path, otherwise we'll use the default path

      ePath = emojione.defaultPathPNG !== emojione.imagePathPNG ? emojione.imagePathPNG : emojione.defaultPathPNG + emojione.emojiSize + '/'; // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname

      alt = emojione.unicodeAlt ? emojione.convert(unicode.toUpperCase()) : emojione.escapeHTML(m3);

      if (emojione.sprites) {
        replaceWith = m2 + '<span class="emojione emojione-' + size + '-' + category + ' _' + unicode + '"  ' + title + '>' + alt + '</span>';
      } else {
        replaceWith = m2 + '<img class="emojione" alt="' + alt + '"' + title + ' src="' + ePath + unicode + emojione.fileExtension + '"/>';
      }

      return replaceWith;
    });
  }

  return str;
}; // this is really just unicodeToShortname() but I opted for the shorthand name to match toImage()


emojione.toShort = function (string) {
  var find = emojione.unicodeCharRegex();
  var search = new RegExp('<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(' + find + ')', 'gi');
  var iosFixRegex = new RegExp(String.fromCharCode(65039), 'g');

  var replace = function replace(entire, m1) {
    return typeof m1 === 'undefined' || m1 === '' ? entire : emojione.shortnameConversionMap()[m1];
  };

  return string.replace(search, replace).replace(iosFixRegex, '');
}; // for converting unicode code points and code pairs to their respective characters


emojione.convert = function (unicode) {
  if (unicode.indexOf('-') > -1) {
    var parts = [];
    var s = unicode.split('-');

    for (var i = 0; i < s.length; i++) {
      var part = parseInt(s[i], 16);

      if (part >= 0x10000 && part <= 0x10FFFF) {
        var hi = Math.floor((part - 0x10000) / 0x400) + 0xD800;
        var lo = (part - 0x10000) % 0x400 + 0xDC00;
        part = String.fromCharCode(hi) + String.fromCharCode(lo);
      } else {
        part = String.fromCharCode(part);
      }

      parts.push(part);
    }

    return parts.join('');
  } else {
    var _s = parseInt(unicode, 16);

    if (_s >= 0x10000 && _s <= 0x10FFFF) {
      var _hi = Math.floor((_s - 0x10000) / 0x400) + 0xD800;

      var _lo = (_s - 0x10000) % 0x400 + 0xDC00;

      return String.fromCharCode(_hi) + String.fromCharCode(_lo);
    } else {
      return String.fromCharCode(_s);
    }
  }
};

emojione.escapeHTML = function (string) {
  var escaped = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
  };
  return string.replace(/[&<>"']/g, function (match) {
    return escaped[match];
  });
};

emojione.unescapeHTML = function (string) {
  var unescaped = {
    '&amp;': '&',
    '&#38;': '&',
    '&#x26;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&#x3C;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&#x3E;': '>',
    '&quot;': '"',
    '&#34;': '"',
    '&#x22;': '"',
    '&apos;': '\'',
    '&#39;': '\'',
    '&#x27;': '\''
  };
  return string.replace(/&(?:amp|#38|#x26|lt|#60|#x3C|gt|#62|#x3E|apos|#39|#x27|quot|#34|#x22);/ig, function (match) {
    return unescaped[match];
  });
};

emojione.shortnameConversionMap = function () {
  var map = [],
      emoji;

  for (emoji in emojione.emojioneList) {
    if (!emojione.emojioneList.hasOwnProperty(emoji) || emoji === '') continue;
    map[emojione.convert(emojione.emojioneList[emoji].uc)] = emoji;
  }

  return map;
};

emojione.unicodeCharRegex = function () {
  if (!emojione.memUnicodeCharRegex) {
    var map = [];
    var bList = emojione.blacklistChars.split(',');

    for (emoji in emojione.emojioneList) {
      if (!emojione.emojioneList.hasOwnProperty(emoji) || emoji === '') continue;
      var unicode = emojione.emojioneList[emoji].uc;
      if (bList.indexOf(String.fromCodePoint(parseInt("0x".concat(unicode)))) !== -1) continue;
      map.push(emojione.convert(unicode));
    }

    emojione.memUnicodeCharRegex = map.join('|').replace(/[-[\]{}()*+?.,;:&\\^$#\s]/g, '\\$&');
  }

  return emojione.memUnicodeCharRegex;
};

emojione.mapEmojioneList = function (addToMapStorage) {
  for (var shortname in emojione.emojioneList) {
    if (!emojione.emojioneList.hasOwnProperty(shortname)) {
      continue;
    }

    var unicode = emojione.emojioneList[shortname].uc;
    addToMapStorage(unicode, shortname);
  }
};

emojione.mapUnicodeToShort = function () {
  if (!emojione.memMapShortToUnicode) {
    emojione.memMapShortToUnicode = {};
    emojione.mapEmojioneList(function (unicode, shortname) {
      emojione.memMapShortToUnicode[unicode] = shortname;
    });
  }

  return emojione.memMapShortToUnicode;
};

module.exports = emojione;